let locationCart = {};
let updateCartProducts;
let updateCartSummary;
let updateMenuButtons;
let emptyCartOnModalClose = true;
let getClassicCartModal;
let emptyAllCart;
let screenOrientation = window.screen.orientation.type.includes('landscape')
  ? 'LANDSCAPE'
  : 'PORTRAIT';
let alterPriceInclVatForCheck = 0;
let currentOrderAjax = null;
let organizerId;
let locationId;
let paymentSplittingAjaxLock = false;
let paymentSplitModalAjaxLock = false;
let getExtraModalAjaxLock = false;
let wastageMode = false;
let wastageRegistrationInProgress = false;

let hasBeenInactive = false;
let inactivityTimer = null;
let confirmTimer = null;

function setClassicLocationCart(data) {
  if (data.location_id !== undefined && data.location_id !== null) {
    locationCart.location_id = data.location_id;
    if (data.location_type !== undefined && data.location_type !== null) {
      locationCart.location_type = data.location_type;
    }
    if (data.table_number !== undefined && data.table_number !== null) {
      locationCart.table_number = data.table_number;
    }
    if (data.table_id !== undefined && data.table_id !== null) {
      locationCart.table_id = data.table_id;
    }
    if (
      data.isSessionLastPurchase !== undefined &&
      data.isSessionLastPurchase !== null
    ) {
      locationCart.isSessionLastPurchase = data.isSessionLastPurchase;
    }
    if (data.table_session_id !== undefined && data.table_session_id !== null) {
      locationCart.table_session_id = data.table_session_id;
    }
    if (data.table_guest_id !== undefined) {
      locationCart.table_guest_id = data.table_guest_id;
    }
    if (data.orderId !== undefined && data.orderId !== null) {
      locationCart.order_id = data.orderId;
    } else {
      delete locationCart.order_id;
    }
    if (
      data.is_per_person_ordering_enabled !== undefined &&
      data.is_per_person_ordering_enabled !== null
    ) {
      locationCart.is_per_person_ordering_enabled =
        data.is_per_person_ordering_enabled;
    }
    if (data.is_new_guest !== undefined && data.is_new_guest !== null) {
      locationCart.is_new_guest = data.is_new_guest;
    }
    if (
      data.number_of_products !== undefined &&
      data.number_of_products !== null
    ) {
      locationCart.number_of_products = data.number_of_products;
    }
    if (data.amount !== undefined && data.amount !== null) {
      locationCart.amount = data.amount;
    }
    if (data.tips_percent !== undefined && data.tips_percent !== null) {
      locationCart.tips_percent = data.tips_percent;
    }
    if (data.payment_method !== undefined && data.payment_method !== null) {
      locationCart.payment_method = data.payment_method;
    }
    if (Array.isArray(data.giftcards)) {
      locationCart.giftcards = data.giftcards;
    }
    if (data.comment !== undefined && data.comment !== null) {
      locationCart.comment = data.comment;
    }
    if (data.name !== undefined && data.name !== null) {
      locationCart.name = data.name;
    }
    if (data.phone_number !== undefined && data.phone_number !== null) {
      locationCart.phone_number = data.phone_number;
    }
    if (data.pickup_date !== undefined && data.pickup_date !== null) {
      locationCart.pickup_date = data.pickup_date;
    }
    if (data.pickup_time !== undefined && data.pickup_time !== null) {
      locationCart.pickup_time = data.pickup_time;
    }
    if (data.promo_code !== undefined && data.promo_code !== null) {
      locationCart.promo_code = data.promo_code;
    }
    if (
      data.pick_up_at_the_bar !== undefined &&
      data.pick_up_at_the_bar !== null
    ) {
      locationCart.pick_up_at_the_bar = data.pick_up_at_the_bar;
    }

    if (data.products !== undefined && data.products !== null) {
      locationCart.products = [];

      for (let i = 0; i < data.products.length; i++) {
        let productObj = data.products[i];
        let productExtras = [];
        if (
          productObj.product_extra !== undefined &&
          productObj.product_extra !== null
        ) {
          for (let j = 0; j < productObj.product_extra.length; j++) {
            let productExtraObj = productObj.product_extra[j];
            let productExtra = {
              product_extra_id: productExtraObj.product_extra_id,
              amount: productExtraObj.amount,
              discount_percent: productExtraObj.discount_percent,
            };

            if (productExtraObj.order_product_extra_id !== undefined) {
              productExtra.order_product_extra_id =
                productExtraObj.order_product_extra_id;
            }

            productExtras.push(productExtra);
          }
        }
        let product = {
          product_id: productObj.product_id,
          amount: productObj.amount,
          comment: productObj.comment,
          discount_percent: productObj.discount_percent,
          original_product_price: productObj.original_product_price,
        };
        if (productExtras.length) {
          product.product_extra = productExtras;
        }
        if (productObj.session_product_id) {
          product.session_product_id = productObj.session_product_id;
        }
        if (productObj.product_assignment_id) {
          product.product_assignment_id = productObj.product_assignment_id;
        }
        if (
          productObj.is_open_price !== undefined &&
          productObj.is_open_price !== null
        ) {
          product.is_open_price = productObj.is_open_price;
        }
        if (productObj.order_product_id) {
          product.order_product_id = productObj.order_product_id;
          product.reserved_quantity = productObj.amount;
        }

        if (productObj.has_split) {
          product.has_split = true;
        }
        if (
          productObj.is_open_price !== undefined &&
          productObj.is_open_price !== null
        ) {
          product.is_open_price = productObj.is_open_price;
        }
        locationCart.products.push(product);
      }
    }

    if (
      data.is_takeaway_checked !== undefined &&
      data.is_takeaway_checked !== null
    ) {
      locationCart.is_takeaway_checked = data.is_takeaway_checked;
    } else {
      locationCart.is_takeaway_checked = 0;
    }

    if (
      data.add_to_cart_from_table !== undefined &&
      data.add_to_cart_from_table !== null
    ) {
      locationCart.add_to_cart_from_table = data.add_to_cart_from_table;
    }

    if (
      data.booking_reference !== undefined &&
      data.booking_reference !== null
    ) {
      locationCart.booking_reference = data.booking_reference;
    }

    if (data.booking_id !== undefined && data.booking_id !== null) {
      locationCart.booking_id = data.booking_id;
    }

    if (
      data.order_storage_ids !== undefined &&
      data.order_storage_ids !== null
    ) {
      orderStorageIds = data.order_storage_ids;
    }
    updateCartSummary();
    updateMenuButtons();
    locationCart.order_storage_identifier = '';
    if (data.checkout_type !== undefined && data.checkout_type !== null) {
      locationCart.checkout_type = data.checkout_type;
    }

    if (
      data.amount_without_discount !== undefined &&
      data.amount_without_discount !== null
    ) {
      locationCart.amount_without_discount = data.amount_without_discount;
    }

    if (data.share_amount !== undefined && data.share_amount !== null) {
      locationCart.share_amount = data.share_amount;
    }

    if (data.exchange_amount !== undefined && data.exchange_amount !== null) {
      locationCart.exchange_amount = data.exchange_amount;
    }

    return getClassicCartModal();
  }
}

function closePanel() {
  $('.classic-mobile-cart').css('bottom', '-100%');
  setTimeout(() => {
    $('.classic-mobile-cart').css('display', 'none');
  }, 300);

  $('.drawer-backdrop,.classic-mobile-drawer-body').css({
    bottom: '-100%',
  });

  setTimeout(() => {
    $('.drawer-backdrop,.classic-mobile-drawer-body').css('display', 'none');
  }, 300);
}

$(document).ready(function () {
  let p = $('body').attr('p');
  let posType = $('#classic-location-products').data('pos-type');
  let shop_type = $('body').attr('shop_type') ?? null;
  let error_message = $('body').attr('error_message') ?? null;
  let isEnableDoubleClickQuickOrder = !!$('#product-list').attr(
    'data-enable-double-click-quick-order'
  );
  const hasEnabledDefaultOrderAsTakeaway = $('#classic-location-products').attr(
    'data-enabled-default-order-as-takeaway'
  );

  let hasDoubleClickedProduct = false;
  const isMobile = $('body').attr('is-mobile') === '1';

  function cartHasProducts() {
    return (
      Array.isArray(locationCart.products) &&
      locationCart.products.some(
        (product) => Number.parseFloat(product.amount) > 0
      )
    );
  }

  const WASTAGE_HIDDEN_ACTIONS_CLASS = 'wastage-hidden-actions';

  function applyWastageMode() {
    $('.checkout-actions-container').each(function () {
      const $container = $(this);
      const $normalActions = $container
        .children('.checkout-actions')
        .not('.wastage-checkout-actions');
      const $wastageActions = $container.children('.wastage-checkout-actions');

      if (wastageMode) {
        // Only the rows that were actually visible are marked, so leaving the
        // mode restores the exact layout instead of a hardcoded set of rows
        $normalActions
          .not('.d-none')
          .addClass('d-none ' + WASTAGE_HIDDEN_ACTIONS_CLASS);
        $wastageActions.removeClass('d-none');
      } else {
        $wastageActions.addClass('d-none');
        $normalActions
          .filter('.' + WASTAGE_HIDDEN_ACTIONS_CLASS)
          .removeClass('d-none ' + WASTAGE_HIDDEN_ACTIONS_CLASS);
      }
    });

    $('body').toggleClass('wastage-mode-active', wastageMode);
    $('.checkout-header .header-container .label').text(
      wastageMode
        ? $('.wastage-mode-config').first().data('title') || 'Svinnmodus'
        : 'Checkout'
    );
    $('.register-wastage').prop(
      'disabled',
      !cartHasProducts() || wastageRegistrationInProgress
    );

    $('.last-order-detail-container').toggleClass('d-none', wastageMode);

    if (wastageMode) {
      $('.quick-order-payment-container').hide();
      $('.last-order-detail').addClass('d-none');
    }
  }

  function switchWastageMode(enabled) {
    if (wastageMode === enabled) {
      return;
    }

    if (cartHasProducts()) {
      const confirmationMessage =
        $('.wastage-mode-config').first().data('confirmation') ||
        'Handlekurven inneholder produkter. Vil du bytte modus og beholde produktene?';
      if (!window.confirm(confirmationMessage)) {
        return;
      }
    }

    wastageMode = enabled;
    applyWastageMode();

    if (wastageMode) {
      updateCartProducts();
    } else {
      if (locationCart.order_storage_identifier) {
        updateCartSummary();
      } else {
        updateCartProducts();
      }
    }
  }

  $(document).on('click', '.enable-wastage-mode', function () {
    switchWastageMode(true);
  });

  $(document).on('click', '.disable-wastage-mode', function () {
    switchWastageMode(false);
  });

  $(document).on('click', '.register-wastage', function () {
    if (!wastageMode || !cartHasProducts() || wastageRegistrationInProgress) {
      return;
    }

    $('#wastage-register-modal').modal('show');
  });

  $(document).on('click', '#wastage-register-confirm', function () {
    $('#wastage-register-modal').modal('hide');

    if (!wastageMode || !cartHasProducts() || wastageRegistrationInProgress) {
      return;
    }

    wastageRegistrationInProgress = true;
    applyWastageMode();

    $.ajax({
      type: 'POST',
      url: '/ajax/wastage/register',
      dataType: 'json',
      data: {
        location_id: locationId,
        products: locationCart.products,
      },
    })
      .done(function (response) {
        wastageRegistrationInProgress = false;
        emptyAllCart('wastage_registered');
        applyWastageMode();
        popupAlert();
        showToast({
          type: 'success',
          message: response.message || 'Svinnet er registrert.',
        });
      })
      .fail(function (response) {
        wastageRegistrationInProgress = false;
        applyWastageMode();
        errorPopupAlert(
          response.responseJSON?.error_message ||
            'Svinnet kunne ikke registreres.'
        );
      });
  });

  if (
    shop_type === 'pos' &&
    location.search.indexOf('pos_type=classic') === -1
  ) {
    location.href = location.pathname + '?pos_type=classic';
    return;
  }

  if (location.search.indexOf('pos-sale=2') !== -1) {
    showToast({ type: 'success', message: 'Veksel vellykket', duration: 2000 });
    $('#cash-exchange-input').val('');
    removeQueryParams(['shop-type', 'order', 'pos_type', 'pos-sale'], true);
  }

  $(window).on('beforeunload', function () {
    const orderId = $('#payment-split-modal').attr('data-order-id');
    if (orderId) {
      return 'Er du sikker på at du vil forlate siden? Din nåværende delte betaling vil gå tapt.';
    }

    if (
      locationCart &&
      locationCart.products &&
      locationCart.products.length > 0 &&
      !locationCart.payment_method
    ) {
      return '⚠️ Du har varer i handlekurven. Vil du gå ut likevel?';
    }
  });

  let splitOrderId = $('body').attr('order') ?? null;
  organizerId = $('body').attr('organizer_id');
  $('[data-toggle="tooltip"]').tooltip({ placement: 'top' });
  if (p === 'events' && posType === 'classic') {
    connectWebSocket();
    setDeviceId();

    $(document).on('click touchstart scroll', function () {
      if (!hasBeenInactive) {
        resetInactivityTimer();
      }
    });

    $(document).on(
      'hide.bs.modal',
      '#pay-with-cash-confirmation-modal',
      function () {
        if (currentOrderAjax && currentOrderAjax.readyState !== 4) {
          currentOrderAjax.abort();
          currentOrderAjax = null;
        }
        order_ajax_lock = false;
        $('div.loader').remove();
        $('.order-button').prop('disabled', false);
      }
    );

    $(document).on('click', '.open-cart-mobile-btn', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }

      localStorage.setItem('isCartOpened', true);
      $('.classic-mobile-cart').css('display', 'flex');
      $('.classic-mobile-cart .close-cart').css('display', 'none');
      setTimeout(() => {
        $('.classic-mobile-cart').css('bottom', '0');
        $('.drawer-backdrop ,.classic-mobile-drawer-body').css({
          display: 'flex',
          bottom: '0',
        });
        adjustCheckoutActionsHeight();
      }, 30);
    });

    $(document).on('click', '.drawer-backdrop', function () {
      localStorage.setItem('isCartOpened', false);
      closePanel();
    });

    $(document).on('hide.bs.modal', '#split-payment-cart-modal', function () {
      $('#context-menu').addClass('d-none');
      $('#order-storage-list-modal').modal('hide');
      $('#split-payment-cart-modal').remove();
      $('.modal-backdrop').remove();

      if (emptyCartOnModalClose) {
        emptyCart();
        emptyCartOnModalClose = false;
      }
    });

    if ($('#suggested-product div').length > 0) {
      $('#remove-suggested-product-container').attr('hidden', false);
    }

    // $("header").hide();
    $('.container').css({
      width: '100%',
      'max-width': '2550px',
    });

    $('#footer').css('display', 'none');

    $(window).on('load resize', function () {
      setTimeout(function () {
        const headerHeight = $('header').outerHeight() || 0;
        $('#content-body').css({
          height: `calc(100% - ${headerHeight}px)`,
          overflow: 'hidden',
        });

        adjustClassicProductsHeight();
        // adjustCartItemHeight();
      }, 100);
    });

    setTimeout(function () {
      const headerHeight = $('header').outerHeight() || 0;
      $('#content-body').css({
        height: `calc(100% - ${headerHeight}px)`,
        overflow: 'hidden',
      });
      adjustClassicProductsHeight();
    }, 100);

    locationId = $('#location-id').val();
    var containerWidth = $('#product-container').width();
    var containerHeight = $('#product-container').height();

    var productWidth = 210;
    var productHeight = 130;

    var productsPerRow = Math.floor(containerWidth / productWidth);
    var rowsInContainer = Math.floor(containerHeight / productHeight);

    const formData = new FormData();
    formData.append('event_id', locationId);
    formData.append('pos_type', localStorage.getItem('postype'));

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'get_orientation',
        })
      );
    }

    enableSwipe('checkout', {
      threshold: 400,
      preventDefault: false,
    });

    $(document).on('click', '.close-checkout', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      localStorage.setItem('isCartOpened', false);
      $('#checkout').css('width', '0');
      $('body').removeClass('checkout-cart-open');
      $('body').addClass('checkout-cart-close');
      setTimeout(() => {
        $('#open-cart').removeClass('d-none');
        $('.quick-order-payment-container.desktop').show();

        if (prevSaleTimeoutId) {
          $('#previousSaleDesktopBar').show();
        }

        if (locationCart.products.length > 0) {
          $('.quick-order-payment-container:not(.desktop)').show();
          $('.quick-order-payment-container.desktop > .payment-buttons-wrapper')
            .removeClass('d-none')
            .addClass('d-flex');
        }
      }, 300);
    });

    $(document).on('click', '.close-cart-mobile', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      closePanel();
      localStorage.setItem('isCartOpened', false);
    });

    $(document).on('click', '#open-cart, .open-cart-desktop', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      localStorage.setItem('isCartOpened', true);
      if (
        $('.checkout-actions-container.desktop').attr(
          'data-actions-per-row'
        ) === '3'
      ) {
        $('#checkout').css('width', '360px');
      } else {
        $('#checkout').css('width', '472px');
      }
      $('body').addClass('checkout-cart-open');
      $('body').removeClass('checkout-cart-close');
      $('#open-cart').addClass('d-none');
      $('#previousSaleDesktopBar').hide();
      $('.quick-order-payment-container').hide();
      $('.open-save-table').hide();
      $('.checkout-action:disabled').each(function () {
        const orderCards = $('.order-card').not('.clone');

        if (orderCards.length) {
          const orderCardIds = orderCards
            .map(function () {
              return $(this).attr('id');
            })
            .get();

          if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
            $(this).attr('title', 'Vennligst vent, det pågår en betaling');
          }
        } else {
          $(this).attr('title', 'Legg produkter i Checkout først');
        }
      });

      adjustCheckoutActionsHeight();
    });

    const isCartOpened = localStorage.getItem('isCartOpened');
    // Check if the cart is opened and set the initial state
    if (isCartOpened === 'true' && window.innerWidth < 768) {
      $('.close-checkout').trigger('click');
    } else if (isCartOpened === 'true') {
      $('#open-cart').trigger('click');
    } else {
      $('.close-checkout').trigger('click');
    }
    // Close cart on resize if opened
    window.addEventListener('resize', function () {
      if (isCartOpened === 'true' && window.innerWidth < 768) {
        $('.close-checkout').trigger('click');
      } else if (isCartOpened === 'true') {
        $('#open-cart').trigger('click');
      } else {
        $('.close-checkout').trigger('click');
      }
    });

    $(document).on(
      'click',
      '.reset-classic-shopping-cart, .reset-classic-shopping-cart-mini',
      function () {
        if (hasBeenInactive) {
          showClearCartConfirmation();
          return;
        }

        const cartIsEmpty =
          locationCart.products.length === 0 &&
          (!locationCart.share_amount ||
            locationCart.share_amount <= 0 ||
            !locationCart.exchange_amount ||
            locationCart.exchange_amount <= 0);

        if (cartIsEmpty) {
          return;
        }

        $('#empty-cart-modal').modal('show');
      }
    );

    $(document).on('click', '#empty-cart-confirm', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      saveToElectronicJournal(
        locationId,
        'deleted_checkout',
        locationCart.products
      );

      emptyCart();
      $('#cart-modal').modal('hide');
      $('#empty-cart-modal').modal('hide');
      $('.modal-backdrop').remove();
      popupAlert();
      return false;
    });

    function saveToElectronicJournal(
      location_id = null,
      event_type,
      items = []
    ) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/electronic-journal/save',
        data: {
          location_id: location_id,
          event_type: event_type,
          items: items,
        },
      })
        .done(function (data) {
          return true;
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    }

    $(document).on('click', '#discount-toggle', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $('.discount-section').toggleClass('active');
      // adjustCartItemHeight();
    });

    $(document).on('click', '#reset-shopping-cart', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      emptyCart();
      $('#cart-modal').modal('hide');
      return false;
    });

    $(document).on('submit', '#commentForm', function (e) {
      e.preventDefault();
      const comment = $('#comment-box').val();
      locationCart.comment = comment;
      $('#order-comment-model').modal('hide');
    });

    $(document).on('submit', '.product-search-form', function (e) {
      e.preventDefault();

      const searchFormData = new FormData($(this)[0]);

      const currentPage = parseInt($(this).attr('data-current-page')) || 1;

      const promo_code = $('#classic_promo_code').val();
      const postype = localStorage.getItem('postype') ?? null;
      searchFormData.append('event_id', locationId);
      searchFormData.append('page', currentPage - 1);
      searchFormData.append('product_category_id', 'all');
      searchFormData.append('promo_code', promo_code);
      searchFormData.append('location_type', locationType);
      searchFormData.append('pos_type', postype);
      searchProductList(searchFormData, 'all');
    });

    // Mobile search toggle functionality
    $(document).on('click', '#mobile-search-toggle', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $('.search-product-form-container-mobile').slideToggle(300);
      // Focus on the search input when shown
      setTimeout(function () {
        if ($('.search-product-form-container-mobile').is(':visible')) {
          $('#search_string').focus();
        } else {
          $('#clear-search-product-button').trigger('click');
        }
      }, 350);
    });

    $(document).on('click', '#clear-search-product-button', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      e.preventDefault();
      $(
        '#search_string,.search-product-form-container-mobile #search_string'
      ).val('');
      $(this).addClass('d-none');
      const searchFormData = new FormData();
      const currentPage = parseInt($(this).attr('data-current-page')) || 1;
      const promo_code = $('#classic_promo_code').val();
      const postype = localStorage.getItem('postype') ?? null;
      searchFormData.append('search_string', '');
      searchFormData.append('event_id', locationId);
      searchFormData.append('page', currentPage - 1);
      searchFormData.append('product_category_id', 'all');
      searchFormData.append('promo_code', promo_code);
      searchFormData.append('location_type', locationType);
      searchFormData.append('pos_type', postype);

      searchProductList(searchFormData, 'all');
      if ($('.search-product-form-container-mobile').length > 0) {
        $('.search-product-form-container-mobile').slideUp(300);
      }
    });

    function searchProductList(formData, categoryId = '', scrollPosition = 0) {
      formData.append('orientation', screenOrientation);
      formData.append('pos_type', posType);
      $.ajax({
        type: 'POST',
        url: '/ajax/events/get_all_products',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            const $html = $(data.html);

            const productCardCount = $html.find(
              '#category-all .shop-product-container'
            ).length;

            const $parsedCard = $html
              .find('#category-all > .shop-product-container')
              .first();

            if (
              productCardCount === 1 &&
              !$parsedCard.data('is-open-price') &&
              $('#classic-location-products').attr(
                'data-search-and-add-to-checkout'
              ) == 1
            ) {
              // Extract all needed data
              const productName = $parsedCard.data('product-name') || '';
              const productId =
                $parsedCard.find('.add-product').data('product-id') ||
                $parsedCard.find('.remove-product').data('product-id') ||
                '999';
              const priceInclVat =
                $parsedCard.find('.add-product').data('price-incl-vat') ||
                '0.00';
              const hasExtra = $parsedCard
                .find('.add-product')
                .data('has-product-extra')
                ? '1'
                : '';
              const forceExtra = $parsedCard.data('force-extra-box') || '0';
              const isOpenPrice = $parsedCard.data('is-open-price') ? '1' : '';

              const priceText = $parsedCard
                .find('.product-price')
                .text()
                .trim();

              // === Exact Fake Card Matching Your Structure ===
              const fakeHTML = `
        <div class="shop-product-container d-none"
             id=" "
             data-product-name="${productName}"
             data-product-type=""
             data-category-id="all"
             data-force-extra-box="${forceExtra}"
             style="position: relative;"
             ${isOpenPrice ? 'data-is-open-price="1"' : ''}>

            <button data-product-type=""
                    tabindex="9999"
                    href="#"
                    type="button"
                    class="btn btn-block shop-product alert-primary"
                    id="prod-${productId}-fake with-background-image"
                    style="background: #cce5ff; border-color: #b8cee6; color: #000000;">

                <p class="product-title"><strong style="font-size: 14px;">${productName}</strong></p>
                <p class="product-price" style="font-size: 14px;">
                    ${priceText}
                </p>
            </button>

            <div class="d-none">
                <div class="col-md-auto product-qty-container-wrapper d-flex">
                    <div class="pull-right product-qty-container">
                        <button id="remove-product-${productId}"
                                class="p-0 btn btn-outline-primary remove-product align-middle product-qty-button "
                                data-product-id="${productId}"
                                data-product-with-category-id=""
                                data-price-incl-vat="${priceInclVat}"
                                data-force-product-extra-popup="1"
                                data-has-product-extra="${hasExtra}"
                                style="cursor: pointer;">
                            <i class="material-icons align-middle p-0">remove</i>
                        </button>

                        <input class="form-control col-6 product-to-order "
                               onfocus="this.select();"
                               data-product-id="${productId}"
                               data-price-incl-vat="${priceInclVat}"
                               value="0"
                               type="number"
                               min="0"
                               id="">

                        <span id="product-price-${productId}"
                              class="text-center pt-2 d-none" style="">kr ${priceText}</span>

                        <button class="p-0 btn btn-primary add-product align-middle product-qty-button "
                                data-product-id="${productId}"
                                data-product-with-category-id=""
                                data-price-incl-vat="${priceInclVat}"
                                data-alter-price-incl-vat="0.00"
                                data-force-product-extra-popup="1"
                                data-has-product-extra="${hasExtra}"
                                style="cursor: pointer;">
                            <i class="material-icons align-middle p-0">add</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>`;

              // Append to the current All category container
              $('#category-all').append(fakeHTML);

              // Trigger click on the fake card
              const $fakeCard = $(
                '#category-all .shop-product-container'
              ).last();

              if ($fakeCard.length > 0) {
                $fakeCard.find('.shop-product').first().trigger('click');
                setTimeout(() => {
                  $('#clear-search-product-button').trigger('click');
                }, 500);
              }
            } else {
              $('#classic-category-product-container').empty();
              $('#classic-category-product-container').html(data.html);
              $('#promo-code-alert-message').fadeOut(5000);
              setTimeout(function () {
                $('#promo-code-alert-message').addClass('d-none');
              }, 5000);

              if (categoryId == 'all') {
                $('.classic-category-nav-link').removeClass('active');
                $('.classic-category-nav-link').last().addClass('active');
                const navContainer = $('#nav-scroll-container');
                const activeLink = $('.classic-category-nav-link.active');
                if (navContainer.length && activeLink.length) {
                  const scrollPosition =
                    activeLink.position().left +
                    navContainer.scrollLeft() -
                    navContainer.width() / 2 +
                    activeLink.width() / 2;
                  navContainer.animate({ scrollLeft: scrollPosition }, 300);
                }
              }

              if (
                scrollPosition !== 0 &&
                scrollPosition !== undefined &&
                scrollPosition !== null
              ) {
                const navContainer = $('#nav-scroll-container');
                navContainer.scrollLeft(scrollPosition);
              }

              if (
                formData.get('search_string') &&
                formData.get('search_string') != ''
              ) {
                $(
                  '#clear-search-product-button,.search-product-form-container-mobile #clear-search-product-button'
                ).removeClass('d-none');
              } else {
                $(
                  '#clear-search-product-button,.search-product-form-container-mobile #clear-search-product-button'
                ).addClass('d-none');
              }

              if (
                productCardCount === 1 &&
                $parsedCard.data('is-open-price') &&
                $('#classic-location-products').attr(
                  'data-search-and-add-to-checkout'
                ) == 1
              ) {
                $('#category-all .shop-product-container')
                  .find('.shop-product')
                  .first()
                  .trigger('click');
              }
            }

            $('.shop-product-container').holdToConfirm({
              targetSelector: '.shop-product',
              svgSelector: '.ring-svg',
              totalDuration: 1250,

              onCancel: function ($wrap) {
                const productId = $wrap.data('product-id');
                // FIX: Using String comparison instead of Number (1) since .attr() returns a String
                const forcedProductExtraPopup =
                  $wrap.attr('data-force-product-extra-popup') === '1';
                const hasProductExtra =
                  $wrap.attr('data-has-product-extra') === '1';

                if (hasProductExtra && !forcedProductExtraPopup) {
                  $(document).off('click', '.add-product');
                  getClassicProductExtraModal(productId);

                  setTimeout(() => {
                    $(document).on(
                      'click',
                      '.add-product',
                      addProductClickHandler
                    );
                  }, 250);
                }
              },
              onComplete: function ($wrap) {
                const productId = $wrap.data('product-id');

                $.ajax({
                  type: 'POST',
                  url: '/api/v1/private/products/get-product-details',
                  data: { product_id: productId },
                  timeout: 10000,
                })
                  .done(function (data) {
                    if (data.html) {
                      $('#content').append(data.html);
                      $('#product-details-modal').modal('show');
                    }
                  })
                  .fail(function (xhr) {
                    if (xhr.responseJSON?.redirect_url) {
                      window.location.href = xhr.responseJSON.redirect_url;
                    }
                  });
              },
            });

            adjustClassicProductsHeight();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    $(window).on('orientationchange', function (event) {
      var angle = window.screen.orientation.type.includes('landscape') ? 90 : 0;
      switch (angle) {
        case 0:
        case 180:
          screenOrientation = 'PORTRAIT';
          $(
            '.product-container, #suggested-product, #classic-cart-table'
          ).addClass('portrait');
          break;
        case 90:
        case 270:
          screenOrientation = 'LANDSCAPE';
          $(
            '.product-container, #suggested-product, #classic-cart-table'
          ).removeClass('portrait');
          break;
      }
    });

    // Cart Process
    let locationType = $('#classic-location-products').attr(
      'data-location-type'
    );
    let userId = $('#classic-location-products').attr('data-user-id');
    locationCart = {
      location_id: locationId,
      location_type: locationType,
      table_number: '',
      number_of_products: 0,
      amount: 0,
      tips_percent: 0,
      products: [],
      payment_method: '',
      giftcards: [],
      comment: '',
      name: '',
      phone_number: '',
      pickup_date: '',
      pickup_time: '',
      promo_code: '',
      pick_up_at_the_bar: false,
      order_storage_identifier: '',
      user_id: null,
      customer_id: '',
      pos_type: posType,
      order_discount_percent: 0,
      is_takeaway_checked: hasEnabledDefaultOrderAsTakeaway == 1 ? 1 : 0,
    };

    function getCartInfoFromSession() {
      $.ajax({
        type: 'GET',
        url: '/ajax/order/get_cart_from_session',
      })
        .done(function (data) {
          setTimeout(() => {
            setLastOrderDetails();
          }, 500);
          if (
            data.location_id !== undefined &&
            data.location_id !== null &&
            data.location_id == locationId
          ) {
            data.set_payment_failed = true;
            setClassicLocationCart(data);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    if (!($('.clear-shopping-cart').length > 0)) {
      getCartInfoFromSession();
    }

    updateMenuButtons = function () {
      if (locationCart.products.length) {
        for (let i = 0; i < locationCart.products.length; i++) {
          let productId = locationCart.products[i].product_id;
          let input = $('#product-id-' + productId);
          input.val(locationCart.products[i].amount);
          let addToCartButton = input.siblings('button.add-product');
          if (
            input.val() > 0 &&
            !(
              addToCartButton.attr('data-has-product-extra') == 1 &&
              addToCartButton.attr('data-force-product-extra-popup') == 1
            )
          ) {
            if (!input.siblings('span').hasClass('d-none')) {
              input.siblings('span').addClass('d-none');
            }
            if (input.siblings('.remove-product').hasClass('d-none')) {
              input.siblings('.remove-product').removeClass('d-none');
            }
            if (input.hasClass('d-none')) {
              input.removeClass('d-none');
            }
          }
        }
      }
    };

    function areEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (
          JSON.stringify(normalize(arr1)) !== JSON.stringify(normalize(arr2))
        ) {
          return false;
        }
      }
      return true;
    }

    function normalize(value) {
      if (Array.isArray(value)) {
        return value.map(normalize);
      }

      if (value && typeof value === 'object') {
        return Object.fromEntries(
          Object.entries(value).map(([key, value]) => [key, normalize(value)])
        );
      }

      if (
        typeof value === 'string' &&
        value.trim() !== '' &&
        !Number.isNaN(Number(value))
      ) {
        return Number(value);
      }

      return value;
    }

    $(document).on('click', '#add-to-cart-button', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let numberOfProduct = parseInt($("input[name='product-to-order']").val());
      let productId = parseInt(
        $("input[name='product-to-order']").attr('data-product-id')
      );
      let productType = $(this).attr('data-product-type');
      let isOpenPrice = $("input[name='product-to-order']").attr(
        'data-is-open-price'
      );
      let isTakeaway = locationCart.is_takeaway_checked ? 1 : 0;
      let comment = $("textarea[name='comment']").val();
      let productExtraArray = $('input.product-extra-to-order');
      let productExtraTextArray = $('input.product-extra-text-to-order');
      let productExtras = [];

      productExtraArray.each(function () {
        if (parseInt($(this).val()) > 0) {
          let productExtra = {
            product_extra_id: parseInt($(this).attr('data-product-extra-id')),
            amount: parseInt($(this).val()),
            original_price: isTakeaway
              ? parseFloat($(this).attr('data-alter-price-incl-vat'))
              : parseFloat($(this).attr('data-price-incl-vat')),
          };
          productExtras.push(productExtra);
        }
      });
      productExtraTextArray.each(function () {
        if ($(this).is(':checked')) {
          let productExtra = {
            product_extra_id: parseInt($(this).attr('data-product-extra-id')),
            amount: 1,
            checked: true,
            original_price: 0,
            alter_original_price: 0,
          };
          productExtras.push(productExtra);
        }
      });
      productExtras.sort(function (a, b) {
        return a['product_extra_id'] > b['product_extra_id']
          ? 1
          : a['product_extra_id'] < b['product_extra_id']
            ? -1
            : 0;
      });
      let allProducts = locationCart.products;

      let productInCart = false;
      if (productExtras.length > 0) {
        if (allProducts.length > 0) {
          for (let [index, product] of allProducts.entries()) {
            if (
              product.product_id == productId &&
              product.is_takeaway &&
              product.is_takeaway == isTakeaway
            ) {
              if ('product_extra' in product) {
                if (areEqual(product.product_extra, productExtras) === true) {
                  locationCart.products[index].amount =
                    parseFloat(locationCart.products[index].amount) +
                    numberOfProduct;
                  locationCart.products[index].comment = comment;
                  productInCart = true;
                  break;
                }
              }
            }
          }
        }
      } else {
        if (allProducts.length > 0) {
          for (let product of allProducts) {
            if (
              product.product_id === productId &&
              product.is_takeaway &&
              product.is_takeaway === isTakeaway
            ) {
              if (!('product_extra' in product)) {
                let productIndex = locationCart.products.findIndex(
                  (obj) => obj.product_id === product.product_id
                );
                if (productIndex !== -1) {
                  locationCart.products[productIndex].amount =
                    locationCart.products[productIndex].amount +
                    numberOfProduct;
                  locationCart.products[productIndex].comment = comment;
                  productInCart = true;
                  break;
                }
              }
            }
          }
        }
      }

      if (productInCart === false) {
        let productPrice =
          parseFloat($('#subtotal').text().replace(',', '.')) / numberOfProduct;

        let product = {
          product_id: productId,
          amount: numberOfProduct,
          comment: comment,
          discount_percent: locationCart.order_discount_percent || 0,
          original_product_price: productPrice,
          is_open_price: isOpenPrice,
          is_takeaway: isTakeaway,
        };
        if (productExtras.length > 0) {
          product.product_extra = productExtras;
        }
        locationCart.products.unshift(product);
      }
      let priceInclVat = parseFloat($('#subtotal').text().replace(',', '.'));
      locationCart.number_of_products =
        parseInt(locationCart.number_of_products) + numberOfProduct;
      locationCart.amount = parseFloat(locationCart.amount) + priceInclVat;
      updateCartSummary();
      updateCartProducts();
      $('#product-extra-modal').modal('hide');
      if (productType === 'suggested') {
        $(`#suggested-product-${productId}`).remove();
        if ($('#suggested-product div').length === 0) {
          $('.suggested-product-list-container').attr('hidden', true);
          $('#remove-suggested-product-container').attr('hidden', true);
        }
      }
    });

    $(document).on('change', '#open-price-input', function () {
      let openPrice = parseFloat($(this).val());
      let subTotal = parseFloat($('#subtotal').text().replace(',', '.'));
      if (isNaN(openPrice) || openPrice < 0) {
        openPrice = 0;
      }
      $('#subtotal').text(openPrice.toFixed(2).replace('.', ','));
    });

    $(document).on('click', '.add-product-with-extra-products', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let numberOfProduct = parseInt(
        $(this).siblings('input.product-to-order').val()
      );
      let productIndex = $(this).attr('data-cart-index');
      let productPrice = parseFloat($(this).attr('data-price-incl-vat'));
      let subTotal = parseFloat($('#subtotal').text().replace(',', '.'));
      let alterSubTotal = parseFloat(
        $('#alterSubtotal').text().replace(',', '.')
      );
      var isChecked = $('#alt_price').prop('checked');
      if (isChecked && alterSubTotal && alterSubTotal > 0) {
        let alterSumPriceExtra = alterSubTotal - productPrice * numberOfProduct;
        let alterSumPriceExtraPerProduct = alterSumPriceExtra / numberOfProduct;
        numberOfProduct = numberOfProduct + 1;
        alterSubTotal = (
          (productPrice + alterSumPriceExtraPerProduct) *
          numberOfProduct
        ).toFixed(2);
        $(this).siblings('input.product-to-order').val(numberOfProduct);
        $('#alterSubtotal').text(alterSubTotal.replace('.', ','));

        if ($('#product-discount-price-input').length) {
          $('#product-discount-price-input').val(
            formattedPriceToSetValue(alterSubTotal)
          );
        }
      } else {
        let sumPriceExtra = subTotal - productPrice * numberOfProduct;
        let sumPriceExtraPerProduct = sumPriceExtra / numberOfProduct;
        numberOfProduct = numberOfProduct + 1;
        subTotal = (
          (productPrice + sumPriceExtraPerProduct) *
          numberOfProduct
        ).toFixed(2);
        $(this).siblings('input.product-to-order').val(numberOfProduct);
        $('#subtotal').text(subTotal.replace('.', ','));

        if ($('#product-discount-price-input').length) {
          $('#product-discount-price-input').val(
            formattedPriceToSetValue(subTotal)
          );
        }
      }
      if (!!productIndex) {
        locationCart.products[productIndex].amount = numberOfProduct;
      }
    });

    $(document).on('click', '.remove-product-with-extra-products', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let numberOfProduct = parseInt(
        $(this).siblings('input.product-to-order').val()
      );
      if (numberOfProduct === 1) {
        return false;
      }
      let productIndex = $(this).attr('data-cart-index');
      let productPrice = parseFloat($(this).attr('data-price-incl-vat'));
      let subTotal = parseFloat($('#subtotal').text().replace(',', '.'));
      let alterSubtotal = parseFloat(
        $('#alterSubtotal').text().replace(',', '.')
      );
      var isChecked = $('#alt_price').prop('checked');
      if (isChecked && alterSubtotal && alterSubtotal > 0) {
        let alterSumPriceExtra = alterSubtotal - productPrice * numberOfProduct;
        let alterSumPriceExtraPerProduct = alterSumPriceExtra / numberOfProduct;
        numberOfProduct = numberOfProduct - 1;
        alterSubtotal = (
          (productPrice + alterSumPriceExtraPerProduct) *
          numberOfProduct
        ).toFixed(2);
        $(this).siblings('input.product-to-order').val(numberOfProduct);
        $('#alterSubtotal').text(alterSubtotal.replace('.', ','));
        if ($('#product-discount-price-input').length) {
          $('#product-discount-price-input').val(
            formattedPriceToSetValue(alterSubtotal)
          );
        }
      } else {
        let sumPriceExtra = subTotal - productPrice * numberOfProduct;
        let sumPriceExtraPerProduct = sumPriceExtra / numberOfProduct;
        numberOfProduct = numberOfProduct - 1;
        subTotal = (
          (productPrice + sumPriceExtraPerProduct) *
          numberOfProduct
        ).toFixed(2);
        $(this).siblings('input.product-to-order').val(numberOfProduct);
        $('#subtotal').text(subTotal.replace('.', ','));
        if ($('#product-discount-price-input').length) {
          $('#product-discount-price-input').val(
            formattedPriceToSetValue(subTotal)
          );
        }
      }
      locationCart.products[productIndex].amount = numberOfProduct;
    });

    $(document).on('click', '.add-product-extra', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      if (!$(this).siblings('span').hasClass('d-none')) {
        $(this).siblings('span').addClass('d-none');
      }
      if ($(this).siblings('.remove-product-extra').hasClass('d-none')) {
        $(this).siblings('.remove-product-extra').removeClass('d-none');
      }
      if ($(this).siblings('input.product-extra-to-order').hasClass('d-none')) {
        $(this).siblings('input.product-extra-to-order').removeClass('d-none');
      }
      let numberOfProductExtra = parseInt(
        $(this).siblings('input.product-extra-to-order').val()
      );
      let productExtraPrice = parseFloat($(this).attr('data-price-incl-vat'));
      let productExtraAlterPrice = parseFloat(
        $(this).attr('data-alter-price-incl-vat')
      );
      let productId = parseFloat($(this).attr('data-product-id'));
      const cartIndex = $(this).data('cart-index');
      let numberOfProduct = parseInt(
        $('#product-with-extra-products-id-' + productId).val()
      );

      numberOfProductExtra = numberOfProductExtra + 1;

      if (cartIndex !== '' && cartIndex >= 0) {
        const isTakeaway =
          locationCart.products[cartIndex]?.is_takeaway ||
          locationCart.is_takeaway_checked
            ? 1
            : 0;
        const productOriginalPrice = parseFloat(
          locationCart.products[cartIndex].original_product_price
        );
        const productAlterOriginalPrice = parseFloat(
          locationCart.products[cartIndex].original_product_price
        );
        const discountPercent = parseFloat(
          $('#product-discount-percent-input').attr('data-original-value')
        );
        const totalPriceInput = $('#product-discount-price-input');
        if (
          isTakeaway &&
          productAlterOriginalPrice &&
          productAlterOriginalPrice > 0
        ) {
          const updatedProductAlterOriginalPrice =
            parseFloat(productAlterOriginalPrice) +
            parseFloat(productExtraPrice);

          const alterTotalPrice =
            numberOfProduct *
            (updatedProductAlterOriginalPrice * (1 - discountPercent / 100));
          totalPriceInput
            .val(alterTotalPrice)
            .attr('data-original-value', alterTotalPrice);
          $(this)
            .siblings('input.product-extra-to-order')
            .val(numberOfProductExtra);
          $('#product-discount-price-input').val(
            formattedPriceToShow(alterTotalPrice)
          );
          $('#alterSubtotal').text(formattedPriceToShow(alterTotalPrice));
        } else {
          const updatedProductOriginalPrice =
            parseFloat(productOriginalPrice) + parseFloat(productExtraPrice);
          locationCart.products[cartIndex].original_product_price =
            updatedProductOriginalPrice;
          const totalPrice =
            numberOfProduct *
            (updatedProductOriginalPrice * (1 - discountPercent / 100));

          totalPriceInput
            .val(totalPrice)
            .attr('data-original-value', totalPrice);
          $(this)
            .siblings('input.product-extra-to-order')
            .val(numberOfProductExtra);
          $('#product-discount-price-input').val(
            formattedPriceToShow(totalPrice)
          );
          $('#subtotal').text(formattedPriceToShow(totalPrice));
        }
        return;
      }

      const extraPrice = locationCart.is_takeaway_checked
        ? productExtraAlterPrice
        : productExtraPrice;
      $(this)
        .siblings('input.product-extra-to-order')
        .val(numberOfProductExtra);
      let subTotal = parseFloat($('#subtotal').text().replace(',', '.'));
      subTotal = (subTotal + extraPrice * numberOfProduct).toFixed(2);
      $('#subtotal').text(subTotal.replace('.', ','));
    });

    $(document).on('click', '.remove-product-extra', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let numberOfProductExtra = parseInt(
        $(this).siblings('input.product-extra-to-order').val()
      );
      if (numberOfProductExtra <= 0) {
        return;
      }

      let productExtraPrice = parseFloat($(this).attr('data-price-incl-vat'));
      let productId = parseFloat($(this).attr('data-product-id'));
      const cartIndex = $(this).data('cart-index');
      let numberOfProduct = parseInt(
        $('#product-with-extra-products-id-' + productId).val()
      );
      var isAlterChecked = $('#alt_price').prop('checked');

      numberOfProductExtra = numberOfProductExtra - 1;
      if (cartIndex !== '' && cartIndex >= 0) {
        const productOriginalPrice =
          locationCart.products[cartIndex].original_product_price;

        const discountPercent = parseFloat(
          $('#product-discount-percent-input').attr('data-original-value')
        );
        const totalPriceInput = $('#product-discount-price-input');

        const updatedProductOriginalPrice =
          productOriginalPrice - productExtraPrice;

        locationCart.products[cartIndex].original_product_price =
          updatedProductOriginalPrice;

        const totalPrice =
          numberOfProduct *
          (updatedProductOriginalPrice * (1 - discountPercent / 100));
        totalPriceInput.val(totalPrice).attr('data-original-value', totalPrice);
        $(this)
          .siblings('input.product-extra-to-order')
          .val(numberOfProductExtra);
        $('#product-discount-price-input').val(
          formattedPriceToShow(totalPrice)
        );
        $('#subtotal').text(formattedPriceToShow(totalPrice));
        return;
      }

      $(this)
        .siblings('input.product-extra-to-order')
        .val(numberOfProductExtra);
      let subTotal = parseFloat($('#subtotal').text().replace(',', '.'));
      let alterSubTotal = parseFloat(
        $('#alterSubtotal').text().replace(',', '.')
      );
      if (isAlterChecked && alterSubTotal && alterSubTotal > 0) {
        alterSubTotal = (
          alterSubTotal -
          productExtraPrice * numberOfProduct
        ).toFixed(2);
        $('#alterSubtotal').text(alterSubTotal.replace('.', ','));
      } else {
        subTotal = (subTotal - productExtraPrice * numberOfProduct).toFixed(2);
        $('#subtotal').text(subTotal.replace('.', ','));
      }
      if (numberOfProductExtra === 0) {
        if ($(this).siblings('span').hasClass('d-none')) {
          $(this).siblings('span').removeClass('d-none');
        }
        if (!$(this).hasClass('d-none')) {
          $(this).addClass('d-none');
        }
        if (
          !$(this).siblings('input.product-extra-to-order').hasClass('d-none')
        ) {
          $(this).siblings('input.product-extra-to-order').addClass('d-none');
        }
      }
    });

    $(document).on(
      'change',
      'div.product-qty-container-wrapper input.product-to-order',
      function () {
        let productId = parseInt($(this).attr('data-product-id'));
        let productIndex = locationCart.products.findIndex(
          (obj) => obj.product_id == productId
        );

        let productAmount = parseFloat($(this).val());
        let discountPercent = parseFloat(
          $('#product-discount-percent-input').val()
        );
        let priceInclVat = parseFloat($(this).attr('data-price-incl-vat'));
        if (productAmount > locationCart.products[productIndex].amount) {
          let productAmountDiff =
            productAmount -
            parseFloat(locationCart.products[productIndex].amount);
          locationCart.number_of_products =
            parseFloat(locationCart.number_of_products) + productAmountDiff;
          let priceInclVatDiff = productAmountDiff * priceInclVat;
          locationCart.amount =
            parseFloat(locationCart.amount) + priceInclVatDiff;
        }

        if (productAmount < locationCart.products[productIndex].amount) {
          let productAmountDiff =
            parseFloat(locationCart.products[productIndex].amount) -
            productAmount;
          locationCart.number_of_products =
            parseFloat(locationCart.number_of_products) - productAmountDiff;
          let priceInclVatDiff = productAmountDiff * priceInclVat;
          locationCart.amount =
            parseFloat(locationCart.amount) - priceInclVatDiff;
        }
        locationCart.products[productIndex].amount = productAmount;
        let updatedPriceIncVat =
          priceInclVat * productAmount -
          priceInclVat * productAmount * (discountPercent / 100);

        $('#product-discount-price-input').val(
          formattedPriceToSetValue(updatedPriceIncVat)
        );

        updateCartSummary();
      }
    );

    let numberOfExtraProduct;
    $(document).on(
      'focusin',
      'div#product-extra-modal input.product-to-order',
      function () {
        numberOfExtraProduct = $(this).val();
      }
    );

    $(document).on(
      'change',
      'div#product-extra-modal input.product-to-order',
      function () {
        let numberOfProduct = parseInt($(this).val());
        let productPrice = parseFloat($(this).attr('data-price-incl-vat'));
        let subTotal = parseFloat($('#subtotal').text().replace(',', '.'));
        let sumPriceExtra = subTotal - productPrice * numberOfExtraProduct;
        let sumPriceExtraPerProduct = sumPriceExtra / numberOfExtraProduct;
        subTotal = (
          (productPrice + sumPriceExtraPerProduct) *
          numberOfProduct
        ).toFixed(2);
        $('#subtotal').text(subTotal.replace('.', ','));
      }
    );

    let numberOfExtraProductExtra;
    $(document).on(
      'focusin',
      'div#product-extra-modal input.product-extra-to-order',
      function () {
        numberOfExtraProductExtra = $(this).val();
      }
    );

    $(document).on(
      'change',
      'div#product-extra-modal input.product-extra-to-order',
      function () {
        let numberOfProductExtra = parseInt($(this).val());
        let productExtraPrice = parseFloat($(this).attr('data-price-incl-vat'));
        let productId = parseInt($(this).attr('data-product-id'));
        let numberOfProduct = parseInt(
          $('#product-with-extra-products-id-' + productId).val()
        );
        let subTotal = parseFloat($('#subtotal').text().replace(',', '.'));
        if (numberOfExtraProductExtra > numberOfProductExtra) {
          let numberOfProductExtraDiff =
            numberOfExtraProductExtra - numberOfProductExtra;
          subTotal = (
            subTotal -
            numberOfProductExtraDiff * productExtraPrice * numberOfProduct
          ).toFixed(2);
        }
        if (numberOfExtraProductExtra < numberOfProductExtra) {
          let numberOfProductExtraDiff =
            numberOfProductExtra - numberOfExtraProductExtra;
          subTotal = (
            subTotal +
            numberOfProductExtraDiff * productExtraPrice * numberOfProduct
          ).toFixed(2);
        }
        $('#subtotal').text(subTotal.replace('.', ','));
      }
    );

    $(document).on('click', '.add-product', addProductClickHandler);

    $(document).on('click', '.close-suggested-product', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $(this)
        .closest('.shop-product-container')
        .fadeOut(200, function () {
          $(this).remove();
        });
      setTimeout(() => {
        if ($('#suggested-product div').length === 0) {
          $('.suggested-product-list-container').attr('hidden', true);
          $('#remove-suggested-product-container').attr('hidden', true);
        }
        adjustClassicProductsHeight();
      }, 300);
    });

    $(document).on(
      'input',
      '#product-discount-price-input, #product-discount-percent-input, #discount-percent-input, .payment-split-input',
      function () {
        if (this.value.length > 1 && this.value.indexOf(0) == 0) {
          $(this).val(Math.abs(this.value));
        }
      }
    );

    $(document).on(
      'keydown',
      '#product-discount-price-input, #discount-percent-input, #product-discount-percent-input, .payment-split-input',
      function (event) {
        if (event.key === '-' || event.key === '+') {
          event.preventDefault();
        }
      }
    );

    $(document).on(
      'input',
      '#product-discount-percent-input, #discount-percent-input',
      function () {
        const value = parseFloat(this.value.replace(',', '.'));

        if (this.value.length > 1 && this.value.indexOf(0) == 0) {
          $(this).val(Math.abs(this.value));
        }

        if (value > 100) {
          this.value = 100;
        }
      }
    );

    $(document).on('input', '#product-discount-price-input', function () {
      if (this.value.length > 1 && this.value.indexOf(0) == 0) {
        $(this).val(Math.abs(this.value));
      }
    });

    $(document).on('change', '#product-discount-percent-input', function () {
      const productIndex = $(this).data('cart-index');
      const incomingPercent = parseFloat($(this).val());

      const productPrice =
        locationCart.products[productIndex].original_product_price;

      const productQuantity = $(
        '#product-with-extra-products-id-' +
          locationCart.products[productIndex].product_id
      ).val();

      const originalProductTotalPrice = productPrice * productQuantity;
      const incomingDiscountPrice =
        originalProductTotalPrice * (1 - incomingPercent / 100);

      $('#subtotal').text(formattedPriceToShow(floor(incomingDiscountPrice)));

      $('#product-discount-price-input')
        .val(floor(incomingDiscountPrice))
        .attr('data-original-value', incomingDiscountPrice);

      $('#product-discount-percent-input').attr(
        'data-original-value',
        incomingPercent
      );
    });

    $(document).on('change', '#product-discount-price-input', function () {
      const productIndex = $(this).data('cart-index');
      const incomingPrice = parseFloat($(this).val().replace(',', '.'));
      const registeredProductPrice = parseFloat(
        $(this).attr('data-product-price')
      );
      const productPrice =
        locationCart.products[productIndex].original_product_price;

      const productQuantity = locationCart.products[productIndex].amount;
      const discountedProductPrice = incomingPrice / productQuantity;

      const discountPercent = (1 - discountedProductPrice / productPrice) * 100;
      $('#subtotal').text(formattedPriceToShow(floor(incomingPrice)));
      $('#productExtraModalLabel').attr(
        'data-product-price',
        discountedProductPrice
      );
      if (discountedProductPrice > productPrice) {
        $('#product-discount-percent-input')
          .val(0)
          .attr('data-original-value', 0);
        return;
      }
      $('#product-discount-percent-input')
        .val(floor(discountPercent))
        .attr('data-original-value', discountPercent);
    });

    $(document).on('keydown', '#discount-percent-input', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        const type = $(this).data('type');
        const orderDiscountpercent =
          parseFloat($('#discount-percent-input').val().replace(',', '.')) || 0;
        locationCart.order_discount_percent = orderDiscountpercent;

        locationCart.products.map((product, index) => {
          const bestValuePercent =
            orderDiscountpercent > product.discount_percent
              ? orderDiscountpercent
              : product.discount_percent;
          locationCart.products[index].discount_percent =
            Math.floor(bestValuePercent * 100) / 100;
        });

        $('#product-extra-modal').modal('hide');
        $('.modal-backdrop').remove();
        if (
          type !== undefined &&
          type !== null &&
          type === 'scroll' &&
          orderStorageIds !== null
        ) {
          getClassicCartModal();
        } else {
          updateCartProducts();
        }
      }
    });

    $(document).on('click', '#add-discount', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      e.preventDefault();
      const type = $(this).data('type');
      const $section = $(this).closest('.discount-section');
      const orderDiscountpercent =
        parseFloat(
          $section.find('input#discount-percent-input').val().replace(',', '.')
        ) || 0;

      locationCart.order_discount_percent = orderDiscountpercent;

      locationCart.products.map((product, index) => {
        let bestPercentValue = 0;
        const productDiscountPercent = parseFloat(
          product.discount_percent || 0
        );
        if (productDiscountPercent < 0) {
          bestPercentValue = productDiscountPercent + orderDiscountpercent;
        } else {
          bestPercentValue =
            orderDiscountpercent > productDiscountPercent
              ? orderDiscountpercent
              : productDiscountPercent;
        }
        locationCart.products[index].discount_percent = bestPercentValue;
      });

      locationCart.amount_without_discount = floor(
        locationCart.products.reduce(
          (total, product) =>
            total + parseFloat(product.amount * product.original_product_price),
          0
        )
      );

      $('#product-extra-modal').modal('hide');
      $('.modal-backdrop').remove();
      if (
        type !== undefined &&
        type !== null &&
        type === 'scroll' &&
        orderStorageIds !== null
      ) {
        getClassicCartModal();
      } else {
        updateCartProducts();
      }
    });

    $(document).on('click', '#show-discount', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $(this).hide();
      $('.show-discount-percent').removeClass('d-none');
    });

    $(document).on('click', '#update-extra-product-button', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      const type = $(this).data('type');
      let productIndex = parseInt($(this).data('cart-index'));
      let productExtraArray = $('input.product-extra-to-order');
      const productQuantity = parseFloat(
        $(
          '#product-with-extra-products-id-' +
            locationCart.products[productIndex].product_id
        ).val()
      );
      let productPrice = parseFloat(
        $('#productExtraModalLabel').data('product-price')
      );

      let productExtraTextArray = $('input.product-extra-text-to-order');
      let isTakeaway = $('#product-takeaway-checkbox').prop('checked') ? 1 : 0;
      let comment = $("textarea[name='comment']").val();
      let productDiscountPercent =
        $('#product-discount-percent-input').attr('data-original-value') || 0;
      let productDiscountPrice =
        $('#product-discount-price-input').attr('data-original-value') || 0;
      let productExtras = [];
      let originalProductPrice =
        locationCart.products[productIndex].original_product_price >
        productPrice
          ? locationCart.products[productIndex].original_product_price
          : productPrice;
      let alterOrignalProductPrice = productPrice;

      productExtraArray.each(function () {
        if (parseInt($(this).val()) > 0) {
          let productExtra = {
            product_extra_id: parseInt($(this).attr('data-product-extra-id')),
            amount: parseInt($(this).val()),
            original_price: parseFloat($(this).attr('data-price-incl-vat')),
          };
          productExtras.push(productExtra);

          originalProductPrice +=
            parseInt($(this).val()) *
            parseFloat($(this).attr('data-price-incl-vat'));
          alterOrignalProductPrice +=
            parseInt($(this).val()) *
            parseFloat($(this).attr('data-price-incl-vat'));
        }
      });
      productExtraTextArray.each(function () {
        if ($(this).is(':checked')) {
          let productExtra = {
            product_extra_id: parseInt($(this).attr('data-product-extra-id')),
            amount: 1,
            checked: true,
            original_price: 0,
          };
          productExtras.push(productExtra);
          originalProductPrice += 0;
          alterOrignalProductPrice += 0;
        }
      });
      productExtras.sort(function (a, b) {
        return a['product_extra_id'] > b['product_extra_id']
          ? 1
          : a['product_extra_id'] < b['product_extra_id']
            ? -1
            : 0;
      });

      if (
        productPrice >
        locationCart.products[productIndex].original_product_price
      ) {
        locationCart.products[productIndex].is_open_price = 1;
        locationCart.products[productIndex].original_product_price =
          productPrice;
      } else {
        locationCart.products[productIndex].original_product_price =
          originalProductPrice;
      }

      locationCart.products[productIndex].product_extra = productExtras;
      locationCart.products[productIndex].comment = comment;
      locationCart.products[productIndex].discount_price = productDiscountPrice;
      locationCart.products[productIndex].discount_percent =
        productDiscountPercent;
      locationCart.products[productIndex].amount = productQuantity;

      if (isTakeaway) {
        locationCart.products[productIndex].is_takeaway = 1;
      } else {
        delete locationCart.products[productIndex].is_takeaway;
      }

      $('#product-extra-modal').modal('hide');
      $('.modal-backdrop').remove();
      if (
        type !== undefined &&
        type !== null &&
        type === 'scroll' &&
        orderStorageIds !== null
      ) {
        getClassicCartModal();
        // updateCartProducts();
      } else {
        updateCartProducts();
      }
    });

    $(document).on('change', '.cart-product-amount', function () {
      let productId = $(this).data('product-id');
      let productIndex = parseFloat($(this).data('cart-index'));
      let productAmount = parseFloat($(this).val());

      const existingProductAmount = locationCart.products[productIndex].amount;

      locationCart.products[productIndex].amount = productAmount;
      if (locationCart.products[productIndex].amount_added_by_cart) {
        locationCart.products[productIndex].amount_added_by_cart =
          parseFloat(locationCart.products[productIndex].amount_added_by_cart) +
          1;
      } else {
        locationCart.products[productIndex].amount_added_by_cart = 1;
      }

      locationCart.number_of_products =
        locationCart.number_of_products - existingProductAmount + productAmount;
      let productPrice = parseFloat(
        $(this).data('product-price-incl-vat') || '0'
      );
      let productTotalPrice = (productPrice * productAmount).toFixed(2);
      $(this)
        .closest('td')
        .find('.product-total-price')
        .text(productTotalPrice.replace('.', ','));

      $('input#product-id-' + productId).val(productAmount);
      $('input#product-cart-index-' + productIndex).val(productAmount);
      addPriceToCart(productPrice);
      locationCart.amount_without_discount = floor(
        locationCart.products.reduce(
          (total, product) =>
            total +
            parseFloat(
              (product.amount * product.original_product_price).toFixed(2)
            ),
          0
        )
      );
      updateCartSummary();
      updateCartProducts();
    });

    $(document).on('click', '#show-more-payment', function (event) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      const $target = $(
        '.checkout-actions-container #more-payment-button-container'
      );

      if ($target.length === 0) {
        console.warn('#more-payment-button-container not found');
        return;
      }

      const willShow = $target.hasClass('d-none');

      $target.removeClass('d-none');
      $('.checkout-actions-container #default-payment-buttons').addClass(
        'd-none'
      );
      $('#show-less-payment').removeClass('d-none-custom');
      $('#checkout-mobile #show-less-payment').removeClass('d-none-custom');

      const $defaultPaymentButtons = $('#default-payment-buttons');
      const $mobileDefaultPaymentButtons = $(
        '#checkout-mobile #default-payment-buttons'
      );
      const $defaultCheckoutActions = $('#default-checkout-actions');
      const $mobileDefaultCheckoutActions = $(
        '#checkout-mobile #default-checkout-actions'
      );

      if (willShow) {
        $defaultPaymentButtons.addClass('d-none');
        $mobileDefaultPaymentButtons.addClass('d-none');
        $defaultCheckoutActions.addClass('d-none');
        $mobileDefaultCheckoutActions.addClass('d-none');
      }

      adjustCheckoutActionsHeight();
    });

    $(document).on('click', '#show-less-payment', function (event) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      const $target = $('.checkout-actions-container #default-payment-buttons');

      if ($target.length === 0) {
        console.warn('#default-payment-buttons not found');
        return;
      }

      const willHide = $target.hasClass('d-none');

      $target.removeClass('d-none');
      $('.checkout-actions-container #more-payment-button-container').addClass(
        'd-none'
      );
      $('#show-less-payment').addClass('d-none-custom');

      const $defaultPaymentButtons = $('#more-payment-button-container');
      const $mobileDefaultPaymentButtons = $(
        '#checkout-mobile #more-payment-button-container'
      );
      const $defaultCheckoutActions = $('#default-checkout-actions');
      const $mobileDefaultCheckoutActions = $(
        '#checkout-mobile #default-checkout-actions'
      );

      if (willHide) {
        $defaultPaymentButtons.add('d-none');
        $mobileDefaultPaymentButtons.add('d-none');
        $defaultCheckoutActions.add('d-none');
        $mobileDefaultCheckoutActions.add('d-none');
      }

      adjustCheckoutActionsHeight();
    });

    function adjustCheckoutActionsHeight() {
      if (isMobile) {
        const listOrderDetailContainerPadding = $(
          '#checkout-mobile .checkout-actions-container'
        ).css('padding-left');
        $('#checkout-mobile .last-order-detail-container').css({
          'padding-left': listOrderDetailContainerPadding,
          'padding-right': listOrderDetailContainerPadding,
        });

        const checkoutMobileHeight = $('#checkout-mobile').height();
        const checkoutActionContainerHeight = $(
          '#checkout-mobile .checkout-actions-container'
        ).height();
        const checkoutSummaryHeight = $(
          '#checkout-mobile .checkout-summary'
        ).height();
        const lastOrderDetailContainerHeight =
          $('#checkout-mobile .last-order-detail-container').height() || 0;

        if (
          checkoutMobileHeight -
            checkoutSummaryHeight -
            (lastOrderDetailContainerHeight + 50) <
          checkoutActionContainerHeight
        ) {
          $('#checkout-mobile #order_register_form').css({
            height:
              checkoutMobileHeight -
              checkoutSummaryHeight -
              (lastOrderDetailContainerHeight + 50) +
              'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden',
          });
        } else {
          $('#checkout-mobile #order_register_form').css({
            height: checkoutActionContainerHeight + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden',
          });
        }
      } else {
        const productCategoryNavHeight = $('#product-category-nav').length
          ? $('#product-category-nav').height() || 0
          : 0;
        $('#checkout > .checkout-container').css({
          height: `calc(100vh - ${productCategoryNavHeight + $('header').height()}px)`,
        });

        const checkoutBodyHeight = $('#checkout .checkout-body').height();
        const checkoutActionsContainerHeight = $(
          '#checkout .checkout-actions-container'
        ).height();

        const checkoutSummaryHeight = $('#checkout .checkout-summary').height();
        const lastOrderDetailContainerHeight =
          $('#checkout .last-order-detail-container').height() || 0;

        if (
          checkoutBodyHeight -
            checkoutSummaryHeight -
            (lastOrderDetailContainerHeight + 50) <
          checkoutActionsContainerHeight
        ) {
          $('#checkout #order_register_form').css({
            height:
              checkoutBodyHeight -
              checkoutSummaryHeight -
              (lastOrderDetailContainerHeight + 50) +
              'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden',
          });
        } else {
          $('#checkout #order_register_form').css({
            height: checkoutActionsContainerHeight + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden',
          });
        }
      }
    }

    $(document).on('click', '.cart-product', function (event) {
      if (locationCart.order_id && locationCart.order_id != '') {
        return;
      }

      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      if (!$(event.target).closest('.product-qty-container').length) {
        let productId = parseInt($(this).attr('data-product-id'));
        let productIndex = parseInt($(this).data('cart-index'));
        let comment = locationCart.products[productIndex].comment;
        const productPrice = $(this)
          .find('.product-total-price')
          .data('product-price-incl-vat');

        if (!locationCart.products[productIndex].original_product_price) {
          locationCart.products[productIndex].original_product_price =
            productPrice;
        }

        let discountPrice =
          locationCart.products[productIndex].amount * productPrice;
        let discountPercent =
          locationCart.products[productIndex].discount_percent;
        locationCart.products[productIndex].discount_price = discountPrice;

        if (locationCart.products[productIndex].product_extra) {
          const totalProductExtraPrice = locationCart.products[
            productIndex
          ].product_extra.reduce(
            (total, extraProduct) =>
              total + extraProduct.amount * extraProduct.original_price,
            0
          );
          const individualOriginalProductPrice = parseFloat(
            $(this).data('product-price')
          );
          locationCart.products[productIndex].original_product_price =
            individualOriginalProductPrice + totalProductExtraPrice;
        }
        if ('product_extra' in locationCart.products[productIndex]) {
          let productExtra = locationCart.products[productIndex].product_extra;
          getClassicProductExtraModal(
            productId,
            discountPrice,
            discountPercent,
            1,
            productIndex,
            comment,
            productExtra,
            locationCart.products[productIndex].amount,
            locationCart.products[productIndex]
          );
        } else {
          getClassicProductExtraModal(
            productId,
            discountPrice,
            discountPercent,
            1,
            productIndex,
            comment,
            [''],
            locationCart.products[productIndex].amount,
            locationCart.products[productIndex]
          );
        }
      }
    });

    updateCartSummary = function () {
      if (!locationCart.amount_without_discount) {
        locationCart.amount_without_discount = 0;
      }
      if (!locationCart.alter_amount_without_discount) {
        locationCart.alter_amount_without_discount = 0;
      }

      // Show quick order payment buttons when there are products in cart and checkout is NOT open

      // Show quick order payment buttons when there are products in cart
      const notShareAmountOrExchangeMode =
        !locationCart.share_amount ||
        locationCart.share_amount <= 0 ||
        !locationCart.exchange_amount ||
        locationCart.exchange_amount <= 0;
      if (
        locationCart.products &&
        locationCart.products.length > 0 &&
        notShareAmountOrExchangeMode
      ) {
        // Add has-products class for mobile layout
        $('.small-cart-container').addClass('has-products');
        $('#previousSaleBar').css({
          bottom: !prevSaleTimeoutId
            ? '-200px'
            : `${$('.small-cart-container.mobile').outerHeight() + 7.5}px`,
        });
        if (!locationCart.is_per_person_ordering_enabled) {
          $('.reset-classic-shopping-cart-mini').removeClass('d-none-custom');
        }
        $('.open-cart-mobile').addClass('has-products');

        if ($('#open-cart').hasClass('d-none')) {
          $('.quick-order-payment-container.desktop > .payment-buttons-wrapper')
            .removeClass('d-flex')
            .addClass('d-none');
          $('.quick-order-payment-container:not(.desktop)').hide();
        } else {
          $('.quick-order-payment-container.desktop > .payment-buttons-wrapper')
            .removeClass('d-none')
            .addClass('d-flex');
          $('.quick-order-payment-container:not(.desktop)').show();
          $('.quick-order-button').each(function () {
            const orderCards = $('.order-card').not('.clone');

            if (orderCards.length) {
              const orderCardIds = orderCards
                .map(function () {
                  return $(this).attr('id');
                })
                .get();

              if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
                $(this).prop('disabled', true);
                $(this).attr('title', 'Vennligst vent, det pågår en betaling');
              } else {
                $(this).prop('disabled', false);
                $(this).removeAttr('title');
              }
            } else {
              if ($(this).attr('data-terminal-type') != '2') {
                $(this).prop('disabled', false);
              }
              $(this).removeAttr('title');
            }
          });
        }
      } else if (
        locationCart.share_amount > 0 ||
        locationCart.exchange_amount > 0
      ) {
        $('.small-cart-container').addClass('has-products');
        $('#previousSaleBar').css({
          bottom: !prevSaleTimeoutId
            ? '-200px'
            : `${$('.small-cart-container.mobile').outerHeight() + 7.5}px`,
        });
        $('.reset-classic-shopping-cart-mini').removeClass('d-none-custom');
        $('.open-cart-mobile').addClass('has-products');

        $('.quick-order-payment-container.desktop > .payment-buttons-wrapper')
          .removeClass('d-none')
          .addClass('d-flex');
        $('.quick-order-payment-container:not(.desktop)').show();
        $('.quick-order-button').each(function () {
          const orderCards = $('.order-card').not('.clone');

          if (orderCards.length) {
            const orderCardIds = orderCards
              .map(function () {
                return $(this).attr('id');
              })
              .get();

            if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
              $(this).prop('disabled', true);
              $(this).attr('title', 'Vennligst vent, det pågår en betaling');
            } else {
              $(this).prop('disabled', false);
              $(this).removeAttr('title');
            }
          } else {
            if ($(this).attr('data-terminal-type') != '2') {
              $(this).prop('disabled', false);
            }
            $(this).removeAttr('title');
          }
        });

        $('.quick-order-total-price').text(
          formattedPriceToShow(
            locationCart.share_amount || locationCart.exchange_amount
          )
        );
      } else {
        // Remove has-products class for mobile layout
        $('.small-cart-container').removeClass('has-products');
        $('.reset-classic-shopping-cart-mini').addClass('d-none-custom');
        $('.open-cart-mobile').removeClass('has-products');
        $('.quick-order-payment-container.desktop > .payment-buttons-wrapper')
          .removeClass('d-flex')
          .addClass('d-none');
        $('.quick-order-payment-container:not(.desktop)').hide();

        $('#previousSaleBar').css({
          bottom: '0px',
        });
      }
      adjustClassicProductsHeight();
      if (wastageMode) {
        applyWastageMode();
      }
      // adjustCartItemHeight();
    };

    $(document).on('click', '.remove-product', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let productId = parseInt($(this).attr('data-product-id'));
      let productIndex = locationCart.products.findIndex(
        (obj) => obj.product_id === productId
      );
      let productAmount =
        parseInt(locationCart.products[productIndex].amount) - 1;
      locationCart.products[productIndex].amount = productAmount;
      let priceInclVat = parseFloat($(this).attr('data-price-incl-vat'));
      locationCart.number_of_products =
        parseInt(locationCart.number_of_products) - 1;
      locationCart.amount = parseFloat(locationCart.amount) - priceInclVat;
      updateCartSummary();
      $('input#product-id-' + productId).val(productAmount);
      if (productAmount === 0) {
        if (!$('input#product-id-' + productId).hasClass('d-none')) {
          $('input#product-id-' + productId).addClass('d-none');
        }
        if ($(this).siblings('span').hasClass('d-none')) {
          $(this).siblings('span').removeClass('d-none');
        }
        $(this).addClass('d-none');
        if (!$('#footer-space-for-cart').hasClass('d-none')) {
          $('#footer-space-for-cart').addClass('d-none');
        }
        if ($('#footer-space-for-cart').hasClass('d-block')) {
          $('#footer-space-for-cart').removeClass('d-block');
        }
      }
    });

    // Helper function to apply table number restrictions
    function applyTableNumberRestrictions() {
      if (locationCart.share_amount > 0) {
        $('.product-qty-button').attr('disabled', true);
        $('.product-qty-button').css('cursor', 'not-allowed');
        if ($('#alt_checkbox').length > 0) {
          document
            .getElementById('alt_checkbox')
            .style.setProperty('display', 'none', 'important');
        }

        $('.classic-products-container').css({
          opacity: '0.5',
          'pointer-events': 'none',
          cursor: 'not-allowed',
        });
      } else if (locationCart.order_id) {
        $('.classic-products-container').css({
          opacity: '0.5',
          'pointer-events': 'none',
          cursor: 'not-allowed',
        });
      } else {
        $('.product-qty-button').attr('disabled', false);
        $('.product-qty-button').css('cursor', 'pointer');

        $('.classic-products-container').css({
          opacity: '',
          'pointer-events': '',
          cursor: '',
        });
      }
    }

    // Helper function for common post-checkout logic
    function handlePostCheckoutLogic(data, autoPayWithTerminal) {
      if ($('#alt_checkbox').length > 0) {
        document.getElementById('alt_checkbox').style.removeProperty('display');
      }

      if (locationCart.customer_id) {
        setTimeout(() => {
          $(".order-button[data-payment-method='payment_credit']").prop(
            'disabled',
            false
          );
        }, 100);
      }

      // Calculate and update amounts
      const totalAmount = parseFloat(
        String(
          $('#cart-amount-with-tips').data('cart-amount-with-tips') || '0'
        ).replace(',', '.')
      );
      locationCart.amount = totalAmount;

      locationCart.amount_without_discount =
        locationCart.amount_without_discount
          ? locationCart.amount_without_discount
          : floor(
              locationCart.products.reduce(
                (total, product) =>
                  total +
                  parseFloat(product.amount * product.original_product_price),
                0
              )
            );

      updateCartSummary();

      // Handle checkout sub-menu visibility
      if (locationCart.table_number && !data.hasSplited) {
        $('.checkout-sub-menu').addClass('d-none');
        setTimeout(() => {
          $('.table-number-title').show(); // or whatever action was intended
        }, 300);
      } else {
        $('.checkout-sub-menu').removeClass('d-none');
      }

      // Initialize select2 for customer number dropdown
      $("select[name='customer_number']").select2({
        theme: 'bootstrap4',
      });

      // Set discount percent if exists
      if (locationCart.order_discount_percent) {
        $('#discount-percent-input').val(locationCart.order_discount_percent);
      }

      // Update cart products if provided
      if (data.cart_products !== undefined && data.cart_products !== null) {
        locationCart.products = data.cart_products;
      }

      // Handle automatic form submission
      if (
        locationCart.order_storage_identifier != null &&
        locationCart.order_storage_identifier != ''
      ) {
        locationCart.payment_method = 'none';
        $('form#order_register_form').submit();
      } else if (
        autoPayWithTerminal !== undefined &&
        autoPayWithTerminal !== null &&
        autoPayWithTerminal === true
      ) {
        locationCart.payment_method = 'payment_terminal';
        $('form#order_register_form').submit();
      }

      // Handle gift card validation
      if (
        Array.isArray(locationCart.giftcards) &&
        locationCart.giftcards.length
      ) {
        renderAppliedGiftCards();
      } else if (locationCart.giftcard_code) {
        $('#giftcard-code').val(locationCart.giftcard_code);
        $('#validate-giftcard').click();
      }
    }

    updateCartProducts = function (autoPayWithTerminal) {
      for (let [index, product] of locationCart.products.entries()) {
        if (product.amount === 0) {
          locationCart.products.splice(index, 1);
        }
      }

      locationCart.amount_without_discount = locationCart.products.reduce(
        (total, product) =>
          total + parseFloat(product.amount * product.original_product_price),
        0
      );

      let data = generateLocationCartData(locationCart, {
        shop_type: p,
        organizer_id: organizerId,
        orientation: screenOrientation,
        isCartOpened: localStorage.getItem('isCartOpened'),
      });

      if (locationCart.payment_failed === true) {
        data.payment_failed = locationCart.payment_failed;
      }

      if (locationCart.name != '') {
        data.name = locationCart.name;
      }

      if ($.isNumeric(locationCart.phone_number)) {
        data.phone_number = locationCart.phone_number;
      }

      if (locationCart.pick_up_at_the_bar == true) {
        data.pick_up_at_the_bar = locationCart.pick_up_at_the_bar;
      }
      if (orderStorageIds !== null) {
        data.order_storage_ids = orderStorageIds;
      }

      return $.ajax({
        type: 'POST',
        url: '/ajax/order/get_cart',
        data: data,
      })
        .done(function (data) {
          setTimeout(() => {
            setLastOrderDetails();
          }, 500);

          if (
            locationCart.number_of_products > 0 ||
            locationCart.table_number
          ) {
            //Dimiss SubProductCategoryMdal
            if ($('#pos-sub-product-category-product-modal').length) {
              $('#pos-sub-product-category-product-modal').remove();
            }

            locationCart.amount_without_discount = locationCart.products.reduce(
              (total, product) =>
                total +
                parseFloat(product.amount * product.original_product_price),
              0
            );

            $('#show-giftcard-section').prop('disabled', false);
            $('.classic-mobile-cart #show-giftcard-section').prop(
              'disabled',
              false
            );

            $('#show-customer-modal').prop('disabled', false);
            $('.classic-mobile-cart #show-customer-modal').prop(
              'disabled',
              false
            );
            // Enable checkout-actions-container buttons
            $('.checkout-actions-container #show-giftcard-section').prop(
              'disabled',
              false
            );
            $('.checkout-actions-container #show-customer-modal').prop(
              'disabled',
              false
            );
            if (
              locationCart.products.split_products &&
              locationCart.products.split_products.length > 0
            ) {
              $('#split-by-sum').prop('disabled', true);
            }

            if (
              locationCart.customer_id ||
              locationCart.customer_contact_person_id
            ) {
              $(
                '.checkout-header .header-container .actions #show-customer-modal'
              )
                .css('background-color', '#28a745')
                .css('border-color', '#28a745');
              $('.checkout-actions-container #show-customer-modal')
                .css('background-color', '#28a745')
                .css('border-color', '#28a745')
                .css('color', '');
            }
          } else {
            // Disable checkout-actions-container buttons when cart is empty
            setTimeout(() => {
              $('.checkout-action:disabled').each(function () {
                const orderCards = $('.order-card').not('.clone');

                if (orderCards.length) {
                  const orderCardIds = orderCards
                    .map(function () {
                      return $(this).attr('id');
                    })
                    .get();

                  if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
                    $(this).attr(
                      'title',
                      'Vennligst vent, det pågår en betaling'
                    );
                  }
                } else {
                  $(this).attr('title', 'Legg produkter i Checkout først');
                }
              });
            }, 300);
            $('.checkout-actions-container #show-giftcard-section').prop(
              'disabled',
              true
            );
            $('.checkout-actions-container #show-customer-modal').prop(
              'disabled',
              true
            );

            $('.checkout-actions-container #show-customer-modal')
              .css('background-color', '')
              .css('border-color', '')
              .css('color', '');
          }
          //updated html
          if (data.html !== undefined && data.html !== null) {
            // Full checkout update
            if ($('#product-extra-modal').length) {
              $('#product-extra-modal').remove();
            }
            if ($('.modal-backdrop').length) {
              $('.modal-backdrop').remove();
            }
            if (
              !$('#open-cart').hasClass('d-none') &&
              locationCart.share_amount > 0
            ) {
              $('#open-cart').trigger('click');
            }

            if (data.hasSplited) {
              $('#content').append(data.html);
              $('#split-by-sum').prop('disabled', true);
            } else {
              $('#checkout').empty();
              $('#checkout').html(data.html);
              $('#checkout-mobile').empty();
              $('#checkout-mobile').html(data.html);

              // Reapply button positioning after DOM replacement
              setTimeout(() => {
                // IMPORTANT: Reapply flexbox layout after DOM replacement
                applyFlexboxCartLayout();
              }, 10);

              setTimeout(() => {
                applyTableNumberRestrictions();
              }, 100);
            }

            if (
              $('body').attr('is_verifone') &&
              $(
                '.order-button[data-payment-method="payment_verifone_terminal"]'
              ).hasClass('d-none-custom')
            ) {
              $(
                '.order-button[data-payment-method="payment_verifone_terminal"]'
              ).removeClass('d-none-custom');
            }

            handlePostCheckoutLogic(data, autoPayWithTerminal);
          } else if (
            data.productContainerHtml !== undefined &&
            data.productContainerHtml !== null
          ) {
            // Partial update - only replace cart products container
            if ($('#product-extra-modal').length) {
              $('#product-extra-modal').remove();
            }
            if ($('.modal-backdrop').length) {
              $('.modal-backdrop').remove();
            }

            // Verify the container exists before replacing
            if ($('#checkout .cart-products-container').length === 0) {
              return;
            }

            // Update only the cart products container in both desktop and mobile
            $('#checkout .cart-products-container').replaceWith(
              data.productContainerHtml
            );
            $('#checkout-mobile .cart-products-container').replaceWith(
              data.productContainerHtml
            );
            // Update order summary if provided
            if (
              data.orderSummaryHtml !== undefined &&
              data.orderSummaryHtml !== null
            ) {
              // Check if order summary exists and replace it
              if ($('#checkout .order-summary').length > 0) {
                $('#checkout .order-summary').replaceWith(
                  data.orderSummaryHtml
                );
              }
              // Uncomment if you need mobile support:
              if ($('#checkout-mobile .order-summary').length > 0) {
                $('#checkout-mobile .order-summary').replaceWith(
                  data.orderSummaryHtml
                );
              }
            }

            // Apply table number restrictions after partial update
            setTimeout(() => {
              applyTableNumberRestrictions();
            }, 100);

            handlePostCheckoutLogic(data, autoPayWithTerminal);
          }
          //end of updated html
          applyWastageMode();
          // To show toast about low stock inventory
          if (data.current_pr_low_stock) {
            const currentStockQty = data.stockQty ?? 0;
            showToast({
              type: 'warning',
              title: 'Advarsel om lite lager',
              message: `Dette produktet er nesten tomt på lager! Kun "${currentStockQty}" igjen.`,
              position: 'top-bottom',
              duration: 4000,
            });
          } else {
            if (
              data.low_stock_menu_items &&
              data.low_stock_menu_items.length > 0
            ) {
              data.low_stock_menu_items.forEach((item, index) => {
                if (item.is_menu_product_low_stock) {
                  const currentStockQty = item.stockQty ?? 0;
                  setTimeout(
                    () => {
                      showToast({
                        type: 'warning',
                        title: 'Advarsel om lite lager',
                        message: `Dette menyproduktet "${item.name}" er nesten utsolgt! Kun "${currentStockQty}" igjen.`,
                        position: 'top-bottom',
                        duration: 4000,
                      });
                    },
                    index === 0 ? 50 : index * 4200
                  );
                }
              });
            }
          }

          if (data.wsOrderData) {
            if (!$('#open-cart').hasClass('d-none')) {
              if (window.innerWidth < 768) {
                $('.quick-order-payment-container').css({
                  display: 'flex',
                  'flex-wrap': 'wrap',
                  gap: '3px',
                  'max-width': '216px',
                  'max-height': '220px',
                  overflow: 'hidden auto',
                });
              } else {
                $(
                  '.quick-order-payment-container.desktop > .payment-buttons-wrapper'
                )
                  .removeClass('d-none')
                  .addClass('d-flex');
                $('.quick-order-payment-container:not(.desktop)').show();
              }
            }

            $('.quick-order-total-price').text(
              formattedPriceToShow(
                data.wsOrderData.total_with_discount ||
                  data.wsOrderData.exchange_amount
              )
            );

            $('.quick-order-quantity').text(
              data.wsOrderData.products.reduce(
                (total, product) => total + parseFloat(product.quantity),
                0
              )
            );

            const totalQuantity = data.wsOrderData.products.reduce(
              (total, product) => total + parseFloat(product.quantity),
              0
            );

            if (totalQuantity > 0) {
              $('.small-cart-container').addClass('has-products');
              if (!locationCart.is_per_person_ordering_enabled) {
                $('.reset-classic-shopping-cart-mini').removeClass(
                  'd-none-custom'
                );
              }
              $('#previousSaleBar').css({
                bottom: !prevSaleTimeoutId
                  ? '-200px'
                  : `${$('.small-cart-container.mobile').outerHeight() + 2.5}px`,
              });
            } else {
              $('.small-cart-container').removeClass('has-products');
              $('.reset-classic-shopping-cart-mini').addClass('d-none-custom');
            }

            $('.checkout-action').each(function () {
              const orderCards = $('.order-card').not('.clone');
              if (orderCards.length) {
                const orderCardIds = orderCards
                  .map(function () {
                    return $(this).attr('id');
                  })
                  .get();
                if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
                  $(this).prop('disabled', true);
                  $(this).attr(
                    'title',
                    'Vennligst vent, det pågår en betaling'
                  );
                } else {
                  $(this).prop('disabled', false);
                }
              } else {
                if ($(this).attr('data-terminal-type') != '2') {
                  $(this).prop('disabled', false);
                } else {
                  $(this).prop('disabled', true);
                }
              }
            });

            // Disabled Exchange button if there is products in the cart
            $('.cash-exchange-button').prop(
              'disabled',
              locationCart.products.length > 0
            );

            // Apply same logic to quick-order-buttons (mini checkout)
            $('.quick-order-button').each(function () {
              const orderCards = $('.order-card').not('.clone');

              if (orderCards.length) {
                const orderCardIds = orderCards
                  .map(function () {
                    return $(this).attr('id');
                  })
                  .get();
                if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
                  $(this).prop('disabled', true);
                  $(this).attr(
                    'title',
                    'Vennligst vent, det pågår en betaling'
                  );
                } else if (locationCart.products.length > 0) {
                  $(this).prop('disabled', false);
                  $(this).removeAttr('title');
                }
              } else if (locationCart.products.length > 0) {
                if ($(this).attr('data-terminal-type') != '2') {
                  $(this).prop('disabled', false);
                } else {
                  $(this).prop('disabled', true);
                }
                $(this).removeAttr('title');
              }
            });

            $('.quick-order-total-price').addClass('scale-up');
            setTimeout(() => {
              $('.quick-order-total-price').removeClass('scale-up');
              if (data.wsOrderData.total_with_discount > 0) {
                $('.quick-order-button')
                  .filter(function () {
                    return (
                      $(this).attr('data-payment-method') !==
                      'payment_verifone_terminal'
                    );
                  })
                  .prop('disabled', false);
              }
            }, 200);
            sendUpdateToServer(data.wsOrderData);
          }

          if (hasDoubleClickedProduct) {
            const quickOrderButton = $('.quick-order-button').first();
            locationCart.order_storage_identifier = '';
            const paymentMethod = quickOrderButton.attr('data-payment-method');
            locationCart.payment_method = paymentMethod;
            if (
              paymentMethod === 'payment_terminal' ||
              paymentMethod === 'payment_verifone_terminal'
            ) {
              locationCart.terminal_id =
                quickOrderButton.attr('data-terminal-id');
            }

            if (paymentMethod === 'payment_split') {
              getPaymentSplitModal(locationCart);
            } else {
              $('form#order_register_form').submit();
            }
          }

          $('.order-card').each(function () {
            const terminalId = $(this).attr('id');
            const terminalOrderButton = $(
              ".order-button[data-terminal-id='" + terminalId + "']"
            );

            terminalOrderButton.prop('disabled', true);
            terminalOrderButton.attr(
              'title',
              'Vennligst vent, det pågår en betaling'
            );
            const quickOrderButton = $(
              ".quick-order-button[data-terminal-id='" + terminalId + "']"
            );
            quickOrderButton.prop('disabled', true);
            quickOrderButton.attr(
              'title',
              'Vennligst vent, det pågår en betaling'
            );
          });

          if (locationCart.is_per_person_ordering_enabled) {
            $('.quick-order-payment-container:not(.desktop)').show();

            if (
              data.perPersonOrderingActions != undefined &&
              data.perPersonOrderingActions != null
            ) {
              $('.reset-classic-shopping-cart-mini').addClass('d-none-custom');
              $('#small-cart-payment-buttons-wrapper').addClass('d-none');

              $('#small-cart-per-person-ordering-actions').html(
                data.perPersonOrderingActions
              );

              $('.show-on-per-person-ordering').removeClass('d-none');
              $('.hide-on-per-person-ordering').addClass('d-none');

              $('.small-cart-container').addClass('has-products');
              $('#previousSaleBar').css({
                bottom: !prevSaleTimeoutId
                  ? '-200px'
                  : `${$('.small-cart-container.mobile').outerHeight() + 2.5}px`,
              });
              $('#open-cart-mobile').addClass('has-products');

              $('#small-cart-table-name').text(
                data.tableName ? `Bord ${data.tableName}` : ''
              );
            }

            if (locationCart.products.length === 0) {
              $('.put-on-person-btn').each(function () {
                if (!$(this).hasClass('d-none')) {
                  $(this).addClass('d-none');
                }
              });

              $('.next-person-btn').each(function () {
                if ($(this).hasClass('d-none')) {
                  $(this).removeClass('d-none');
                }
              });
            } else {
              $('.put-on-person-btn').each(function () {
                if ($(this).hasClass('d-none')) {
                  $(this).removeClass('d-none');
                }
              });
              $('.next-person-btn').each(function () {
                if (!$(this).hasClass('d-none')) {
                  $(this).addClass('d-none');
                }
              });
            }
          }

          if ($('body').attr('is_verifone') !== '1') {
            checkTerminalAvailability();
          }

          adjustCheckoutActionsHeight();
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
          cartQuickPaymentTerminalLock = false;
        });
    };

    $(document).on('click', '.add-tips', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let tipsPercent = parseInt($(this).attr('data-tips-percent'));
      if (tipsPercent === locationCart.tips_percent) {
        locationCart.tips_percent = 0;
        $(this).removeClass('btn-primary');
        $(this).addClass('btn-light');
      } else {
        locationCart.tips_percent = tipsPercent;
        $('.add-tips').removeClass('btn-primary');
        $('.add-tips').addClass('btn-light');
        $(this).removeClass('btn-light');
        $(this).addClass('btn-primary');
      }
      updateTips();
      if (locationCart.tips_percent == 0) {
        if (!$('.cart-summary-total').hasClass('d-none')) {
          $('.cart-summary-total').addClass('d-none');
        }
        if (!$('.cart-summary-tips').hasClass('d-none')) {
          $('.cart-summary-tips').addClass('d-none');
        }
      } else {
        if ($('.cart-summary-total').hasClass('d-none')) {
          $('.cart-summary-total').removeClass('d-none');
        }
        if ($('.cart-summary-tips').hasClass('d-none')) {
          $('.cart-summary-tips').removeClass('d-none');
        }
      }
    });

    function updateTips() {
      $('#cart-tips-percent').text(locationCart.tips_percent);
      let locationAmount = $('#cart-amount').data('total-price');
      let tips = (locationAmount * locationCart.tips_percent) / 100;
      $('#cart-tips').text(tips.toFixed(2).replace('.', ','));
      let amountWithTips = (locationAmount + tips).toFixed(2);
      $('#cart-amount-with-tips').text(amountWithTips.replace('.', ','));
      $('#order-button-amount').text(amountWithTips.replace('.', ','));
      $('#tipping').val(
        ((locationAmount * locationCart.tips_percent) / 100)
          .toFixed(2)
          .replace('.', ',')
      );
    }

    $(document).on('click', '.cart-add-product', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let productId = $(this).data('product-id');
      let productIndex = parseFloat($(this).data('cart-index'));
      let productAmount = parseFloat(
        locationCart.products[productIndex].amount
      );
      let cartAmount = parseFloat(locationCart.number_of_products);

      productAmount += 1;
      cartAmount += 1;

      if (
        locationCart.products[productIndex].reserved_quantity &&
        productAmount > locationCart.products[productIndex].reserved_quantity
      ) {
        showToast({
          type: 'error',
          message:
            'Mengden av dette produktet kan ikke overstige den reserverte mengden.',
          position: 'bottom-left',
          duration: 4000,
        });
        return;
      }

      locationCart.products[productIndex].amount = productAmount;
      if (locationCart.products[productIndex].amount_added_by_cart) {
        locationCart.products[productIndex].amount_added_by_cart =
          parseFloat(locationCart.products[productIndex].amount_added_by_cart) +
          1;
      } else {
        locationCart.products[productIndex].amount_added_by_cart = 1;
      }

      locationCart.number_of_products = cartAmount;
      let productPrice = parseFloat(
        $(this)
          .siblings('.cart-product-amount')
          .data('product-price-incl-vat') || '0'
      );
      let productTotalPrice = (productPrice * productAmount).toFixed(2);
      $(this)
        .closest('td')
        .find('.product-total-price')
        .text(productTotalPrice.replace('.', ','));
      // $(this).siblings(".cart-product-amount").text(productAmount.toFixed(2));
      $('input#product-id-' + productId).val(productAmount);
      $('input#product-cart-index-' + productIndex).val(productAmount);
      addPriceToCart(productPrice);
      locationCart.amount_without_discount = floor(
        locationCart.products.reduce(
          (total, product) =>
            total +
            parseFloat(
              (product.amount * product.original_product_price).toFixed(2)
            ),
          0
        )
      );
      updateCartSummary();
      updateCartProducts();
    });

    $(document).on('click', '.cart-remove-product', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      const $btn = $(this);
      const productId = $btn.data('product-id');
      const productIndex = parseFloat($btn.data('cart-index'));
      const productInCart = locationCart.products[productIndex];
      const productPrice = parseFloat(
        $btn.siblings('.cart-product-amount').data('product-price-incl-vat') ||
          '0'
      );

      const addedAmount =
        locationCart.products[productIndex].amount_added_by_cart ?? null;

      if (
        (productInCart.product_assignment_id ||
          productInCart.session_product_id) &&
        (!productInCart.has_split || productInCart.has_split != 'true') &&
        (!addedAmount || parseInt(addedAmount) <= 0)
      ) {
        const assignmentId = productInCart.product_assignment_id;

        $('#void-single-assignment-confirm, #put-back-to-table-confirm')
          .attr('data-session-product-id', productInCart.session_product_id)
          .attr('data-product-assignment-id', assignmentId)
          .attr('data-product-id', productId)
          .attr('data-product-index', productIndex)
          .attr('data-product-price', productPrice);

        $('#table-product-removing-modal').modal('show');
        return;
      } else if (
        productInCart.has_split == 'true' &&
        (!addedAmount || addedAmount <= 0)
      ) {
        showToast({
          type: 'error',
          message:
            'Dette produktet har blitt delt opp i flere produkter, og kan ikke fjernes herfra.',
          position: 'bottom-left',
          duration: 4000,
        });
        return;
      }

      decreaseProductInCart(productIndex, productId, productPrice);
    });

    $(document).on('click', '#void-single-assignment-confirm', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      const productIndex = $(this).attr('data-product-index');
      const sessionProductId = $(this).attr('data-session-product-id');
      const productAssignmentId = $(this).attr('data-product-assignment-id');
      const productPrice = $(this).attr('data-product-price');
      const productId = $(this).attr('data-product-id');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/session-products/void-one',
        data: { sessionProductId, productAssignmentId },
        success: function (response) {
          const { data, message } = response;
          if (data.success === true) {
            showToast({
              type: 'success',
              message: message || 'Produkt annullert.',
              position: 'bottom-left',
              duration: 1500,
            });

            decreaseProductInCart(productIndex, productId, productPrice);
            $('#table-product-removing-modal').modal('hide');
          }
        },
        error: function (response) {
          if (response.responseJSON?.redirect_url) {
            document.location.href = response.responseJSON.redirect_url;
          }

          if (response.responseJSON?.message) {
            showToast({
              type: 'error',
              message: response.responseJSON.message,
              position: 'bottom-left',
              duration: 2000,
            });
          }
        },
      });
    });

    $(document).on('click', '#put-back-to-table-confirm', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      const productIndex = $(this).attr('data-product-index');
      const productAssignmentId = $(this).attr('data-product-assignment-id');
      const productPrice = $(this).attr('data-product-price');
      const productId = $(this).attr('data-product-id');

      if (productAssignmentId) {
        $.ajax({
          type: 'POST',
          url: '/api/v1/private/session-products/put-back-to-table',
          data: {
            productAssignmentId,
          },
          success: function (response) {
            const { data, message } = response;
            if (data.success) {
              showToast({
                type: 'success',
                message: message || 'Produkt lagt tilbake på bordet.',
                position: 'bottom-left',
                duration: 1500,
              });

              $('#table-product-removing-modal').modal('hide');

              decreaseProductInCart(productIndex, productId, productPrice);
            }
          },
          function(data) {
            if (data.responseJSON?.redirect_url) {
              document.location.href = data.responseJSON.redirect_url;
            }

            if (data.responseJSON?.message) {
              showToast({
                type: 'error',
                message: data.responseJSON.message,
                position: 'bottom-left',
                duration: 2000,
              });
            }
          },
        });
      } else {
        showToast({
          type: 'success',
          message: 'Produkt lagt tilbake på bordet.',
          position: 'bottom-left',
          duration: 1500,
        });

        $('#table-product-removing-modal').modal('hide');

        decreaseProductInCart(productIndex, productId, productPrice);
      }
    });

    function decreaseProductInCart(productIndex, productId, productPrice) {
      const product = locationCart.products[productIndex];
      let productAmount = parseFloat(product.amount);
      let cartAmount = parseFloat(locationCart.number_of_products);
      const addedAmount =
        locationCart.products[productIndex].amount_added_by_cart ?? null;

      if (addedAmount && addedAmount > 0) {
        locationCart.products[productIndex].amount_added_by_cart -= 1;
      }
      let subtractedAmount; // how much we actually subtract from cart total
      if (productAmount > 0 && productAmount < 1) {
        subtractedAmount = productAmount; // remove the fraction completely
        productAmount = 0;
      } else {
        subtractedAmount = 1;
        productAmount -= 1;
      }

      cartAmount -= subtractedAmount;
      product.amount = productAmount;
      locationCart.number_of_products = cartAmount;

      subtractPriceToCart(productPrice * subtractedAmount);
      $('input#product-id-' + productId).val(productAmount);
      $('input#product-cart-index-' + productIndex).val(productAmount);

      locationCart.amount_without_discount = floor(
        locationCart.products.reduce(
          (total, p) =>
            total +
            parseFloat((p.amount * p.original_product_price).toFixed(2)),
          0
        )
      );

      updateCartSummary();
      updateCartProducts();
      if (
        locationCart.products.length === 0 &&
        !locationCart.is_per_person_ordering_enabled
      ) {
        emptyCart();
        $('#checkout').empty();
        $('#checkout-mobile').empty();
      }
    }

    $(document).on('change', '#table_number', function () {
      let tableNumber = $(this).val();
      locationCart.table_number = tableNumber;
    });

    $(document).on('change', '#name', function () {
      let name = $(this).val();
      locationCart.name = name;
    });

    $(document).on('change', '#phone_number', function () {
      let phoneNumber = $(this).val();
      locationCart.phone_number = phoneNumber;
    });

    $(document).on('change', '#pickup_date', function () {
      let pickupDate = $(this).val();
      locationCart.pickup_date = pickupDate;
    });

    $(document).on('change', '#pickup_time', function () {
      let pickupTime = $(this).val();
      locationCart.pickup_time = pickupTime;
    });

    function subtractPriceToCart(productPrice) {
      locationCart.amount = locationCart.amount - productPrice;
    }

    function addPriceToCart(productPrice) {
      locationCart.amount = locationCart.amount + productPrice;
    }

    $(document).on('click', '#cart-comment-button', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      if ($('#cart-comment').hasClass('d-none')) {
        $('#cart-comment').removeClass('d-none');
      } else {
        $('#cart-comment').addClass('d-none');
      }
      return false;
    });

    $(document).on('click', '#product-extra-comment-button', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      if ($('#product-extra-comment').hasClass('d-none')) {
        $('#product-extra-comment').removeClass('d-none');
      }
      if ($('#product-extra-comment-label').hasClass('d-none')) {
        $('#product-extra-comment-label').removeClass('d-none');
      }
      $(this).remove();
    });

    $(document).on('change', '#cart-comment', function () {
      locationCart.comment = $('#cart-comment').val();
    });

    $(document).on('click', '#term-button', function () {
      return false;
    });

    $(document).on('click', '.get-products', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let btn = $(this);
      locationId = $(this).attr('data-location-id');
      let locationType = $(this).attr('data-location-type');

      if (locationCart.number_of_products > 0) {
        changeLocationType(locationId, locationType, locationCart).done(
          function (data) {
            if (data.are_products_available === false) {
              let confirmMessage = btn.attr(
                'data-location-type-confirm-message'
              );
              if (!confirm(confirmMessage)) {
                $(
                  "input[name='inlineRadioOptions'][data-location-type='" +
                    locationType +
                    "']"
                ).prop('checked', false);
                $(
                  "input[name='inlineRadioOptions'][data-location-type='" +
                    locationCart.location_type +
                    "']"
                ).prop('checked', true);
                return false;
              }
              emptyCart();
            } else {
              locationCart.amount = data.cart_total_price;
            }
            locationCart.location_type = locationType;
            updateCartSummary();
            getProducts(locationId, locationType, locationCart.products);
          }
        );
      } else {
        locationCart.location_type = locationType;
        getProducts(locationId, locationType);
      }
    });

    $(document).on('submit', '#classic-pos-promocode', function (e) {
      e.preventDefault();
      activatePromoCode();
    });

    function activatePromoCode() {
      let promoCode = $('#classic_promo_code').val();
      const searchString = $('#search_string').val();
      let activeCategoryId = $('#nav-scroll-container .nav-link.active').data(
        'category-id'
      );
      if (promoCode == '') {
        return false;
      }

      let promoCodeIsValid = false;
      checkPromoCode(locationId, promoCode, function (promoCodeIsValidBool) {
        promoCodeIsValid = promoCodeIsValidBool;
      });

      setTimeout(function () {
        if (!promoCodeIsValid) {
          if ($('#promocode-error').hasClass('d-none')) {
            $('#promocode-error').removeClass('d-none');
          }
          return false;
        } else {
          $('#promocodeFormModal').modal('hide');
          locationCart.promo_code = promoCode;
          let promocodeFormData = new FormData();
          promocodeFormData.append('event_id', locationId);
          promocodeFormData.append('product_category_id', activeCategoryId);
          promocodeFormData.append('promo_code', promoCode);
          promocodeFormData.append('location_type', locationType);
          promocodeFormData.append('search_string', searchString);
          formData.append('pos_type', posType);
          searchProductList(promocodeFormData, activeCategoryId);
          popupAlert();
        }
      }, 1000);
    }

    function checkPromoCode(locationId, promoCode, promoCodeIsValid) {
      $.ajax({
        type: 'POST',
        url: '/ajax/event/check_promo_code',
        data: {
          location_id: locationId,
          promo_code: promoCode,
        },
      })
        .done(function (data) {
          if (
            data.promo_code_is_valid !== undefined &&
            data.promo_code_is_valid !== null &&
            data.promo_code_is_valid == true
          ) {
            promoCodeIsValid(true);
          } else {
            promoCodeIsValid(false);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function changeLocationType(locationId, locationType, locationCart) {
      return $.ajax({
        type: 'POST',
        url: '/ajax/event/change_location_type',
        data: {
          location_id: locationId,
          location_type: locationType,
          products: locationCart.products,
        },
      })

        .done(function (data) {
          return {
            are_products_available: data.are_products_available,
            cart_total_price: data.cart_total_price,
          };
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function getProducts(
      locationId,
      locationType,
      products = null,
      promoCode = null,
      shop_type = null
    ) {
      $.ajax({
        type: 'POST',
        url: '/ajax/event/get_products',
        data: {
          location_id: locationId,
          location_type: locationType,
          products: products,
          promo_code: promoCode,
          shop_type,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#classic-location-products').remove();
            if ($('#location-type-buttons').length) {
              $('#location-type-buttons').after(data.html);
            } else if ($('#location-promo-code-form-wrapper').length) {
              $('#location-promo-code-form-wrapper').after(data.html);
            } else {
              $('#location').after(data.html);
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function emptyCart(
      emptyCartStatus = 'order_cancelled',
      tableSessionId = null
    ) {
      setLastOrderDetails();
      locationCart.order_storage_identifier = '';
      locationCart.order_storage_ids = [];
      locationCart.number_of_products = 0;
      locationCart.amount = 0;
      locationCart.products = [];
      locationCart.order_discount_percent = 0;
      locationCart.amount_without_discount = 0;
      locationCart.checkout_type = '';
      locationCart.table_guest_id = '';
      locationCart.table_session_id = '';
      locationCart.customer_id = '';
      locationCart.terminal_id = '';
      locationCart.giftcard_code = '';
      locationCart.giftcards = [];
      locationCart.customer_contact_person_id = '';
      locationCart.is_takeaway_checked =
        hasEnabledDefaultOrderAsTakeaway == 1 ? 1 : 0;
      locationCart.checkout_type = 'normal';
      locationCart.table_id = null;
      delete locationCart.is_per_person_ordering_enabled;
      delete locationCart.is_new_guest;
      delete locationCart.share_amount;
      delete locationCart.order_id;

      $('.hide-on-per-person-ordering').removeClass('d-none');
      $('.show-on-per-person-ordering').addClass('d-none');
      $('#small-cart-table-name').text('');
      $('#small-cart-per-person-ordering-actions').empty();

      $('.small-cart-container').removeClass('has-products');
      $('.reset-classic-shopping-cart-mini').addClass('d-none-custom');
      $('#previousSaleBar').css({ bottom: '0' });

      // Reset takeaway button state
      $('.alt_price_button').removeClass('active');
      $('.checkout-header .header-container .label').text('Checkout');

      // Remove green color from customer button when customer is cleared
      $('.checkout-header .header-container .actions #show-customer-modal')
        .css('background-color', '')
        .css('border-color', '')
        .css('color', '');
      $('.checkout-actions-container #show-customer-modal')
        .css('background-color', '')
        .css('border-color', '')
        .css('color', '');

      locationCart.share_amount = 0;
      locationCart.exchange_amount = 0;
      locationCart.comment = '';
      orderStorageIds = null;
      renderAppliedGiftCards();
      updateCartSummary();

      updateCartProducts().always(function () {
        if (
          emptyCartStatus === 'order_complete' ||
          emptyCartStatus === 'completed_share_by_amount'
        ) {
          showOrderSuccessCheckmark();
        }

        if (tableSessionId) {
          showTableSessionDetails(tableSessionId);
        }
      });

      selectedCustomerId = null;

      $('#comment-box').val('');
      $('#table-name').text('');
      $('#small-cart-table-name').text('');

      $('.quick-order-total-price').text(formattedPriceToShow(0));
      $('.quick-order-button')
        .filter(function () {
          return (
            $(this).attr('data-payment-method') !== 'payment_verifone_terminal'
          );
        })
        .prop('disabled', false);
      $('.quick-order-payment-container.desktop > .payment-buttons-wrapper')
        .removeClass('d-flex')
        .addClass('d-none');
      $('.quick-order-quantity').text('0');
      $('.quick-order-payment-container:not(.desktop)').hide();
      $('.product-qty-button').attr('disabled', false);
      $('.product-qty-button').css('cursor', 'pointer');

      $('.classic-products-container').css({
        opacity: '',
        'pointer-events': '',
        cursor: '',
      });

      // Disable checkout-actions-container buttons when cart is empty
      $('.checkout-actions-container #show-giftcard-section').prop(
        'disabled',
        true
      );
      $('.checkout-actions-container #show-customer-modal').prop(
        'disabled',
        true
      );
      $('.checkout-actions-container #show-customer-modal')
        .css('background-color', '')
        .css('border-color', '')
        .css('color', '');

      const POSId = localStorage.getItem('deviceID');
      $('.customer-item').removeClass('selected');
      sendUpdateToServer({
        type: emptyCartStatus,
        deviceId: POSId,
      });
    }

    emptyAllCart = function (emptyCartStatus, tableSessionId) {
      emptyCart(emptyCartStatus, tableSessionId);
    };

    if ($('.clear-shopping-cart').length) {
      emptyCart();
    }

    $(document).on(
      'click',
      '.checkout-actions-container .checkout-action[data-payment-method]',
      function (event) {
        if (
          getAppliedGiftCards().length > 0 &&
          $(this).attr('data-payment-method') !== 'payment_giftcard'
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return false;
        }
      }
    );

    $(document).on('click', '.order-button', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      locationCart.order_storage_identifier = '';
      const paymentMethod = $(this).attr('data-payment-method');
      locationCart.payment_method = paymentMethod;
      if (
        paymentMethod === 'payment_terminal' ||
        paymentMethod === 'payment_verifone_terminal'
      ) {
        locationCart.terminal_id = $(this).attr('data-terminal-id');
        locationCart.terminal_type = $(this).attr('data-terminal-type');
        setTimeout(() => {
          $(this).prop('disabled', true);
          $(this).attr('title', 'Vennligst vent, det pågår en betaling');
        }, 300);
      }
    });

    $(document).on('click', '.quick-order-button', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }

      if (locationCart.is_per_person_ordering_enabled) {
        $('#open-cart').trigger('click');
        return;
      }

      locationCart.order_storage_identifier = '';
      const paymentMethod = $(this).attr('data-payment-method');
      locationCart.payment_method = paymentMethod;
      if (
        paymentMethod === 'payment_terminal' ||
        paymentMethod === 'payment_verifone_terminal'
      ) {
        locationCart.terminal_id = $(this).attr('data-terminal-id');
      }

      if (paymentMethod === 'payment_split') {
        getPaymentSplitModal(locationCart);
      } else {
        $('form#order_register_form').submit();
      }
    });

    $(document).on('click', '.close-terminals', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $('#terminal-list-model').modal('hide');
      return false;
    });

    let order_ajax_lock = false;

    $(document).on('submit', '#order_register_form', function (e) {
      e.preventDefault();

      if (
        isVerifone &&
        (!$('body').attr('is-verifone-session-started') ||
          $('body').attr('is-verifone-session-started') == '0') &&
        locationCart.payment_method === 'payment_verifone_terminal' &&
        (locationCart.terminal_id == undefined ||
          locationCart.terminal_id == '')
      ) {
        checkVerifoneSDKState();
        return;
      }
      const cashPaymentActivation = $('#cash_payment_activation').data(
        'cash-payment-activation'
      );

      if (
        locationCart.products.length === 0 &&
        !locationCart.share_amount &&
        !locationCart.exchange_amount
      ) {
        return;
      }

      if (locationCart.payment_method === 'payment_split') {
        if (isPreventToPayInvoice($(this))) {
          showToast({
            type: 'error',
            title: 'Ugyldig betalingsmetode',
            message: 'Faktura produkter kan ikke betale',
            position: 'bottom-right',
            duration: 5000,
          });
          return;
        }
        getPaymentSplitModal(locationCart);
        return;
      }

      if (
        locationCart.payment_method === 'payment_giftcard' &&
        getAppliedGiftCardTotal() + 0.009 < getGiftCardOrderTotal()
      ) {
        renderAppliedGiftCards();
        return;
      }

      if (locationCart.payment_method !== 'payment_credit') {
        locationCart.customer_id = '';
        // Remove green color from customer button when customer is cleared
        $('.checkout-header .header-container .actions #show-customer-modal')
          .css('background-color', '')
          .css('border-color', '')
          .css('color', '');
        $('.checkout-actions-container #show-customer-modal')
          .css('background-color', '')
          .css('border-color', '')
          .css('color', '');
      }

      $('div.loader').remove();
      $('.order-button').attr('disabled', true);

      if (!order_ajax_lock) {
        const isTripleTexInvoicePayment =
          locationCart.products.length == 1 &&
          locationCart.products[0].invoice_id > 0;
        if (isTripleTexInvoicePayment) {
          $('#tripletex-payment-progress-modal').modal('show');
        } else if (cashPaymentActivation !== 1) {
          $(this).after('<div class="loader"></div>');
        }
        order_ajax_lock = true;

        if ($('#pick-up-at-the-bar') && $('#pick-up-at-the-bar').length) {
          locationCart.pick_up_at_the_bar = true;
        }

        let newOrderData = {
          location_id: locationId,
          location_type: locationCart.location_type,
          table_number: locationCart.table_number,
          products: locationCart.products,
          tips_percent: locationCart.tips_percent,
          payment_method: locationCart.payment_method,
          terminal_id:
            locationCart.terminal_id ||
            localStorage.getItem('verifoneSerialNumber') ||
            '',
          comment: locationCart.comment,
          name: locationCart.name,
          phone_number: locationCart.phone_number,
          pickup_date: locationCart.pickup_date,
          pickup_time: locationCart.pickup_time,
          promo_code: locationCart.promo_code,
          custom_pickup_time: $('#custom_pickup_time').val(),
          pick_up_at_the_bar: locationCart.pick_up_at_the_bar,
          order_storage_identifier: locationCart.order_storage_identifier,
          userId,
          customer_number: locationCart.customer_id,
          customer_contact_person_id: locationCart.customer_contact_person_id,
          shop_type,
          giftcard_code: locationCart.giftcard_code,
          giftcards: locationCart.giftcards || [],
          is_printed: window.ReactNativeWebView ? 1 : 0,
          terminal_number:
            $(
              "button.checkout-action.terminal[data-terminal-id='" +
                locationCart.terminal_id +
                "']"
            ).attr('data-terminal-number') || '',
          is_takeaway: locationCart.is_takeaway_checked,
          table_session_id: locationCart.table_session_id,
          table_guest_id: locationCart.table_guest_id,
          booking_reference: locationCart.booking_reference || null,
          booking_id: locationCart.booking_id || null,
          isSessionLastPurchase: locationCart.isSessionLastPurchase || false,
          invoice_reference: $('#invoice-reference').val() || null,
          exchange_amount: locationCart.exchange_amount,
        };

        if (orderStorageIds !== null) {
          newOrderData.order_storage_ids = orderStorageIds;
        }

        if (
          locationCart.share_amount &&
          locationCart.share_amount > 0 &&
          locationCart.table_session_id &&
          locationCart.table_session_id !== '' &&
          locationCart.table_guest_id &&
          locationCart.table_guest_id !== ''
        ) {
          var tempCartData = { ...locationCart };

          if (locationCart.payment_method === 'payment_verifone_terminal') {
            emptyCart();
          }

          createShareBySumOrder(
            {
              amount: tempCartData.share_amount,
              payment_method: tempCartData.payment_method,
              table_session_id: tempCartData.table_session_id,
              table_guest_id: tempCartData.table_guest_id,
              location_id: tempCartData.location_id,
              organizer_id: organizerId,
              terminal_id: tempCartData.terminal_id,
              terminal_number: tempCartData.terminal_number,
              gift_code: tempCartData.giftcard_code,
              products: tempCartData.products,
              is_printed: window.ReactNativeWebView ? 1 : 0,
            },
            tempCartData
          )
            .done((data) => {
              if (tempCartData.payment_method === 'payment_terminal') {
                removeOrderProcessStatus(tempCartData.terminal_id);
              }
            })
            .fail((data) => {
              if (tempCartData.payment_method === 'payment_terminal') {
                updateOrderProcessStatus(tempCartData.terminal_id, 'failed');
              }
            })
            .always(() => {
              $('div.loader').remove();
              $('.order-button').each(function () {
                if (
                  $(this).is('[data-toggle]') &&
                  ($(this).data('payment-method') === 'nets_card' ||
                    $(this).data('payment-method') === 'nets_vipps')
                ) {
                  $(this).prop('disabled', true);
                } else {
                  $(this).prop('disabled', false);
                }
              });

              order_ajax_lock = false;
              cartQuickPaymentTerminalLock = false;
            });
        } else {
          const requiresPaymentConfirmation =
            newOrderData.payment_method === 'payment_cash' ||
            newOrderData.payment_method === 'non_integrated_vipps';

          if (requiresPaymentConfirmation) {
            if (
              cashPaymentActivation == 1 ||
              cashPaymentActivation === true ||
              cashPaymentActivation === 'true'
            ) {
              const isVippsFreePayment =
                newOrderData.payment_method === 'non_integrated_vipps';
              $('#pay-with-cash-confirmation-text').toggleClass(
                'd-none',
                isVippsFreePayment
              );
              $('#pay-with-vipps-free-confirmation-text').toggleClass(
                'd-none',
                !isVippsFreePayment
              );

              $('#pay-with-cash-confirmation-modal').modal('show');

              // Set up event handlers for the modal buttons
              $('#pay-with-cash-confirm')
                .off('click')
                .on('click', function () {
                  if (hasBeenInactive) {
                    showClearCartConfirmation();
                    return;
                  }
                  $('#pay-with-cash-confirmation-modal').modal('hide');
                  $('#order_register_form').append(
                    '<div class="loader"></div>'
                  );
                  processOrder(newOrderData);
                });

              $('.pay-with-cash-cancel')
                .off('click')
                .on('click', function () {
                  if (hasBeenInactive) {
                    showClearCartConfirmation();
                    return;
                  }
                  // Abort any ongoing order request
                  if (currentOrderAjax && currentOrderAjax.readyState !== 4) {
                    currentOrderAjax.abort();
                    currentOrderAjax = null;
                  }
                  order_ajax_lock = false;
                  $('div.loader').remove();
                  $('.order-button').prop('disabled', false);
                });
              return false;
            }
          }

          if (
            newOrderData.exchange_amount &&
            newOrderData.exchange_amount > 0
          ) {
            if (
              locationCart.payment_method === 'payment_verifone_terminal' ||
              locationCart.payment_method === 'payment_terminal'
            ) {
              emptyCart();
            }
          }

          processOrder(newOrderData);
        }

        if (newOrderData.payment_method === 'payment_terminal') {
          const wrapper = $('#process-orders-with-terminal-payments');
          if (wrapper.hasClass('d-none')) {
            wrapper.removeClass('d-none');
            wrapper.addClass('d-flex');
          }
          const clonedOrderCard = $('.order-card.clone').clone();
          clonedOrderCard.removeClass('clone d-none');
          clonedOrderCard.addClass('processing');
          clonedOrderCard.attr('id', newOrderData.terminal_id);
          clonedOrderCard
            .find('.terminal-number')
            .text(newOrderData.terminal_number);
          const statusBadge = clonedOrderCard.find('.status-badge');
          statusBadge.addClass('processing text-primary');
          statusBadge.html(
            `Behandling <div class="spinner-border spinner-border-sm text-primary ml-2" role="status"><span class="sr-only">Loading...</span></div>`
          );
          clonedOrderCard
            .find('.order-items')
            .text(locationCart.number_of_products);

          const cancelButton = clonedOrderCard.find('.cancel-btn');
          cancelButton.addClass('cancel-btn-' + newOrderData.terminal_id);
          cancelButton
            .attr('disabled', false)
            .css({
              cursor: 'pointer',
              'pointer-events': 'auto',
            })
            .find('svg')
            .attr('stroke', 'black');

          cancelButton.attr(
            'data-terminal-number',
            newOrderData.terminal_number
          );
          cancelButton.attr('data-terminal-id', newOrderData.terminal_id);

          const retryButton = clonedOrderCard.find('.retry-btn');
          retryButton.addClass('retry-btn-' + newOrderData.terminal_id);
          retryButton.attr('disabled', true);
          retryButton.attr('data-terminal-id', newOrderData.terminal_id);
          retryButton.attr(
            'data-exchange-amount',
            newOrderData.exchange_amount
          );

          const showOrderButton = clonedOrderCard.find('.show-order');
          showOrderButton.addClass('show-order-' + newOrderData.terminal_id);
          showOrderButton.attr('data-terminal-id', newOrderData.terminal_id);

          const cancelProcessButton = clonedOrderCard.find(
            '.cancel-payment-process'
          );
          cancelButton.addClass(
            'cancel-payment-process-' + newOrderData.terminal_id
          );
          cancelProcessButton.attr(
            'data-terminal-number',
            newOrderData.terminal_number
          );
          cancelProcessButton.attr(
            'data-terminal-id',
            newOrderData.terminal_id
          );
          cancelProcessButton.addClass('disabled');
          cancelProcessButton.attr('disabled');

          if (!$('#' + newOrderData.terminal_id).length) {
            $('#processing-orders').append(clonedOrderCard);

            if (
              typeof window.terminalTimeouts !== 'undefined' &&
              window.terminalTimeouts[newOrderData.terminal_id]
            ) {
              clearTimeout(
                window.terminalTimeouts[newOrderData.terminal_id].cancelTimeout
              );
              clearTimeout(
                window.terminalTimeouts[newOrderData.terminal_id].enableTimeout
              );
              delete window.terminalTimeouts[newOrderData.terminal_id];
            }
          }

          emptyCart(
            null,
            !newOrderData.isSessionLastPurchase
              ? newOrderData.table_session_id
              : null
          );

          order_ajax_lock = false;
          cartQuickPaymentTerminalLock = false;
          $('div.loader').remove();
        }
      }
      return false;
    });

    function processOrder(newOrderData) {
      if (
        newOrderData.terminal_id !== '' &&
        newOrderData.payment_method === 'payment_terminal'
      ) {
        if (
          typeof window.terminalTimeouts !== 'undefined' &&
          window.terminalTimeouts[newOrderData.terminal_id]
        ) {
          clearTimeout(
            window.terminalTimeouts[newOrderData.terminal_id].cancelTimeout
          );
          clearTimeout(
            window.terminalTimeouts[newOrderData.terminal_id].enableTimeout
          );
          delete window.terminalTimeouts[newOrderData.terminal_id];
        }
      }
      currentOrderAjax = $.ajax({
        type: 'POST',
        url: '/ajax/order/new',
        data: newOrderData,
        timeout: 240000,
      })
        .done(function (data) {
          // To use the locationCart data after payment process was deleted with verifone payment
          const copyOfLocationCart = { ...locationCart };

          $('#tripletex-payment-progress-modal').modal('hide');
          currentOrderAjax = null;
          if (newOrderData.table_number) {
            fetchDataAndSend();
          }
          const currentDeviceId = localStorage.getItem('deviceID');
          if (
            data.orderProducts &&
            data.order &&
            data.organizer &&
            !(data.is_sold_giftcard || data.is_paid_invoice) &&
            (locationCart.payment_method === 'payment_preprint' ||
              locationCart.payment_method === 'payment_cash' ||
              locationCart.payment_method === 'non_integrated_vipps' ||
              locationCart.payment_method === 'payment_giftcard')
          ) {
            if (data.order_data) {
              let orderData = { orderData: data.order_data };

              if (!locationCart.table_number && data.production_print_data) {
                orderData = {
                  orderData: [
                    ...data.order_data,
                    ...data.production_print_data,
                  ],
                  printers: data.printers,
                };
              } else {
                orderData = {
                  orderData: [...data.order_data],
                  printers: data.printers,
                };
              }

              if (
                locationCart.payment_method === 'payment_cash' ||
                locationCart.payment_method === 'payment_giftcard'
              ) {
                if (
                  data.main_pos &&
                  data.drawer_settings &&
                  locationCart.payment_method === 'payment_cash'
                ) {
                  const message = {
                    action: 'open_drawer',
                    printer: data.drawer_settings,
                  };
                  if (data.main_pos && data.main_pos === currentDeviceId) {
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify(message)
                    );
                  } else {
                    const socketData = {
                      type: 'open_drawer',
                      main_pos_device_id: data.main_pos,
                      requested_device_id: currentDeviceId,
                      message,
                    };

                    window.globalSocket.send(JSON.stringify(socketData));
                  }
                }

                // Printing cash sales receipt from verifone standalone app
                if (
                  data.printer_ip !== undefined &&
                  data.printer_ip !== null &&
                  data.print_document
                ) {
                  if (
                    window.globalSocket &&
                    window.globalSocket.readyState === WebSocket.OPEN
                  ) {
                    window.globalSocket.send(
                      JSON.stringify({
                        type: 'verifone',
                        action: 'print',
                        verifoneSerialNumber: data.printer_ip,
                        senderDeviceId: localStorage.getItem('deviceID'),
                        printDocument: data.print_document,
                        printOnStandalone: true,
                      })
                    );
                  }
                }

                if (isVerifone) {
                  passVerifoneDataToWebView({
                    action: 'verifone',
                    data: {
                      action: 'print',
                      data: {
                        document: data.print_document,
                        contentTypeString: 'HTML',
                        receiptTypeString: 'DOCUMENT',
                        deliveryMethodString: 'PRINT',
                        deliveryAddress: '',
                      },
                    },
                  });
                }
              }

              cancelOrderPull();
              isPullOrderPending = true;

              if (
                window.ReactNativeWebView &&
                data.main_pos &&
                data.main_pos === currentDeviceId
              ) {
                passDataToWebView(event, 'print_poll_order', orderData);
              } else if (window.ReactNativeWebView) {
                sendWhenReady(
                  window.globalSocket,
                  JSON.stringify({
                    type: 'print_pull_data',
                    main_pos_device_id: data.main_pos,
                    orderData,
                  })
                );
              }
            }
          } else if (
            data.production_print_data &&
            data.printers &&
            !locationCart.table_number &&
            !data.tableNumber
          ) {
            let orderData = {
              orderData: [...data.production_print_data],
              printers: data.printers,
            };

            cancelOrderPull();
            isPullOrderPending = true;

            if (
              window.ReactNativeWebView &&
              data.main_pos &&
              data.main_pos === currentDeviceId
            ) {
              passDataToWebView(event, 'print_poll_order', orderData);
            } else if (window.ReactNativeWebView) {
              sendWhenReady(
                window.globalSocket,
                JSON.stringify({
                  type: 'print_pull_data',
                  main_pos_device_id: data.main_pos,
                  orderData,
                })
              );
            }
          }

          $('div.loader').remove();
          $('.order-button').prop('disabled', true);

          if (
            data.payment_redirect_url !== undefined &&
            data.payment_redirect_url !== null
          ) {
            document.location.href = data.payment_redirect_url;
            return;
          }

          if (
            data.confirmation_code !== undefined &&
            data.confirmation_code !== null
          ) {
            const responseOrder = data.order;
            const orderHtml =
              data.order_html !== undefined && data.order_html !== null
                ? data.order_html
                : '';
            if (data.order && data.orderProducts) {
              const orderReturn = data.order;
              const orderProductsReturn = data.orderProducts;
              const totalPrice = formattedPriceToShow(
                (parseFloat(orderReturn.price_ex_vat_total) * 100 +
                  parseFloat(orderReturn.vat_total) * 100) /
                  100
              );

              const productsWithCount = [];

              orderProductsReturn.forEach((product) => {
                const productDetail = `(${product.quantity})${product.name}`;
                productsWithCount.push(productDetail);
              });
              localStorage.setItem(
                'lastOrderProducts',
                JSON.stringify(productsWithCount)
              );
              localStorage.setItem('lastOrderTotal', totalPrice);
            }

            $('.modal-backdrop').remove();
            if (
              $('#content').hasClass('is-employee') &&
              (newOrderData.payment_method == 'payment_terminal' ||
                newOrderData.payment_method == 'payment_cash' ||
                newOrderData.payment_method == 'payment_preprint' ||
                newOrderData.payment_method == 'payment_method_coupon' ||
                newOrderData.payment_method == 'payment_giftcard' ||
                newOrderData.payment_method == 'non_integrated_vipps' ||
                newOrderData.payment_method == 'none')
            ) {
              if (
                newOrderData.table_session_id !== undefined &&
                newOrderData.table_session_id !== null
              ) {
                if (newOrderData.payment_method !== 'payment_terminal') {
                  emptyCart(
                    'order_complete',
                    !newOrderData.isSessionLastPurchase
                      ? newOrderData.table_session_id
                      : null
                  );
                } else if (
                  newOrderData.table_session_id &&
                  $('#table-session-details-modal.show').length > 0 &&
                  $('#table-session-details-modal').attr(
                    'data-table-session-id'
                  ) == newOrderData.table_session_id &&
                  $('#btnSyncState').hasClass('d-none')
                ) {
                  let isShareByAmount = $('mode-tab[data-mode="sum"]').hasClass(
                    'active'
                  )
                    ? 1
                    : 0;

                  if (!isShareByAmount) {
                    $('#btnSyncState').removeClass('d-none').addClass('d-flex');
                  }
                }
              } else {
                if (newOrderData.payment_method !== 'payment_terminal') {
                  emptyCart('order_complete');
                }
              }

              $('#cart-modal').modal('hide');
              $('.modal-backdrop').remove();
              if (newOrderData.payment_method === 'payment_terminal') {
                // disable cancel button if it's successful
                const $cancelButton = $(
                  ".cancel-btn[data-terminal-id='" +
                    newOrderData.terminal_id +
                    "']"
                );
                if ($cancelButton.length) {
                  $cancelButton
                    .prop('disabled', true)
                    .css({
                      cursor: 'not-allowed',
                      'pointer-events': 'none',
                    })
                    .find('svg')
                    .attr('stroke', '#ccc'); // make icon look disabled
                }
                removeOrderProcessStatus(newOrderData.terminal_id);

                if (locationCart.products.length <= 0) {
                  showOrderSuccessCheckmark();
                }
              }
              $('.confirmation-toast').remove();
              const $confirmationStyle = $('#classic-location-products').data(
                'order-confirmation-toast-style'
              );
              if (responseOrder && responseOrder.pos_sale == 2) {
                showToast({
                  type: 'success',
                  message: 'Veksel vellykket',
                  duration: 2000,
                });
                $('#cash-exchange-input').val('');
              } else if (orderHtml && orderHtml !== '') {
                $('.confirmation-toast').remove();
                $('#content').append(
                  '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                    (window.innerWidth >= 500 ? ' right: 0;' : '') +
                    ' width: 480px; display: none;">' +
                    '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                    ($confirmationStyle == 'compact' ? 'false' : 'true') +
                    '" data-delay="' +
                    ($confirmationStyle === 'compact' ? 100000 : 3000) +
                    '">' +
                    '  <div class="toast-header">' +
                    '    <strong class="mr-auto">Ordre registrert</strong>' +
                    '    <small></small>' +
                    '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                    '      <span aria-hidden="true">&times;</span>' +
                    '    </button>' +
                    '  </div>' +
                    '  <div class="toast-body">' +
                    orderHtml +
                    '  </div>' +
                    '</div>' +
                    '</div>'
                );
              }

              if (
                data.item_count &&
                data.total_amount &&
                $confirmationStyle === 'compact'
              ) {
                showPreviousSaleBar(data.item_count, data.total_amount);
              } else {
                $('.confirmation-toast').css({ padding: '1rem' }).show();
                $('.confirmation-toast-box')
                  .toast('show')
                  .on('hidden.bs.toast', function () {
                    $('.confirmation-toast').attr('style', function (i, s) {
                      return (s || '') + 'padding: 0px !important;';
                    });
                  });
              }

              $('#table-name').text('');
              $('#small-cart-table-name').text('');
              setTimeout(function () {
                order_ajax_lock = false;
                cartQuickPaymentTerminalLock = false;
                if (data.pin_required) {
                  document.location.href = `/user/organizer_login?redirect_url=${encodeURIComponent(
                    document.location.pathname
                  )}`;
                } else if (data.login_reqiured) {
                  document.location.href = '/logout';
                }
              }, 3000);
              emptyCartOnModalClose = true;

              localStorage.removeItem('saved_table_id');
              $('.order-button').each(function () {
                if (
                  $(this).is('[data-toggle]') &&
                  ($(this).data('payment-method') === 'nets_card' ||
                    $(this).data('payment-method') === 'nets_vipps')
                ) {
                  $(this).prop('disabled', true);
                } else if (
                  $(this).data('payment-method') === 'payment_terminal'
                ) {
                  const terminalId = $(this).data('terminal-id');
                  if ($(`#${terminalId}`).length) {
                    $(this).prop('disabled', true);
                  } else {
                    $(this).prop('disabled', false);
                  }
                } else {
                  $(this).prop('disabled', false);
                }
              });

              $('#giftcard-feedback').empty();
              $('#giftcard-feedback').addClass('d-none');

              $('#giftcard-discount').text('0');
              $('#subtotal-with-giftcard').text('0');
              $('#giftcard-discount-summary').addClass('d-none');

              // $("#payment-giftcard").addClass("d-none");
              $('#payment-giftcard').replaceWith(`
                <button
                  type="button"
                  id="show-giftcard-section"
                  class="btn btn-light checkout-action"
                  disabled
                >
                  <svg width="24" height="24" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 0C11.7316 0 11.0308 0.288854 10.5 0.763896C9.96924 0.288854 9.26836 0 8.5 0C6.84315 0 5.5 1.34315 5.5 3C5.5 3.35064 5.56015 3.68722 5.67071 4H2C1.17157 4 0.5 4.67157 0.5 5.5V8.5C0.5 9.32843 1.17157 10 2 10H2.5V19.5C2.5 20.3284 3.17157 21 4 21H17C17.8284 21 18.5 20.3284 18.5 19.5V10H19C19.8284 10 20.5 9.32843 20.5 8.5V5.5C20.5 4.67157 19.8284 4 19 4H15.3293C15.4398 3.68722 15.5 3.35064 15.5 3C15.5 1.34315 14.1569 0 12.5 0ZM2.5 8V6H9.5V8H2.5ZM9.5 10H4.5V19H9.5V10ZM11.5 19V10H16.5V19H11.5ZM11.5 8V6H18.5V8H11.5ZM8.5 2C9.05228 2 9.5 2.44772 9.5 3C9.5 3.55228 9.05228 4 8.5 4C7.94772 4 7.5 3.55228 7.5 3C7.5 2.44772 7.94772 2 8.5 2ZM12.5 4C13.0523 4 13.5 3.55228 13.5 3C13.5 2.44772 13.0523 2 12.5 2C11.9477 2 11.5 2.44772 11.5 3C11.5 3.55228 11.9477 4 12.5 4Z" fill="#000"></path>
                  </svg>
                  Gavekort
                </button>
              `);

              $('#giftcard-code').val('');
              locationCart.giftcard_code = '';
              locationCart.giftcards = [];
              closePanel();
            } else if (
              newOrderData.payment_method === 'payment_verifone_terminal'
            ) {
              if (
                newOrderData.terminal_id !== undefined &&
                newOrderData.terminal_id !== '' &&
                !isVerifone
              ) {
                const wrapper = $('#process-orders-with-terminal-payments');
                if (wrapper.hasClass('d-none')) {
                  wrapper.removeClass('d-none');
                  wrapper.addClass('d-flex');
                }
                const clonedOrderCard = $('.order-card.clone').clone();
                clonedOrderCard.removeClass('clone d-none');
                clonedOrderCard.addClass('processing');
                clonedOrderCard.attr('id', newOrderData.terminal_id);
                clonedOrderCard
                  .find('.terminal-number')
                  .text(newOrderData.terminal_number);
                const statusBadge = clonedOrderCard.find('.status-badge');
                statusBadge.addClass('processing text-primary');
                statusBadge.html(
                  `Behandling <div class="spinner-border spinner-border-sm text-primary ml-2" role="status"><span class="sr-only">Loading...</span></div>`
                );
                clonedOrderCard
                  .find('.order-items')
                  .text(locationCart.number_of_products);

                const cancelButton = clonedOrderCard.find('.cancel-btn');
                cancelButton.remove();

                const retryButton = clonedOrderCard.find('.retry-btn');
                retryButton.addClass('retry-btn-' + newOrderData.terminal_id);
                retryButton.attr('disabled', true);
                retryButton.attr('data-terminal-id', newOrderData.terminal_id);
                retryButton.attr('data-terminal-type', 'verifone');

                const showOrderButton = clonedOrderCard.find('.show-order');
                showOrderButton.remove();

                const cancelProcessButton = clonedOrderCard.find(
                  '.cancel-payment-process'
                );
                cancelButton.addClass(
                  'cancel-payment-process-' + newOrderData.terminal_id
                );
                cancelProcessButton.attr(
                  'data-terminal-number',
                  newOrderData.terminal_number
                );
                cancelProcessButton.attr(
                  'data-terminal-id',
                  newOrderData.terminal_id
                );
                cancelProcessButton.attr('data-terminal-type', 'verifone');
                cancelProcessButton.addClass('disabled');
                cancelProcessButton.attr('disabled');

                if (!$('#' + newOrderData.terminal_id).length) {
                  $('#processing-orders').append(clonedOrderCard);

                  if (
                    typeof window.terminalTimeouts !== 'undefined' &&
                    window.terminalTimeouts[newOrderData.terminal_id]
                  ) {
                    clearTimeout(
                      window.terminalTimeouts[newOrderData.terminal_id]
                        .cancelTimeout
                    );
                    clearTimeout(
                      window.terminalTimeouts[newOrderData.terminal_id]
                        .enableTimeout
                    );
                    delete window.terminalTimeouts[newOrderData.terminal_id];
                  }
                }

                emptyCart();

                const payload = {
                  type: 'verifone',
                  action: 'start_payment',
                  verifoneSerialNumber: newOrderData.terminal_id,
                  paymentData: data.payment_data,
                  locationCart: copyOfLocationCart,
                  senderDeviceId: localStorage.getItem('deviceID'),
                };

                localStorage.setItem(
                  'vt_' + newOrderData.terminal_id,
                  JSON.stringify(payload)
                );

                window.globalSocket.send(JSON.stringify(payload));

                if (
                  !newOrderData.isSessionLastPurchase &&
                  newOrderData.table_session_id
                ) {
                  showTableSessionDetails(newOrderData.table_session_id);
                }
              } else {
                localStorage.setItem(
                  'verifone_payment_data',
                  JSON.stringify(data.payment_data)
                );

                passVerifoneDataToWebView(data.payment_data);

                if (
                  $('#paymentProcessSpinner').hasClass('d-none') &&
                  !$('#paymentProcessError').hasClass('d-none')
                ) {
                  $('#paymentProcessSpinner').removeClass('d-none');
                  $('#paymentProcessError').addClass('d-none');

                  const processingMessage =
                    $('#paymentStatus').data('processing-message') ||
                    'Processing Payment...';
                  $('#paymentStatus').text(processingMessage);
                  $('#retryPaymentButton').addClass('d-none');
                }
                $('#paymentProcessModal')
                  .modal({
                    backdrop: 'static',
                    keyboard: false,
                  })
                  .on('shown.bs.modal', function () {
                    $('#retryPaymentButton').addClass('d-none');
                    $('#paymentProcessSpinner').removeClass('d-none');
                    $('#paymentProcessError').addClass('d-none');
                    const processingMessage =
                      $('#paymentStatus').data('processing-message') ||
                      'Processing Payment...';
                    $('#paymentStatus').text(processingMessage);
                    $('#cancelPaymentButton')
                      .html('<div class="loader"></div>')
                      .prop('disabled', true);
                  })
                  .on('hidden.bs.modal', function () {
                    $('#cancelPaymentButton')
                      .html(
                        $('#cancelPaymentButton').data('button-text') ||
                          'Avbryt'
                      )
                      .prop('disabled', false);
                  });
              }
            } else {
              localStorage.removeItem('saved_table_id');
              document.location.href =
                '/order/confirmation/' + data.confirmation_code;
            }
            setLastOrderDetails();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          $('div.loader').remove();
          $('#tripletex-payment-progress-modal').modal('hide');
          $('.order-button').prop('disabled', true);
          $('.order-button').each(function () {
            if (
              $(this).is('[data-toggle]') &&
              ($(this).data('payment-method') === 'nets_card' ||
                $(this).data('payment-method') === 'nets_vipps')
            ) {
              $(this).prop('disabled', true);
            } else if ($(this).data('payment-method') === 'payment_terminal') {
              const terminalId = $(this).data('terminal-id');
              if ($(`#${terminalId}`).length) {
                $(this).prop('disabled', true);
              } else {
                $(this).prop('disabled', false);
              }
            } else {
              $(this).prop('disabled', false);
            }
          });

          if (
            data.responseJSON !== undefined &&
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            errorPopupAlert(data.responseJSON.error_message);
          } else {
            errorPopupAlert(
              'Noe gikk galt under bestilling. Vennligst prøv igjen.'
            );
          }

          if (newOrderData.payment_method === 'payment_terminal') {
            updateOrderProcessStatus(newOrderData.terminal_id, 'failed');
          }

          order_ajax_lock = false;
          cartQuickPaymentTerminalLock = false;
        })
        .always(function () {
          locationCart.order_storage_identifier = '';
          order_ajax_lock = false;
          hasDoubleClickedProduct = false;
          $('#tripletex-payment-progress-modal').modal('hide');
        });
    }

    $(document).on(
      'dblclick',
      '.shop-product-container .shop-product',
      function () {
        if (hasBeenInactive) {
          showClearCartConfirmation();
          return;
        }

        const isInoiveOAddedToCart =
          locationCart.number_of_products > 0 &&
          'invoice_id' in locationCart.products[0];
        const isGiftcardAddedToCart =
          locationCart.number_of_products > 0 &&
          'gift_card_code' in locationCart.products[0];

        if (isGiftcardAddedToCart) {
          showToast({
            type: 'error',
            title: 'Vennligst tøm handlekurven først!',
            message: 'Gavekort er lagt til i handlekurv',
            position: 'bottom-left',
            duration: 5000,
          });
          return;
        }

        if (isInoiveOAddedToCart) {
          showToast({
            type: 'error',
            title: 'Vennligst tøm handlekurven først!',
            message: 'Fakturabetaling er lagt til i handlekurv',
            position: 'bottom-left',
            duration: 5000,
          });
          return;
        }
        const $this = $(this);

        if (
          isEnableDoubleClickQuickOrder &&
          !$('#open-cart').hasClass('d-none') &&
          !$this.closest('.shop-product-container').attr('data-is-open-price')
            ?.length
        ) {
          clearTimeout(this._clickTimer);
          this._clickTimer = setTimeout(function () {
            const productContainer = $this.closest('.shop-product-container');

            $('.add-product', productContainer).click();
            hasDoubleClickedProduct = true;
          }, 250);

          const shopProduct = $this;
          shopProduct.focus();
          if (this._focusTimeout) {
            clearTimeout(this._focusTimeout);
          }

          this._focusTimeout = setTimeout(() => {
            shopProduct.blur();
            delete this._focusTimeout;
          }, 100);
        }
      }
    );

    let cartQuickPaymentTerminalLock = false;
    $(document).on(
      'click',
      '.cart-quick-payment-terminal .order-button',
      function () {
        if (hasBeenInactive) {
          showClearCartConfirmation();
          return;
        }
        if (!cartQuickPaymentTerminalLock) {
          cartQuickPaymentTerminalLock = true;
          updateCartProducts(true);
        }
      }
    );

    let isNameRequired = false;
    let isPhoneNumberRequired = false;
    $(document).on('click', '#pick-up-at-the-bar-button', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }

      if (isNameRequired === false && $('#name').prop('required')) {
        isNameRequired = true;
      }
      if (
        isPhoneNumberRequired === false &&
        $('#phone_number').prop('required')
      ) {
        isPhoneNumberRequired = true;
      }
      if ($(this).hasClass('btn-primary')) {
        locationCart.pick_up_at_the_bar = true;
        $(this).removeClass('btn-primary');
        $(this).addClass('btn-light');
        $('#table_number').attr('required', false);
        $('#name').attr('required', false);
        $('#phone_number').attr('required', false);
        $('#table_number').val('');
        $('#name').val('');
        $('#phone_number').val('');
        if (!$('.get-delivered-to-table').hasClass('d-none')) {
          $('.get-delivered-to-table').addClass('d-none');
        }
        if ($(this).closest('div').hasClass('col-4')) {
          $(this).closest('div').removeClass('col-4');
          $(this).closest('div').addClass('col-8');
        }
      } else {
        locationCart.pick_up_at_the_bar = false;
        $(this).removeClass('btn-light');
        $(this).addClass('btn-primary');
        if ($('.get-delivered-to-table').hasClass('d-none')) {
          $('.get-delivered-to-table').removeClass('d-none');
        }
        if ($(this).closest('div').hasClass('col-8')) {
          $(this).closest('div').removeClass('col-8');
          $(this).closest('div').addClass('col-4');
        }
        $('#table_number').attr('required', true);
        if (isNameRequired) {
          $('#name').attr('required', true);
        }
        if (isNameRequired) {
          $('#phone_number').attr('required', true);
        }
      }
      return false;
    });

    $(document).on('click', '#customer-credit-payment-button', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }

      if (isPreventToPayInvoice($(this))) {
        showToast({
          type: 'error',
          title: 'Ugyldig betalingsmetode',
          message: 'Faktura produkter kan ikke betale',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }

      if (locationCart.customer_id || locationCart.customer_contact_person_id) {
        locationCart.payment_method = 'payment_credit';
        $('form#order_register_form').submit();
      } else {
        if (locationCart.products.length == 0) {
          return;
        }
        $('#customerModal').modal('show');
        setTimeout(() => {
          $('#confirm-customer-selection').addClass('d-none');
          $('#confirm-and-paid-customer-selection').removeClass('d-none');
        }, 300);
      }
    });

    $(document).on('click', '#show-customer-modal', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      if (locationCart.products.length == 0) {
        return;
      }

      $('#customerModal').modal('show');
      setTimeout(() => {
        $('#confirm-customer-selection').removeClass('d-none');
        $('#confirm-and-paid-customer-selection').addClass('d-none');
      }, 300);
    });

    $(document).on('click', '#show-giftcard-section', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }

      if (isPreventToPayInvoice($(this))) {
        showToast({
          type: 'error',
          title: 'Ugyldig betalingsmetode',
          message: 'Faktura produkter kan ikke betale',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }

      if (locationCart.products.length == 0) {
        $('#gift-card-check-modal').modal('show');
        return;
      }
      if ($('.gift-card-section').hasClass('d-none')) {
        $('.gift-card-section').removeClass('d-none');
        $('#giftcard-code').focus();
      } else {
        $('.gift-card-section').addClass('d-none');
      }
    });

    $(document).on('show.bs.modal', '#customerModal', function () {
      // Remove aria-hidden when modal is about to be shown to fix accessibility issue
      $('#customerModal').removeAttr('aria-hidden');
    });

    $(document).on('shown.bs.modal', '#customerModal', function () {
      $(`.customer`).removeClass('bg-primary text-white');

      if (selectedCustomerId) {
        $(`.customer[data-customer-id="${selectedCustomerId}"]`).addClass(
          'bg-primary text-white'
        );
      }
      $('.modal-backdrop').css('z-index', '999 !important');

      // Ensure aria-hidden is not set when modal is shown and has focus
      $('#customerModal').removeAttr('aria-hidden');
    });

    $(document).on('hide.bs.modal', '#customerModal', function () {
      // Add aria-hidden back when modal is being hidden
      $('#customerModal').attr('aria-hidden', 'true');
    });

    $(document).on('keyup', '#customer-search', function () {
      let searchValue = $(this).val().toLowerCase();

      $('.customer').each(function () {
        let customerText = $(this).text().toLowerCase();

        if (customerText.includes(searchValue)) {
          $(this).removeClass('hidden-customer');
        } else {
          $(this).addClass('hidden-customer');
        }
      });
    });

    $(document).on('change', '.customer-single-select', function () {
      $('.customer-item').removeClass('selected');
      if ($(this).is(':checked')) {
        // Uncheck all other checkboxes
        $('.customer-single-select').not(this).prop('checked', false);
        // Add selected class to current item
        $(this).closest('.customer-item').addClass('selected');
      }
    });
    // Handle clicking on the customer item div
    $(document).on('click', '.customer-item', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      e.preventDefault();

      var $checkbox = $(this).find('.customer-single-select');
      var $currentItem = $(this);

      if ($checkbox.is(':checked')) {
        // If already selected, uncheck it
        $checkbox.prop('checked', false);
        $currentItem.removeClass('selected');

        locationCart.customer_id = '';
        locationCart.customer_contact_person_id = '';
        // Reset customer_id and discount percent for all products

        locationCart.products.forEach((product) => {
          if (parseFloat(product.discount_percent) >= 0) {
            product.discount_percent = 0;
          }
        });

        updateCartProducts();
        $('#confirm-and-paid-customer-selection').prop('disabled', true);
        $('#customerModal').modal('hide');
        $('.checkout-actions-container #show-customer-modal')
          .css('background-color', '#1355ff')
          .css('border-color', '#1355ff')
          .css('color', '');
      } else {
        // Remove selection from all items
        $('.customer-item').removeClass('selected');
        $('.customer-single-select').prop('checked', false);

        // Select current item
        $checkbox.prop('checked', true);
        $currentItem.addClass('selected');
        $('#confirm-and-paid-customer-selection').prop('disabled', false);
      }
    });

    let selectedCustomerId = null;

    $(document).on('click', '#confirm-customer-selection', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      var $checkedCustomer = $('.customer-single-select:checked');

      if ($checkedCustomer.length > 0) {
        // Get the customer data from the checked checkbox
        var customerId = $checkedCustomer.data('customer-id');
        var customerType = $checkedCustomer.data('type');

        $('.customer').removeClass('bg-primary');
        $('.customer').css('color', 'black');

        selectedCustomerId = customerId;
        const customer_id = parseInt(selectedCustomerId);
        const type = customerType;

        if (customerType == 'contact-person') {
          locationCart.customer_contact_person_id = customer_id;
          locationCart.customer_id = '';
        } else {
          locationCart.customer_contact_person_id = '';
          locationCart.customer_id = customer_id;
        }

        // Update customer button color to green when customer is selected
        if (
          locationCart.customer_id ||
          locationCart.customer_contact_person_id
        ) {
          $('.checkout-header .header-container .actions #show-customer-modal')
            .css('background-color', '#28a745')
            .css('border-color', '#28a745')
            .css('color', '');
          $('.checkout-actions-container #show-customer-modal')
            .css('background-color', '#28a745')
            .css('border-color', '#28a745')
            .css('color', '');
        }

        $('.modal-backdrop').remove();
        locationCart.products = locationCart.products.map((product) => {
          return {
            ...product,
          };
        });

        if (locationCart.products.length == 0) {
          return;
        }

        if (
          type !== undefined &&
          type !== null &&
          type === 'scroll' &&
          orderStorageIds !== null
        ) {
          getClassicCartModal();
        } else {
          updateCartProducts();
        }

        $('#customerModal').modal('hide');

        setTimeout(() => {
          $(".order-button[data-payment-method='payment_credit']").prop(
            'disabled',
            false
          );
        }, 1000);
      } else {
        alert('Vennligst velg en kunde først !');
      }
    });

    $(document).on(
      'click',
      '#confirm-and-paid-customer-selection',
      function () {
        if (hasBeenInactive) {
          showClearCartConfirmation();
          return;
        }
        var $checkedCustomer = $('.customer-single-select:checked');

        if ($checkedCustomer.length > 0) {
          // Get the customer data from the checked checkbox
          var customerId = $checkedCustomer.data('customer-id');
          var customerType = $checkedCustomer.data('type');

          $('.customer').removeClass('bg-primary');
          $('.customer').css('color', 'black');

          selectedCustomerId = customerId;
          const customer_id = parseInt(selectedCustomerId);
          const type = customerType;

          if (customerType == 'contact-person') {
            locationCart.customer_contact_person_id = customer_id;
            locationCart.customer_id = '';
          } else {
            locationCart.customer_contact_person_id = '';
            locationCart.customer_id = customer_id;
          }

          locationCart.payment_method = 'payment_credit';

          $('#customerModal').modal('hide');
          updateCartProducts().always(() => {
            $('#order_register_form').submit();
          });
        } else {
          alert('Vennligst velg en kunde først !');
        }
      }
    );

    $(document).on('change', '#customer_number', function () {
      const customer_id = parseInt(this.value);

      const type = $(this).data('type');
      if (type == 'contact-person') {
        locationCart.customer_contact_person_id = customer_id;
        locationCart.customer_id = '';
      } else {
        locationCart.customer_contact_person_id = '';
        locationCart.customer_id = customer_id;
      }

      // Update customer button color to green when customer is selected
      if (locationCart.customer_id || locationCart.customer_contact_person_id) {
        $('.checkout-header .header-container .actions #show-customer-modal')
          .css('background-color', '#28a745')
          .css('border-color', '#28a745')
          .css('color', 'white');
        $('.checkout-actions-container #show-customer-modal')
          .css('background-color', '#28a745')
          .css('border-color', '#28a745')
          .css('color', 'white');
      }

      $('.modal-backdrop').remove();
      locationCart.products = locationCart.products.map((product) => {
        return {
          ...product,
          discount_percent: 0,
        };
      });

      if (
        type !== undefined &&
        type !== null &&
        type === 'scroll' &&
        orderStorageIds !== null
      ) {
        getClassicCartModal();
      } else {
        updateCartProducts();
      }
    });

    $(document).on('change', '#customer_select', function () {
      const customer_id = parseInt(this.value);
      locationCart.customer_id = customer_id;

      // Update customer button color to green when customer is selected
      if (locationCart.customer_id) {
        $('.checkout-header .header-container .actions #show-customer-modal')
          .css('background-color', '#28a745')
          .css('border-color', '#28a745')
          .css('color', 'white');
        $('.checkout-actions-container #show-customer-modal')
          .css('background-color', '#28a745')
          .css('border-color', '#28a745')
          .css('color', 'white');
      }

      locationCart.products = locationCart.products.map((product) => {
        return {
          ...product,
          discount_percent: 0,
        };
      });

      $('.modal-backdrop').remove();
      getClassicCartModal();
    });

    $(document).on('hide.bs.modal', '#product-extra-modal', function (event) {
      $('body').removeClass('modal-open');
      setTimeout(() => {
        $('#product-extra-modal').remove();
      }, 500);
    });

    $(document).on(
      'hide.bs.modal',
      '#terminalProductListModal',
      function (event) {
        $('body').removeClass('modal-open');
        setTimeout(() => {
          $('#terminalProductListModal').remove();
        }, 500);
      }
    );

    $(document).on('hide.bs.modal', '#payment-split-modal', function (event) {
      setTimeout(() => {
        $('#payment-split-modal').remove();
      }, 200);
    });

    $('.order-card').each(function () {
      const terminalId = $(this).attr('id');
      $(".order-button[data-terminal-id='" + terminalId + "']").prop(
        'disabled',
        true
      );
      $(".quick-order-button[data-terminal-id='" + terminalId + "']").prop(
        'disabled',
        true
      );
    });

    getClassicCartModal = function (autoPayWithTerminal) {
      for (let [index, product] of locationCart.products.entries()) {
        if (product.amount === 0) {
          locationCart.products.splice(index, 1);
        }
      }

      locationCart.amount_without_discount = floor(
        locationCart.products.reduce(
          (total, product) =>
            total +
            parseFloat(
              (product.amount * product.original_product_price).toFixed(2)
            ),
          0
        )
      );

      let data = generateLocationCartData(locationCart, {
        shop_type: p,
        organizer_id: organizerId,
        order_storage_ids: orderStorageIds,
        orientation: screenOrientation,
        isCartOpened: localStorage.getItem('isCartOpened'),
      });

      if (locationCart.payment_failed === true) {
        data.payment_failed = locationCart.payment_failed;
      }

      if (locationCart.name != '') {
        data.name = locationCart.name;
      }

      if ($.isNumeric(locationCart.phone_number)) {
        data.phone_number = locationCart.phone_number;
      }

      if (locationCart.pick_up_at_the_bar == true) {
        data.pick_up_at_the_bar = locationCart.pick_up_at_the_bar;
      }
      if (orderStorageIds !== null) {
        orderStorageIds = data.order_storage_ids;
      }
      return $.ajax({
        type: 'POST',
        url: '/ajax/order/get_cart',
        data: data,
      })
        .done(function (data) {
          setLastOrderDetails();
          if (
            data.html === undefined ||
            data.html === null ||
            data.html === ''
          ) {
            emptyAllCart();
            return;
          }

          if (
            locationCart.number_of_products > 0 ||
            locationCart.table_session_id ||
            locationCart.share_amount > 0 ||
            locationCart.exchange_amount > 0
          ) {
            setTimeout(() => {
              $('#show-giftcard-section').prop('disabled', false);
              $('.classic-mobile-cart #show-giftcard-section').prop(
                'disabled',
                false
              );
              $('#show-customer-modal').prop('disabled', false);
              $('.classic-mobile-cart #show-customer-modal').prop(
                'disabled',
                false
              );
              // Enable checkout-actions-container buttons
              $('.checkout-actions-container #show-giftcard-section').prop(
                'disabled',
                false
              );

              $('.checkout-actions-container #show-customer-modal').prop(
                'disabled',
                false
              );

              if (
                locationCart.products.split_products &&
                locationCart.products.split_products.length > 0
              ) {
                $('#split-by-sum').prop('disabled', true);
              }

              $('.checkout-action').each(function () {
                const terminalType = $(this).attr('data-terminal-type');
                if (terminalType && terminalType == 2) {
                  return true;
                }

                const orderCards = $('.order-card').not('.clone');
                if (orderCards.length) {
                  const orderCardIds = orderCards
                    .map(function () {
                      return $(this).attr('id');
                    })
                    .get();

                  if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
                    $(this).prop('disabled', true);
                    $(this).attr(
                      'title',
                      'Vennligst vent, det pågår en betaling'
                    );
                  } else {
                    $(this).prop('disabled', false);
                    $(this).removeAttr('title');
                  }
                } else if (locationCart.share_amount > 0) {
                  const paymentMetthod = $(this).attr('data-payment-method');
                  if (
                    (!paymentMetthod ||
                      paymentMetthod == 'payment_split' ||
                      paymentMetthod == 'payment_credit') &&
                    !$(this).hasClass('more-payment-methods') &&
                    !$(this).hasClass('reset-classic-shopping-cart') &&
                    $(this).attr('id') != 'order-storage-modal'
                  ) {
                    $(this).prop('disabled', true);
                  } else {
                    $(this).prop('disabled', false);
                    $(this).removeAttr('title');
                  }
                } else if (locationCart.exchange_amount > 0) {
                  const paymentMetthod = $(this).attr('data-payment-method');
                  if (
                    (!paymentMetthod ||
                      paymentMetthod == 'payment_split' ||
                      paymentMetthod == 'payment_credit' ||
                      paymentMetthod == 'payment_cash') &&
                    !$(this).hasClass('more-payment-methods') &&
                    !$(this).hasClass('reset-classic-shopping-cart') &&
                    $(this).attr('id') != 'order-storage-modal' &&
                    $(this).attr('id') != 'cash-exchange-button'
                  ) {
                    $(this).prop('disabled', true);
                  } else {
                    $(this).prop('disabled', false);
                    $(this).removeAttr('title');
                  }
                } else if (
                  data.is_gift_card_selling ||
                  data.is_tripletex_invoice_payment
                ) {
                  const paymentMethod = $(this).attr('data-payment-method');
                  const elementId = $(this).attr('id');
                  if (
                    (paymentMethod == 'payment_credit' &&
                      !data.is_gift_card_selling) ||
                    paymentMethod == 'payment_split' ||
                    elementId == 'order-storage-modal' ||
                    elementId == 'tripletex-invoices-button' ||
                    elementId == 'show-giftcard-section' ||
                    elementId == 'discount-toggle' ||
                    elementId == 'show-customer-modal'
                  ) {
                    $(this).prop('disabled', true);
                  } else {
                    $(this).prop('disabled', false);
                  }
                } else {
                  $(this).prop('disabled', false);
                  $(this).removeAttr('title');
                }
              });

              $('.quick-order-button').each(function () {
                const orderCards = $('.order-card').not('.clone');

                if (orderCards.length) {
                  const orderCardIds = orderCards
                    .map(function () {
                      return $(this).attr('id');
                    })
                    .get();

                  if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
                    $(this).prop('disabled', true);
                    $(this).attr(
                      'title',
                      'Vennligst vent, det pågår en betaling'
                    );
                  } else if (locationCart.products.length > 0) {
                    $(this).prop('disabled', false);
                    $(this).removeAttr('title');
                  }
                } else if (locationCart.products.length > 0) {
                  if ($(this).attr('data-terminal-type') != '2') {
                    $(this).prop('disabled', false);
                  } else {
                    $(this).prop('disabled', true);
                  }
                  $(this).removeAttr('title');
                }
              });

              if (
                locationCart.customer_id ||
                locationCart.customer_contact_person_id
              ) {
                $('#show-customer-modal')
                  .css('background-color', '#28a745')
                  .css('border-color', '#28a745')
                  .css('color', 'white');
                $('.checkout-actions-container #show-customer-modal')
                  .css('background-color', '#28a745')
                  .css('border-color', '#28a745')
                  .css('color', 'white');
              }
            }, 500);
          } else if (!locationCart.is_per_person_ordering_enabled) {
            // Disable checkout-actions-container buttons when cart is empty
            $('.checkout-actions-container #show-giftcard-section').prop(
              'disabled',
              true
            );
            $('.checkout-actions-container #show-customer-modal').prop(
              'disabled',
              true
            );
            $('.checkout-action:disabled').each(function () {
              const orderCards = $('.order-card').not('.clone');

              if (orderCards.length) {
                const orderCardIds = orderCards
                  .map(function () {
                    return $(this).attr('id');
                  })
                  .get();

                if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
                  $(this).attr(
                    'title',
                    'Vennligst vent, det pågår en betaling'
                  );
                }
              } else {
                $(this).attr('title', 'Legg produkter i Checkout først');
              }
            });

            $('.checkout-actions-container #show-customer-modal')
              .css('background-color', '')
              .css('border-color', '')
              .css('color', '');
          }

          if (
            data.wsOrderData &&
            !locationCart.is_per_person_ordering_enabled
          ) {
            connectWebSocket();
            sendUpdateToServer(data.wsOrderData);
            if (!$('#open-cart').hasClass('d-none')) {
              if (window.innerWidth < 768) {
                $('.quick-order-payment-container').css({
                  display: 'flex',
                  'flex-wrap': 'wrap',
                  gap: '3px',
                  'max-width': '216px',
                  'max-height': '220px',
                  overflow: 'hidden auto',
                });
              } else {
                $(
                  '.quick-order-payment-container.desktop > .payment-buttons-wrapper'
                )
                  .removeClass('d-none')
                  .addClass('d-flex');
                $('.quick-order-payment-container:not(.desktop)').show();
              }
            } else {
              // Show quick order payment buttons when products exist, regardless of cart state
              if (
                data.wsOrderData.products &&
                data.wsOrderData.products.length > 0
              ) {
                if (window.innerWidth < 768) {
                  $('.quick-order-payment-container').css({
                    display: 'flex',
                    'flex-wrap': 'wrap',
                    gap: '3px',
                    'max-width': '600px',
                    'max-height': '220px',
                    overflow: 'hidden auto',
                  });
                } else {
                  $(
                    '.quick-order-payment-container.desktop > .payment-buttons-wrapper'
                  )
                    .removeClass('d-none')
                    .addClass('d-flex');
                  $('.quick-order-payment-container:not(.desktop)').show();
                }
              } else {
                $(
                  '.quick-order-payment-container.desktop > .payment-buttons-wrapper'
                )
                  .removeClass('d-flex')
                  .addClass('d-none');
                $('.quick-order-payment-container:not(.desktop)').hide();
              }
            }
            $('.quick-order-total-price').text(
              formattedPriceToShow(
                data.wsOrderData.total_with_discount ||
                  data.wsOrderData.exchange_amount
              )
            );

            $('.quick-order-quantity').text(
              data.wsOrderData.products.reduce(
                (total, product) => total + parseFloat(product.quantity),
                0
              )
            );

            // Toggle has-products class based on cart contents
            const totalQuantity = data.wsOrderData.products.reduce(
              (total, product) => total + parseFloat(product.quantity),
              0
            );

            if (totalQuantity > 0) {
              $('.small-cart-container').addClass('has-products');
              $('.reset-classic-shopping-cart-mini').removeClass(
                'd-none-custom'
              );
              $('#previousSaleBar').css({
                bottom: !prevSaleTimeoutId
                  ? '-200px'
                  : `${$('.small-cart-container.mobile').outerHeight() + 2.5}px`,
              });
            } else {
              $('.small-cart-container').removeClass('has-products');
              $('.reset-classic-shopping-cart-mini').addClass('d-none-custom');
              $('#previousSaleBar').css({ bottom: '0' });
            }

            $('.quick-order-total-price').addClass('scale-up');
            setTimeout(() => {
              $('.quick-order-total-price').removeClass('scale-up');
              if (data.wsOrderData.total_with_discount > 0) {
                $('.quick-order-button')
                  .filter(function () {
                    return (
                      $(this).attr('data-payment-method') !==
                      'payment_verifone_terminal'
                    );
                  })
                  .prop('disabled', false);
              }
            }, 200);
          }

          if (data.html !== undefined && data.html !== null) {
            if (locationCart.is_per_person_ordering_enabled) {
              $('#checkout').empty();
              $('#checkout').html(data.html);
              $('#checkout-mobile').empty();
              $('#checkout-mobile').html(data.html);

              if (
                data.tableGuestModalHtml !== undefined &&
                data.tableGuestModalHtml !== null
              ) {
                $('#content-body').append(data.tableGuestModalHtml);
              }

              $('.quick-order-payment-container:not(.desktop)').show();

              if (
                data.perPersonOrderingActions != undefined &&
                data.perPersonOrderingActions != null
              ) {
                $('.reset-classic-shopping-cart-mini').addClass(
                  'd-none-custom'
                );
                $('#small-cart-payment-buttons-wrapper').addClass('d-none');

                $('#small-cart-per-person-ordering-actions').html(
                  data.perPersonOrderingActions
                );

                $('.show-on-per-person-ordering').removeClass('d-none');
                $('.hide-on-per-person-ordering').addClass('d-none');

                $('.small-cart-container').addClass('has-products');
                $('#previousSaleBar').css({
                  bottom: !prevSaleTimeoutId
                    ? '-200px'
                    : `${$('.small-cart-container.mobile').outerHeight() + 2.5}px`,
                });
                $('#open-cart-mobile').addClass('has-products');

                $('#small-cart-table-name').text(
                  data.tableName ? `Bord ${data.tableName}` : ''
                );
              }
            } else {
              if ($('#product-extra-modal').length) {
                $('#product-extra-modal').remove();
              }
              if ($('#cart-modal').length) {
                $('#cart-modal').remove();
              }

              if (data.hasSplited) {
                $('#content').append(data.html);
                $('#split-by-sum').prop('disabled', true);
              } else {
                $('#checkout').empty();
                $('#checkout').html(data.html);
                $('#checkout-mobile').empty();
                $('#checkout-mobile').html(data.html);

                if (
                  locationCart.share_amount > 0 ||
                  locationCart.exchange_amount > 0
                ) {
                  const $visibleCartButton = $('#open-cart')
                    .filter(':visible')
                    .first();

                  if ($visibleCartButton.length) {
                    $visibleCartButton.trigger('click');
                  }
                }

                // IMPORTANT: Reapply flexbox layout after DOM replacement
                setTimeout(() => {
                  applyFlexboxCartLayout();
                }, 10);

                setTimeout(() => {
                  if (
                    locationCart.share_amount > 0 ||
                    locationCart.exchange_amount > 0
                  ) {
                    $('.product-qty-button').attr('disabled', true);
                    $('.product-qty-button').css('cursor', 'not-allowed');
                    if ($('#alt_checkbox').length > 0) {
                      document
                        .getElementById('alt_checkbox')
                        .style.setProperty('display', 'none', 'important');
                    }

                    $('.classic-products-container').css({
                      opacity: '0.5',
                      'pointer-events': 'none',
                      cursor: 'not-allowed',
                    });
                  } else if (locationCart.order_id) {
                    $('.classic-products-container').css({
                      opacity: '0.5',
                      'pointer-events': 'none',
                      cursor: 'not-allowed',
                    });
                  } else {
                    $('.product-qty-button').attr('disabled', false);
                    $('.product-qty-button').css('cursor', 'pointer');

                    $('.classic-products-container').css({
                      opacity: '',
                      'pointer-events': '',
                      cursor: '',
                    });
                  }
                }, 100);
              }
              if ($('#alt_checkbox').length > 0) {
                document
                  .getElementById('alt_checkbox')
                  .style.removeProperty('display');
              }
              if (locationCart.customer_id) {
                setTimeout(() => {
                  // $(".order-button").prop("disabled", true);
                  $(".order-button[data-payment-method='payment_credit']").prop(
                    'disabled',
                    false
                  );
                }, 100);
              }

              if (locationCart.table_number && !data.hasSplited) {
                $('.checkout-sub-menu').addClass('d-none');
              } else {
                $('.checkout-sub-menu').removeClass('d-none');
              }

              locationCart.products = data.cart_products;

              const totalAmount = parseFloat(
                String(
                  $('#cart-amount-with-tips').data('cart-amount-with-tips') ||
                    '0'
                ).replace(',', '.')
              );
              locationCart.amount = totalAmount;
              locationCart.amount_without_discount = floor(
                locationCart.products.reduce(
                  (total, product) =>
                    total +
                    parseFloat(
                      (product.amount * product.original_product_price).toFixed(
                        2
                      )
                    ),
                  0
                )
              );

              updateCartSummary();

              if (locationCart.order_discount_percent) {
                $('#discount-percent-input').val(
                  locationCart.order_discount_percent
                );
              }

              if (
                locationCart.order_storage_identifier != null &&
                locationCart.order_storage_identifier != ''
              ) {
                locationCart.payment_method = 'none';
                $('form#order_register_form').submit();
              } else if (
                autoPayWithTerminal !== undefined &&
                autoPayWithTerminal !== null &&
                autoPayWithTerminal === true
              ) {
                locationCart.payment_method = 'payment_terminal';
                $('form#order_register_form').submit();
              } else {
                if (
                  $('#split-payment-cart-modal').length &&
                  !$(data.html).hasClass('checkout-container')
                ) {
                  $('#split-payment-cart-modal').remove();
                  $('#content').append(data.html);
                  $('#split-payment-cart-modal').modal('show');
                }
              }

              if (
                $('body').attr('is_verifone') &&
                $(
                  '.order-button[data-payment-method="payment_verifone_terminal"]'
                ).hasClass('d-none-custom')
              ) {
                $(
                  '.order-button[data-payment-method="payment_verifone_terminal"]'
                ).removeClass('d-none-custom');
              }
            }
            // adjustCartItemHeight();
          }

          $("select[name='customer_number']").each(function () {
            $(this).select2({
              theme: 'bootstrap4',
            });
          });

          const allpersonlist = $('.select-person');
          if (
            allpersonlist.length > 0 &&
            !$(data.html).hasClass('checkout-container')
          ) {
            // Start checking from the last person backward
            for (let i = allpersonlist.length - 1; i >= 0; i--) {
              const $person = $(allpersonlist[i]);
              const personId = $person.attr('data-person-id');
              const paymentStatus = $person.attr('data-payment-status');

              // Find the first valid person
              if (paymentStatus != 2) {
                $person.click();
                return; // Stop once a valid person is clicked
              }
            }
          }

          if (hasDoubleClickedProduct) {
            const quickOrderButton = $('.quick-order-button').first();
            locationCart.order_storage_identifier = '';
            const paymentMethod = quickOrderButton.attr('data-payment-method');
            locationCart.payment_method = paymentMethod;
            if (
              paymentMethod === 'payment_terminal' ||
              paymentMethod === 'payment_verifone_terminal'
            ) {
              locationCart.terminal_id =
                quickOrderButton.attr('data-terminal-id');
            }

            if (paymentMethod === 'payment_split') {
              getPaymentSplitModal(locationCart);
            } else {
              $('form#order_register_form').submit();
            }
          }

          $('.order-card').each(function () {
            const terminalId = $(this).attr('id');
            $(".order-button[data-terminal-id='" + terminalId + "']").prop(
              'disabled',
              true
            );
          });

          if ($('body').attr('is_verifone') !== '1') {
            checkTerminalAvailability();
          }

          if (
            $('body').attr('is_verifone') == '1' &&
            data.is_tripletex_invoice_payment
          ) {
            closePanel();
          }

          adjustCheckoutActionsHeight();
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
          cartQuickPaymentTerminalLock = false;
        });
    };

    if (
      !error_message &&
      !splitOrderId &&
      localStorage.getItem('location-cart')
    ) {
      localStorage.removeItem('location-cart');
    }

    if (error_message && localStorage.getItem('location-cart')) {
      locationCart = JSON.parse(localStorage.getItem('location-cart'));
    }

    if (splitOrderId && localStorage.getItem('location-cart')) {
      locationCart = JSON.parse(localStorage.getItem('location-cart'));
      locationCart.order_id = splitOrderId;
    }

    // updateCartProducts();

    if (splitOrderId) {
      getPaymentSplitModal(locationCart);
    }

    var modalTimeout = null;
    $(document).on('click', '#recorder', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $(this).toggleClass('active');
      if ($(this).hasClass('active')) {
        startRecording();
        startOrResetFunction(() => {
          $('#product-suggestion-modal').modal({
            backdrop: 'static',
            keyboard: false,
          });

          modalTimeout = setTimeout(() => {
            $('#cancel-suggestion').click();
          }, 5000);
        }, 180000);
      } else {
        stopRecording();
        clearInactivityTimeout();
      }
    });

    $(document).on('click', '#continue-suggestion', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $('#product-suggestion-modal').modal('hide');
      clearTimeout(modalTimeout);
      startOrResetFunction(() => {
        $('#product-suggestion-modal').modal('show');
        modalTimeout = setTimeout(() => {
          $('#product-suggestion-modal').modal('hide');
        }, 5000);
      }, 180000);
    });

    $(document).on('click', '#cancel-suggestion', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $('#product-suggestion-modal').modal('hide');
      stopRecording();
      clearInactivityTimeout();
      clearTimeout(modalTimeout);
    });

    $(document).on('click', '.order-payment-split', function (e) {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      e.preventDefault();
      if (paymentSplittingAjaxLock) return;
      paymentSplittingAjaxLock = true;

      const siblingInput = $(this).closest('div').find('.payment-split-input');
      let giftcard_code = '';
      const $this = $(this);

      if ($('#payment-split-modal .split-payment-modal-close-btn').length > 0) {
        $('#payment-split-modal .split-payment-modal-close-btn').attr(
          'style',
          'display: none !important'
        );
      }

      if (!siblingInput.val() || parseFloat(siblingInput.val()) <= 0) {
        return;
      }

      const paidAmount = parseFloat(siblingInput.val());
      const orderId = $('#payment-split-modal').attr('data-order-id');
      const button = $(this);
      const buttonText = button.text();
      $('.order-button').attr('disabled', true);
      $(this).attr('disabled', true);
      $('#split-methods-select').attr('disabled', true);
      $('#payment-split-input').attr('disabled', true);

      locationCart.order_storage_identifier = '';
      const paymentMethod = $(this).attr('data-payment-method');
      locationCart.payment_split_method = paymentMethod;
      if (
        paymentMethod === 'payment_terminal' ||
        paymentMethod === 'payment_verifone_terminal'
      ) {
        locationCart.terminal_id = $(this).attr('data-terminal-id');
      }

      if (!localStorage.getItem('location-cart')) {
        localStorage.setItem('location-cart', JSON.stringify(locationCart));
      }

      button.empty();
      button.append('<div class="loader"></div>');

      if (paymentMethod == 'payment_giftcard') {
        giftcard_code = $('#giftCardCode').val();
      }

      if (orderId) {
        const payload = {
          order_id: orderId,
          amount: $('#payment-split-input').val(),
          payment_method: locationCart.payment_split_method,
          terminal_id: locationCart.terminal_id,
          shop_type,
          giftcard_code,
          table_number: locationCart.table_number,
          products: locationCart.products,
          tips_percent: locationCart.tips_percent,
          customer_number: locationCart.customer_id,
          table_guest_id: locationCart.table_guest_id ?? null,
          table_session_id: locationCart.table_session_id ?? null,
          booking_reference: locationCart.booking_reference || null,
          booking_id: locationCart.booking_id || null,
          is_printed: 1,
        };

        $.ajax({
          type: 'POST',
          url: '/api/v1/private/order/payment-split',
          data: payload,
        })
          .done(function (data) {
            if (data.order && data.orderProducts) {
              const orderReturn = data.order;
              const orderProductsReturn = data.orderProducts;
              const totalPrice = formattedPriceToShow(
                parseFloat(orderReturn.price_ex_vat_total) +
                  parseFloat(orderReturn.vat_total)
              );
              const productsWithCount = [];

              orderProductsReturn.forEach((product) => {
                const productDetail = `(${product.quantity})${product.name}`;
                productsWithCount.push(productDetail);
              });
              localStorage.setItem(
                'lastOrderProducts',
                JSON.stringify(productsWithCount)
              );
              localStorage.setItem('lastOrderTotal', totalPrice);
            }

            if (
              paymentMethod === 'payment_verifone_terminal' &&
              data.payment_data
            ) {
              if (isVerifone) {
                passVerifoneDataToWebView(data.payment_data);
              } else {
                const verifonePayload = {
                  type: 'verifone',
                  action: 'start_payment',
                  verifoneSerialNumber: payload.terminal_id,
                  paymentData: data.payment_data,
                  senderDeviceId: localStorage.getItem('deviceID'),
                };

                localStorage.setItem(
                  'vt_' + payload.terminal_id,
                  JSON.stringify(verifonePayload)
                );

                sendWhenReady(
                  window.globalSocket,
                  JSON.stringify(verifonePayload)
                );
              }
              return;
            }

            $this.find('div.loader').remove();
            $('.order-button').attr('disabled', false);
            $('.order-payment-split').attr('disabled', false);
            button.text(buttonText);
            siblingInput.val('');
            const currentDeviceId = localStorage.getItem('deviceID');

            if (data.order_id !== null && data.order_id !== undefined) {
              $('#payment-split-modal').attr('data-order-id', data.order_id);
            }

            if (paymentMethod === 'payment_cash') {
              const message = {
                action: 'open_drawer',
                printer: data.drawer_settings,
              };

              if (data.main_pos && data.main_pos === currentDeviceId) {
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
              } else {
                const socketData = {
                  type: 'open_drawer',
                  main_pos_device_id: data.main_pos,
                  requested_device_id: currentDeviceId,
                  message,
                };

                window.globalSocket.send(JSON.stringify(socketData));
              }
            }

            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('order', orderId);
            window.history.replaceState({}, '', currentUrl.toString());

            if (paymentMethod === 'payment_terminal') {
              const terminalId = $this.attr('data-terminal-id');

              if (!orderId) {
                $('#order-payment-split, #payment-split-input').attr(
                  'disabled',
                  false
                );
              }
            }

            if (
              data.payment_redirect_url !== undefined &&
              data.payment_redirect_url !== null
            ) {
              document.location.href = data.payment_redirect_url;
              return;
            }

            let totalAmount = parseFloat(
              $('.payment-split-input').first().attr('data-max-allowed')
            );
            const remainingAmout = parseFloat(
              $('#total-amount').attr('data-total-amount')
            );
            const totalPaid = totalAmount - remainingAmout + paidAmount;

            if (totalPaid > 0) {
              let remainingValue = (totalAmount * 100 - totalPaid * 100) / 100;
              $('#total-amount').text(
                `Gjenværende totalt: ${formattedPriceToShow(remainingValue)}`
              );
              $('#total-amount').attr('data-total-amount', remainingValue);

              $('#payment-split-input').val(remainingValue);
              $('#payment-split-input').attr(
                'data-max-allowed',
                remainingValue
              );
            }
            const orderHtml =
              data.order_html !== undefined && data.order_html !== null
                ? data.order_html
                : '';

            if ($('#content').hasClass('is-employee') && orderHtml !== '') {
              $('#payment-split-modal').modal('hide');

              $('#cart-modal').modal('hide');
              $('.modal-backdrop').remove();
              const $confirmationStyle = $('#classic-location-products').data(
                'order-confirmation-toast-style'
              );
              $('.confirmation-toast').remove();
              if (orderHtml) {
                $('.confirmation-toast').remove();
                $('#content').append(
                  '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                    (window.innerWidth >= 500 ? ' right: 0;' : '') +
                    ' width: 480px; display: none;">' +
                    '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                    ($confirmationStyle == 'compact' ? 'false' : 'true') +
                    '" data-delay="' +
                    ($confirmationStyle === 'compact' ? 100000 : 3000) +
                    '">' +
                    '  <div class="toast-header">' +
                    '    <strong class="mr-auto">Ordre registrert</strong>' +
                    '    <small></small>' +
                    '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                    '      <span aria-hidden="true">&times;</span>' +
                    '    </button>' +
                    '  </div>' +
                    '  <div class="toast-body">' +
                    orderHtml +
                    '  </div>' +
                    '</div>' +
                    '</div>'
                );
              }

              if (
                data.item_count &&
                data.total_amount &&
                $confirmationStyle === 'compact'
              ) {
                showPreviousSaleBar(data.item_count, data.total_amount);
              } else {
                $('.confirmation-toast').css({ padding: '1rem' }).show();
                $('.confirmation-toast-box')
                  .toast('show')
                  .on('hidden.bs.toast', function () {
                    $('.confirmation-toast').attr('style', function (i, s) {
                      return (s || '') + 'padding: 0px !important;';
                    });
                  });
              }

              removeQueryParams('order');
              splitOrderId = null;
              locationCart.order_id = null;
              localStorage.removeItem('location-cart');

              if (data.order_data) {
                let orderData = { orderData: data.order_data };
                if (!locationCart.table_number && data.production_print_data) {
                  orderData = {
                    orderData: [
                      ...data.order_data,
                      ...data.production_print_data,
                    ],
                  };
                }

                cancelOrderPull();
                isPullOrderPending = true;
                if (
                  window.ReactNativeWebView &&
                  data.main_pos &&
                  data.main_pos === currentDeviceId
                ) {
                  passDataToWebView(event, 'print_poll_order', orderData);
                } else if (window.ReactNativeWebView) {
                  sendWhenReady(
                    window.globalSocket,
                    JSON.stringify({
                      type: 'print_pull_data',
                      main_pos_device_id: data.main_pos,
                      orderData,
                    })
                  );
                }
              }
              emptyCart('order_complete');
            }
            locationCart.giftcard_code = '';
            locationCart.giftcards = [];
          })
          .fail(function (data) {
            if (
              data.responseJSON &&
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
            $this.find('div.loader').remove();
            $('.order-button').attr('disabled', false);
            $('.order-payment-split').attr('disabled', false);
            button.text(buttonText);
            errorPopupAlert('Payment fail!');
            if (
              data.responseJSON !== undefined &&
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              if (!$('#order-button-wrapper').is(':visible')) {
                alert(data.responseJSON.error_message);
              } else {
              }
            }

            if (paymentMethod === 'payment_terminal') {
              const terminalId = $this.attr('data-terminal-id');

              $(
                ".payment-split-input[data-terminal-id='" + terminalId + "']"
              ).attr('disabled', false);

              if (
                $(
                  ".payment-split-input[data-payment-method='payment_terminal'][disabled]"
                ).length === 0
              ) {
                $(
                  ".payment-split-input[data-payment-method='nets_card'], .payment-split-input[data-payment-method='nets_vipps']"
                ).attr('disabled', false);
                $(
                  ".order-payment-split[data-payment-method='nets_card'], .order-payment-split[data-payment-method='nets_vipps']"
                ).attr('disabled', false);
              }

              if (!orderId) {
                $('.order-payment-split, .payment-split-input').attr(
                  'disabled',
                  false
                );
              }
            }
            cartQuickPaymentTerminalLock = false;
          })
          .always(function () {
            hasDoubleClickedProduct = false;

            if (payload.payment_method !== 'payment_verifone_terminal') {
              button.attr('disabled', false);
              $('#split-methods-select').attr('disabled', false);
              $('#payment-split-input').attr('disabled', false);
            }

            if (payload.payment_method == 'payment_giftcard') {
              $('#giftCardCode').val('');
              $('#giftcard-split-error, #giftcard-split-feedback')
                .empty()
                .addClass('d-none');
              $('#payment-split-input').val('');
              $('#payment-split-input').attr('disabled', true);
              $('#payment-split-button').attr('disabled', true);
            }
            paymentSplittingAjaxLock = false;
          });

        return;
      }

      if ($('#pick-up-at-the-bar').length) {
        locationCart.pick_up_at_the_bar = true;
      }

      let newOrderData = {
        location_id: locationId,
        location_type: locationCart.location_type,
        table_number: locationCart.table_number,
        products: locationCart.products,
        tips_percent: locationCart.tips_percent,
        payment_method: locationCart.payment_method,
        terminal_id: locationCart.terminal_id,
        comment: locationCart.comment,
        name: locationCart.name,
        phone_number: locationCart.phone_number,
        pickup_date: locationCart.pickup_date,
        pickup_time: locationCart.pickup_time,
        promo_code: locationCart.promo_code,
        custom_pickup_time: $('#custom_pickup_time').val(),
        pick_up_at_the_bar: locationCart.pick_up_at_the_bar,
        order_storage_identifier: locationCart.order_storage_identifier,
        userId,
        customer_number: locationCart.customer_id,
        customer_contact_person_id: locationCart.customer_contact_person_id,
        shop_type,
        split_payment_method: locationCart.payment_split_method,
        split_payment_amount: $('#payment-split-input').val(),
        is_takeaway: locationCart.is_takeaway_checked,
        giftcard_code,
        booking_reference: locationCart.booking_reference || null,
        booking_id: locationCart.booking_id || null,
        table_session_id: locationCart.table_session_id || null,
        table_guest_id: locationCart.table_guest_id || null,
        invoice_reference: $('#invoice-reference').val() || null,
        is_printed: window.ReactNativeWebView ? 1 : 0,
      };

      if (orderStorageIds !== null) {
        newOrderData.order_storage_ids = orderStorageIds;
      }
      $.ajax({
        type: 'POST',
        url: '/ajax/order/new',
        data: newOrderData,
        timeout: 240000,
      })
        .done(function (data) {
          if (newOrderData.table_number) {
            fetchDataAndSend();
          }

          if (
            paymentMethod === 'payment_verifone_terminal' &&
            data.payment_data
          ) {
            if (data.order_id !== null && data.order_id !== undefined) {
              $('#payment-split-modal').attr('data-order-id', data.order_id);
              const currentUrl = new URL(window.location.href);
              currentUrl.searchParams.set('order', data.order_id);
              window.history.replaceState({}, '', currentUrl.toString());
            }

            if (isVerifone) {
              passVerifoneDataToWebView(data.payment_data);
            } else {
              const payload = {
                type: 'verifone',
                action: 'start_payment',
                verifoneSerialNumber: newOrderData.terminal_id,
                paymentData: data.payment_data,
                senderDeviceId: localStorage.getItem('deviceID'),
              };

              localStorage.setItem(
                'vt_' + newOrderData.terminal_id,
                JSON.stringify(payload)
              );

              sendWhenReady(window.globalSocket, JSON.stringify(payload));
            }
            return;
          }

          $this.find('div.loader').remove();
          $('.order-button').attr('disabled', false);
          $('.order-payment-split').attr('disabled', false);
          button.text(buttonText);
          siblingInput.val('');
          if (
            data.payment_redirect_url !== undefined &&
            data.payment_redirect_url !== null
          ) {
            document.location.href = data.payment_redirect_url;
            return;
          }

          const currentDeviceId = localStorage.getItem('deviceID');
          if (data.order_id !== null && data.order_id !== undefined) {
            $('#payment-split-modal').attr('data-order-id', data.order_id);
            if (paymentMethod === 'payment_cash') {
              const message = {
                action: 'open_drawer',
                printer: data.drawer_settings,
              };

              if (data.main_pos && data.main_pos === currentDeviceId) {
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
              } else {
                const socketData = {
                  type: 'open_drawer',
                  main_pos_device_id: data.main_pos,
                  requested_device_id: currentDeviceId,
                  message,
                };

                window.globalSocket.send(JSON.stringify(socketData));
              }
            }
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('order', data.order_id);
            window.history.replaceState({}, '', currentUrl.toString());
          }

          if (paymentMethod === 'payment_terminal') {
            const terminalId = $this.attr('data-terminal-id');
            $(
              ".payment-split-input[data-terminal-id='" + terminalId + "']"
            ).attr('disabled', false);

            if (
              $(
                ".payment-split-input[data-payment-method='payment_terminal'][disabled]"
              ).length === 0
            ) {
              $(
                ".payment-split-input[data-payment-method='nets_card'], .payment-split-input[data-payment-method='nets_vipps']"
              ).attr('disabled', false);
              $(
                ".order-payment-split[data-payment-method='nets_card'], .order-payment-split[data-payment-method='nets_vipps']"
              ).attr('disabled', false);
            }

            if (!orderId) {
              $('.order-payment-split, .payment-split-input').attr(
                'disabled',
                false
              );
            }
          }

          let totalAmount = parseFloat(
            $('.payment-split-input').first().attr('data-max-allowed')
          );
          const remainingAmout = parseFloat(
            $('#total-amount').attr('data-total-amount')
          );
          const totalPaid = totalAmount - remainingAmout + paidAmount;
          if (totalPaid > 0) {
            let remainingValue = (totalAmount * 100 - totalPaid * 100) / 100;
            $('#total-amount').text(
              `Gjenværende totalt: ${formattedPriceToShow(remainingValue)}`
            );
            $('#total-amount').attr('data-total-amount', remainingValue);

            $('#payment-split-input').val(remainingValue);
            $('#payment-split-input').attr('data-max-allowed', remainingValue);
          }
          const orderHtml =
            data.order_html !== undefined && data.order_html !== null
              ? data.order_html
              : '';

          if ($('#content').hasClass('is-employee') && orderHtml !== '') {
            $('#payment-split-modal').modal('hide');

            $('#cart-modal').modal('hide');
            $('.modal-backdrop').remove();
            const $confirmationStyle = $('#classic-location-products').data(
              'order-confirmation-toast-style'
            );
            $('.confirmation-toast').remove();
            if (orderHtml) {
              $('.confirmation-toast').remove();
              $('#content').append(
                '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                  (window.innerWidth >= 500 ? ' right: 0;' : '') +
                  ' width: 480px; display: none;">' +
                  '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                  ($confirmationStyle == 'compact' ? 'false' : 'true') +
                  '" data-delay="' +
                  ($confirmationStyle === 'compact' ? 100000 : 3000) +
                  '">' +
                  '  <div class="toast-header">' +
                  '    <strong class="mr-auto">Ordre registrert</strong>' +
                  '    <small></small>' +
                  '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                  '      <span aria-hidden="true">&times;</span>' +
                  '    </button>' +
                  '  </div>' +
                  '  <div class="toast-body">' +
                  orderHtml +
                  '  </div>' +
                  '</div>' +
                  '</div>'
              );

              if (data.isTableActive && data.tableNumber) {
                if (!$('#split-payment-cart-modal').length) {
                  getSavedOrder(
                    organizerId,
                    locationId,
                    data.tableNumber,
                    true
                  );
                }
                emptyCart('order_complete');
              } else {
                emptyCart('order_complete');
              }
            }
            localStorage.removeItem('location-cart');

            if (
              data.item_count &&
              data.total_amount &&
              $confirmationStyle === 'compact'
            ) {
              showPreviousSaleBar(data.item_count, data.total_amount);
            } else {
              $('.confirmation-toast').css({ padding: '1rem' }).show();
              $('.confirmation-toast-box')
                .toast('show')
                .on('hidden.bs.toast', function () {
                  $('.confirmation-toast').attr('style', function (i, s) {
                    return (s || '') + 'padding: 0px !important;';
                  });
                });
            }

            removeQueryParams('order');
            splitOrderId = null;
            locationCart.order_id = null;

            if (data.order_data) {
              let orderData = { orderData: data.order_data };

              if (!locationCart.table_number && data.production_print_data) {
                orderData = {
                  orderData: [
                    ...data.order_data,
                    ...data.production_print_data,
                  ],
                };
              }

              cancelOrderPull();
              isPullOrderPending = true;
              if (
                window.ReactNativeWebView &&
                data.main_pos &&
                data.main_pos === currentDeviceId
              ) {
                passDataToWebView(event, 'print_poll_order', orderData);
              } else if (window.ReactNativeWebView) {
                sendWhenReady(
                  window.globalSocket,
                  JSON.stringify({
                    type: 'print_pull_data',
                    main_pos_device_id: data.main_pos,
                    orderData,
                  })
                );
              }
            }

            if (newOrderData.payment_method == 'payment_giftcard') {
              $('#giftCardCode').val('');
              $('#payment-split-button').attr('disabled', true);
              $('#payment-split-input').attr('disabled', true);
            }
          }
          locationCart.giftcard_code = '';
          locationCart.giftcards = [];
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
          $('div.loader').remove();
          $('.order-button').attr('disabled', false);
          $('.order-payment-split').attr('disabled', false);
          button.text(buttonText);
          errorPopupAlert('Payment fail!');
          if (
            data.responseJSON !== undefined &&
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            if (!$('#order-button-wrapper').is(':visible')) {
              alert(data.responseJSON.error_message);
            } else {
              blinkButton(
                $(`.terminal-button-${locationCart.terminal_id}`),
                'red'
              );
              $('.loader').attr('hidden', true);
              prependAlert(
                '#order-button-wrapper, #terminal-modal-body',
                data.responseJSON.error_message,
                'danger',
                null,
                '#order_register_form'
              );
            }
          }
          if (paymentMethod === 'payment_terminal') {
            if (!orderId) {
              $('.order-payment-split, .payment-split-input').attr(
                'disabled',
                false
              );
            }
          }
          cartQuickPaymentTerminalLock = false;
        })
        .always(function () {
          locationCart.order_storage_identifier = '';
          hasDoubleClickedProduct = false;
          if (
            newOrderData.split_payment_method !== 'payment_verifone_terminal'
          ) {
            button.attr('disabled', false);
            $('#split-methods-select').attr('disabled', false);
            $('#payment-split-input').attr('disabled', false);
          }
          if (newOrderData.split_payment_method == 'payment_giftcard') {
            $('#giftCardCode').val('');
            $('#giftcard-split-error, #giftcard-split-feedback')
              .empty()
              .addClass('d-none');
            $('#payment-split-input').val('');
            $('#payment-split-input').attr('disabled', true);
            $('#payment-split-button').attr('disabled', true);
          }
          paymentSplittingAjaxLock = false;
        });
    });

    function getAppliedGiftCards() {
      if (!Array.isArray(locationCart.giftcards)) {
        locationCart.giftcards = [];
      }

      return locationCart.giftcards;
    }

    function getAppliedGiftCardTotal() {
      return getAppliedGiftCards().reduce(
        (total, giftCard) => total + parseFloat(giftCard.amount),
        0
      );
    }

    function getGiftCardCartAmount() {
      const renderedTotal = parseFloat(
        String($('#cart-amount').data('total-price') ?? '').replace(',', '.')
      );
      if (!isNaN(renderedTotal) && renderedTotal > 0) {
        return floor(renderedTotal);
      }

      if (!Array.isArray(locationCart.products)) {
        return parseFloat(locationCart.amount) || 0;
      }

      return floor(
        locationCart.products.reduce(
          (total, product) =>
            total +
            parseFloat(
              (
                (parseFloat(product.amount) || 0) *
                (parseFloat(product.original_product_price) || 0) *
                (1 - (parseFloat(product.discount_percent) || 0) / 100)
              ).toFixed(2)
            ),
          0
        )
      );
    }

    function getGiftCardOrderTotal() {
      const tipsPercent = parseFloat(locationCart.tips_percent) || 0;
      return floor(getGiftCardCartAmount() * (1 + tipsPercent / 100));
    }

    function setOtherPaymentButtonsDisabled(shouldDisable) {
      $('.checkout-actions-container [data-payment-method]')
        .not('[id="payment-giftcard"]')
        .each(function () {
          const paymentButton = $(this);
          if (shouldDisable) {
            if (paymentButton.data('disabled-before-giftcard') === undefined) {
              paymentButton.data(
                'disabled-before-giftcard',
                paymentButton.prop('disabled')
              );
            }
            paymentButton
              .prop('disabled', true)
              .addClass('giftcard-payment-disabled');
            paymentButton.attr('aria-disabled', 'true');
          } else if (
            paymentButton.data('disabled-before-giftcard') !== undefined
          ) {
            paymentButton.prop(
              'disabled',
              paymentButton.data('disabled-before-giftcard')
            );
            paymentButton.removeData('disabled-before-giftcard');
            paymentButton.removeClass('giftcard-payment-disabled');
            paymentButton.removeAttr('aria-disabled');
          }
        });
    }

    function setGiftCardPaymentButtonLabel(paymentButton, label) {
      const labelElement = paymentButton.find('span').last();
      if (labelElement.length) {
        labelElement.text(label);
        return;
      }

      const textNodes = paymentButton.contents().filter(function () {
        return this.nodeType === Node.TEXT_NODE && this.nodeValue.trim();
      });
      if (textNodes.length) {
        textNodes.last()[0].nodeValue = ` ${label}`;
      }
    }

    function renderAppliedGiftCards() {
      const giftCards = getAppliedGiftCards();
      let amountToAllocate = getGiftCardOrderTotal();
      giftCards.forEach(function (giftCard) {
        const availableAmount = parseFloat(
          giftCard.amount_left === undefined
            ? giftCard.amount
            : giftCard.amount_left
        );
        giftCard.amount = Math.min(availableAmount, amountToAllocate);
        amountToAllocate = Math.max(0, amountToAllocate - giftCard.amount);
      });
      const appliedTotal = floor(getAppliedGiftCardTotal());
      const remainingTotal = Math.max(
        0,
        floor(getGiftCardOrderTotal() - appliedTotal)
      );

      const containers = $('.gift-card-section-container');
      const container = containers.first();
      const removeLabel = container.data('remove-label') || 'Fjern gavekort';
      const defaultLabel = container.data('default-label') || 'Gavekort';
      const payLabel = container.data('pay-label') || 'Betal med gavekort';
      const feedback = containers.find('[id="giftcard-feedback"]');
      feedback.addClass('alert alert-success py-2 mb-2');

      $('.applied-giftcards').each(function () {
        const list = $(this).empty();
        giftCards.forEach(function (giftCard) {
          const row = $('<div>').addClass(
            'd-flex justify-content-between align-items-center border rounded px-2 py-1 mb-1'
          );
          const description = $('<span>').text(
            `${giftCard.code}: ${parseFloat(giftCard.amount).toFixed(2)} kr`
          );
          const removeButton = $('<button>')
            .attr('type', 'button')
            .attr('data-giftcard-code', giftCard.code)
            .addClass('btn btn-sm btn-outline-danger remove-applied-giftcard')
            .text(removeLabel);
          row.append(description, removeButton);
          list.append(row);
        });
      });

      locationCart.giftcard_code = giftCards.length ? giftCards[0].code : '';

      $('[id="giftcard-discount-text"]').text(
        container.data('total-label') || 'Gavekort:'
      );
      $('[id="giftcard-discount"]').text(appliedTotal.toFixed(2));
      $('[id="subtotal-with-giftcard"]').text(remainingTotal.toFixed(2));
      $('[id="giftcard-discount-summary"]').toggleClass(
        'd-none',
        !giftCards.length
      );

      const paymentButton = $(
        '[id="show-giftcard-section"], [id="payment-giftcard"]'
      );
      if (giftCards.length && remainingTotal <= 0) {
        paymentButton
          .attr('id', 'payment-giftcard')
          .attr('type', 'submit')
          .attr('data-payment-method', 'payment_giftcard')
          .addClass('order-button')
          .removeClass('btn-light btn-primary')
          .addClass('btn-success text-white')
          .prop('disabled', false);
        setGiftCardPaymentButtonLabel(paymentButton, payLabel);
        paymentButton.attr('aria-label', payLabel).attr('title', payLabel);
        feedback
          .removeClass('d-none')
          .text(
            container.data('ready-message') ||
              'Hele beløpet er dekket. Trykk Betal med gavekort.'
          );
      } else {
        paymentButton
          .attr('id', 'show-giftcard-section')
          .attr('type', 'button')
          .removeAttr('data-payment-method')
          .removeClass('order-button')
          .removeClass('btn-success text-white')
          .addClass('btn-light')
          .prop('disabled', false);
        setGiftCardPaymentButtonLabel(paymentButton, defaultLabel);
        paymentButton
          .attr('aria-label', defaultLabel)
          .attr('title', defaultLabel);
        if (giftCards.length) {
          feedback
            .removeClass('d-none')
            .text(
              container.data('add-another-message') ||
                'Legg til et nytt gavekort for gjenstående beløp.'
            );
        } else {
          feedback.addClass('d-none').empty();
        }
      }
      setOtherPaymentButtonsDisabled(giftCards.length > 0);
    }

    $(document).on('click', '.remove-applied-giftcard', function () {
      const giftCardCode = $(this).attr('data-giftcard-code');
      locationCart.giftcards = getAppliedGiftCards().filter(
        (giftCard) => giftCard.code !== giftCardCode
      );
      renderAppliedGiftCards();
    });

    $(document).on('click', '#giftcard-remove', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      $(this).closest('.gift-card-section').find('#giftcard-code').val('');
      $(this).addClass('d-none');
      const mainGiftcardContainer = $(this).closest(
        '.gift-card-section-container'
      );
      const closetDiscountSummary = $(this)
        .closest('.gift-card-section-container')
        .siblings('#giftcard-discount-summary')
        .first();
      mainGiftcardContainer.find('#giftcard-error').addClass('d-none');
      mainGiftcardContainer.find('#giftcard-feedback').addClass('d-none');
      mainGiftcardContainer.find('#giftcard-feedback').addClass('d-none');
      closetDiscountSummary.find('#subtotal-with-giftcard').text('0');

      closetDiscountSummary.addClass('d-none');
      // $(".order-button[data-payment-method=payment_giftcard]").prop(
      //   "disabled",
      //   true
      // );
      // $(".order-button[data-payment-method=payment_giftcard]").addClass("d-none");
      $('.order-button[data-payment-method=payment_giftcard]').replaceWith(`
                <button
                  type="button"
                  id="show-giftcard-section"
                  class="btn btn-light checkout-action"
                >
                <svg width="24" height="24" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 0C11.7316 0 11.0308 0.288854 10.5 0.763896C9.96924 0.288854 9.26836 0 8.5 0C6.84315 0 5.5 1.34315 5.5 3C5.5 3.35064 5.56015 3.68722 5.67071 4H2C1.17157 4 0.5 4.67157 0.5 5.5V8.5C0.5 9.32843 1.17157 10 2 10H2.5V19.5C2.5 20.3284 3.17157 21 4 21H17C17.8284 21 18.5 20.3284 18.5 19.5V10H19C19.8284 10 20.5 9.32843 20.5 8.5V5.5C20.5 4.67157 19.8284 4 19 4H15.3293C15.4398 3.68722 15.5 3.35064 15.5 3C15.5 1.34315 14.1569 0 12.5 0ZM2.5 8V6H9.5V8H2.5ZM9.5 10H4.5V19H9.5V10ZM11.5 19V10H16.5V19H11.5ZM11.5 8V6H18.5V8H11.5ZM8.5 2C9.05228 2 9.5 2.44772 9.5 3C9.5 3.55228 9.05228 4 8.5 4C7.94772 4 7.5 3.55228 7.5 3C7.5 2.44772 7.94772 2 8.5 2ZM12.5 4C13.0523 4 13.5 3.55228 13.5 3C13.5 2.44772 13.0523 2 12.5 2C11.9477 2 11.5 2.44772 11.5 3C11.5 3.55228 11.9477 4 12.5 4Z" fill="#000"></path>
                </svg>
                  Gavekort
                </button>
      `);
      // adjustCartItemHeight();
      // $(".order-button").prop("disabled", false);
      locationCart.giftcard_code = '';
      locationCart.giftcards = [];
      renderAppliedGiftCards();
    });

    $(document).on('click', '#validate-giftcard', function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let giftcardCode = $(this)
        .closest('.gift-card-section')
        .find('#giftcard-code')
        .val()
        .trim();

      if (!giftcardCode) {
        return;
      }

      if (
        getAppliedGiftCards().some((giftCard) => giftCard.code === giftcardCode)
      ) {
        const duplicateMessage = $('.gift-card-section-container')
          .first()
          .data('duplicate-error');
        $('#giftcard-error').removeClass('d-none').text(duplicateMessage);
        return;
      }

      const mainGiftcardContainer = $(this).closest(
        '.gift-card-section-container'
      );
      mainGiftcardContainer.find('#giftcard-remove').removeClass('d-none');
      const closetDiscountSummary = $(this)
        .closest('.gift-card-section-container')
        .siblings('#giftcard-discount-summary')
        .first();
      $('#giftcard-error').addClass('d-none');
      $('#giftcard-feedback').addClass('d-none');
      // Get the new state of the checkbox
      locationCart.amount = getGiftCardCartAmount();

      $.ajax({
        type: 'POST',
        url: '/api/v1/gift-card/validate',
        data: {
          code: giftcardCode,
          total_amount: Math.max(
            0,
            floor(getGiftCardOrderTotal() - getAppliedGiftCardTotal())
          ),
          location_id: locationId,
          allow_partial: 1,
        },
      })
        .done(function (data) {
          if (data.code === giftcardCode && data.html !== undefined) {
            getAppliedGiftCards().push({
              code: data.code,
              amount: parseFloat(data.giftcard_discount),
              amount_left: parseFloat(data.amount_left),
            });
            locationCart.giftcard_code = data.code;
            mainGiftcardContainer
              .find('#giftcard-feedback')
              .removeClass('d-none');
            mainGiftcardContainer.find('#giftcard-feedback').html(data.html);

            closetDiscountSummary.removeClass('d-none');

            closetDiscountSummary
              .find('#giftcard-discount')
              .text(data.giftcard_discount);
            closetDiscountSummary
              .find('#giftcard-discount-text')
              .text(data.giftcard_discount_text);
            // $("#payment-giftcard").removeClass("d-none");
            // $("#payment-giftcard").prop("disabled", false);
            $('#show-giftcard-section, #payment-giftcard').replaceWith(`
              <button
                type="submit"
                id="payment-giftcard"
                class="btn btn-light checkout-action order-button"
                data-payment-method="payment_giftcard"
              >
              <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9997 10.6667C13.0542 10.6667 10.6663 13.0546 10.6663 16.0001C10.6663 18.9456 13.0542 21.3334 15.9997 21.3334C18.9452 21.3334 21.333 18.9456 21.333 16.0001C21.333 13.0546 18.9452 10.6667 15.9997 10.6667ZM13.333 16.0001C13.333 14.5273 14.5269 13.3334 15.9997 13.3334C17.4724 13.3334 18.6663 14.5273 18.6663 16.0001C18.6663 17.4728 17.4724 18.6667 15.9997 18.6667C14.5269 18.6667 13.333 17.4728 13.333 16.0001Z" fill="#000"></path>
                <path d="M26.6663 16.0001C26.6663 17.1047 25.7709 18.0001 24.6663 18.0001C23.5618 18.0001 22.6663 17.1047 22.6663 16.0001C22.6663 14.8955 23.5618 14.0001 24.6663 14.0001C25.7709 14.0001 26.6663 14.8955 26.6663 16.0001Z" fill="#000"></path>
                <path d="M7.33301 18.0001C8.43758 18.0001 9.33301 17.1047 9.33301 16.0001C9.33301 14.8955 8.43758 14.0001 7.33301 14.0001C6.22844 14.0001 5.33301 14.8955 5.33301 16.0001C5.33301 17.1047 6.22844 18.0001 7.33301 18.0001Z" fill="#000"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66634 6.66675C2.82539 6.66675 1.33301 8.15913 1.33301 10.0001V22.0001C1.33301 23.841 2.82539 25.3334 4.66634 25.3334H27.333C29.174 25.3334 30.6663 23.841 30.6663 22.0001V10.0001C30.6663 8.15913 29.174 6.66675 27.333 6.66675H4.66634ZM3.99967 10.0001C3.99967 9.63189 4.29815 9.33341 4.66634 9.33341H27.333C27.7012 9.33341 27.9997 9.63189 27.9997 10.0001V22.0001C27.9997 22.3683 27.7012 22.6667 27.333 22.6667H4.66634C4.29815 22.6667 3.99967 22.3683 3.99967 22.0001V10.0001Z" fill="#000"></path>
              </svg>
                Gavekort
              </button>
            `);
            closetDiscountSummary
              .find('#subtotal-with-giftcard')
              .text(data.subtotal);
            $('#giftcard-discount-summary').removeClass('d-none');
            $('.order-button[data-payment-method=payment_giftcard]').prop(
              'disabled',
              false
            );
            // $(".order-button").prop("disabled", true);
            $(".order-button[data-payment-method='payment_giftcard']").prop(
              'disabled',
              false
            );

            mainGiftcardContainer.find('#giftcard-code').val('');
            mainGiftcardContainer.find('#giftcard-remove').addClass('d-none');
            renderAppliedGiftCards();

            // adjustCartItemHeight();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
          if (
            data.responseJSON !== undefined &&
            data.responseJSON.error.message !== undefined &&
            data.responseJSON.error.message !== null
          ) {
            mainGiftcardContainer.find('#giftcard-feedback').empty();
            mainGiftcardContainer.find('#giftcard-feedback').addClass('d-none');

            closetDiscountSummary.find('#giftcard-discount').text('0');
            closetDiscountSummary.find('#subtotal-with-giftcard').text('0');

            closetDiscountSummary.addClass('d-none');

            mainGiftcardContainer.find('#giftcard-error').removeClass('d-none');
            mainGiftcardContainer
              .find('#giftcard-error')
              .text(data.responseJSON.error.message);

            $('.order-button[data-payment-method=payment_giftcard]').prop(
              'disabled',
              true
            );

            if (data.responseJSON.error.code != 422) {
              locationCart.giftcard_code = '';
            }
            renderAppliedGiftCards();
            // adjustCartItemHeight();
          }
        });
    });

    $(document).on('keydown', '#giftcard-code', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        $('#validate-giftcard').click();
      }
    });

    $(document).on(
      'click',
      '.order-button[data-payment-method="payment_cash"]',
      function (e) {
        const button = $(this);
        const isEnableCashExchange =
          button.attr('data-enable-cash-exchange') == 1;
        if (isEnableCashExchange) {
          const totalAmount =
            locationCart.share_amount > 0
              ? locationCart.share_amount
              : locationCart.amount > 0
                ? locationCart.amount
                : locationCart.amount_without_discount;

          $('#payment-change-modal #amount-to-pay').text(
            formattedPriceToShow(totalAmount)
          );
          $('#paid-amount-input').val(totalAmount).trigger('input');
          $('#payment-change-modal').modal('show');
        }
      }
    );

    $(document).on(
      'change',
      'input[name="paid-amount"][type="radio"]',
      function () {
        const paidAmount = $(this).val();
        $('#paid-amount-input').val(paidAmount).trigger('input');
        const totalAmount =
          locationCart.share_amount > 0
            ? locationCart.share_amount
            : locationCart.amount > 0
              ? locationCart.amount
              : locationCart.amount_without_discount;
        const exchangeAmount = paidAmount - totalAmount;
        $('#exchange-amount').text(
          formattedPriceToShow(Math.max(0, exchangeAmount))
        );
      }
    );

    $(document).on('input', '#paid-amount-input', function () {
      $('input[name="paid-amount"]').prop('checked', false);
      $('input[name="paid-amount"]').closest('label').removeClass('active');

      const paidAmount = Number($(this).val());

      const totalAmount =
        locationCart.share_amount > 0
          ? locationCart.share_amount
          : locationCart.amount > 0
            ? locationCart.amount
            : locationCart.amount_without_discount;

      const exchangeAmount = paidAmount - totalAmount;

      if (exchangeAmount >= 0) {
        $('#register-cash-payment-order').prop('disabled', false);
      } else {
        $('#register-cash-payment-order').prop('disabled', true);
      }

      $('#exchange-amount').text(formattedPriceToShow(exchangeAmount));
    });

    $(document).on('click', '.register-cash-payment-order', function () {
      $('form#order_register_form').submit();
      $('#payment-change-modal').modal('hide');
    });

    $(document).on('hide.bs.modal', '#payment-change-modal', function () {
      $('#exchange-amount').text('00,-');
      $('input[name="paid-amount"]').prop('checked', false);
      $('input[name="paid-amount"]').closest('label').removeClass('active');
      $('#paid-amount-input').val('');
    });
  }

  $(document).on('keydown', '#giftCardCode', function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      $('#validateGiftCard').click();
    }
  });

  $(document).on('change', '#giftCardCode', function () {
    $('#payment-split-button').attr('disabled', true);
    $('#payment-split-input').attr('disabled', true);
    $('#giftcard-split-error, #giftcard-split-feedback')
      .empty()
      .addClass('d-none');
  });

  $(document).on('click', '#validateGiftCard', function () {
    if (hasBeenInactive) {
      showClearCartConfirmation();
      return;
    }
    const giftcardCode = $('#giftCardCode').val();
    if (!giftcardCode) return;

    const total_amount = $('#total-amount').attr('data-total-amount');

    $.ajax({
      type: 'POST',
      url: '/api/v1/gift-card/split-validation',
      data: {
        location_id: locationId,
        code: giftcardCode,
        total_amount,
      },
    })
      .done(function (data) {
        if (data.code === giftcardCode && data.html !== undefined) {
          $('#giftCardAmount').val(data.giftcard_discount);

          $('#payment-split-input')
            .val(data.giftcard_discount)
            .attr('data-remaining-credit-limit', data.giftcard_discount)
            .data('remaining-credit-limit', data.giftcard_discount);

          if ($('#giftcard-split-feedback').hasClass('d-none')) {
            $('#giftcard-split-feedback').removeClass('d-none');
          }
          $('#giftcard-split-feedback').html(data.html);

          if (data.warning_message) {
            $('#giftcard-split-error')
              .text(data.warning_message)
              .removeClass('d-none');
          } else {
            $('#giftcard-split-error').empty().addClass('d-none');
          }

          $('#payment-split-button').attr('disabled', false);
          $('#payment-split-input').attr('disabled', false);
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON &&
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
        if (
          data.responseJSON !== undefined &&
          data.responseJSON.error.message !== undefined &&
          data.responseJSON.error.message !== null
        ) {
          $('#giftcard-split-feedback').empty();
          if (!$('#giftcard-split-feedback').hasClass('d-none')) {
            $('#giftcard-split-feedback').addClass('d-none');
          }
          if ($('#giftcard-split-error').hasClass('d-none')) {
            $('#giftcard-split-error').removeClass('d-none');
          }
          $('#giftcard-split-error').text(data.responseJSON.error.message);
          $('#payment-split-button').attr('disabled', true);
          $('#payment-split-input').attr('disabled', true);
          $('#giftCardAmount').val('');
        }
      });
  });

  // =========================================================================
  // REMOVE LAST PURCHASED CONTAINER ON LOAD IF THERE IS NO LAST PURCHASED YET
  // =========================================================================
  if (localStorage.getItem('lastOrderTotal') === null) {
    $('.last-order-detail-container').remove();
  }
});

function addProductClickHandler() {
  if (hasBeenInactive) {
    showClearCartConfirmation();
    return;
  }

  const isInoiveOAddedToCart =
    locationCart.number_of_products > 0 &&
    'invoice_id' in locationCart.products[0];
  const isGiftcardAddedToCart =
    locationCart.number_of_products > 0 &&
    'gift_card_code' in locationCart.products[0];

  if (isGiftcardAddedToCart) {
    showToast({
      type: 'error',
      title: 'Vennligst tøm handlekurven først!',
      message: 'Gavekort er lagt til i handlekurv',
      position: 'bottom-left',
      duration: 5000,
    });
    return;
  }

  if (isInoiveOAddedToCart) {
    showToast({
      type: 'error',
      title: 'Vennligst tøm handlekurven først!',
      message: 'Fakturabetaling er lagt til i handlekurv',
      position: 'bottom-left',
      duration: 5000,
    });
    return;
  }

  const productContainer = $(this).closest('.shop-product-container');
  const openPriceProduct = productContainer.attr('data-is-open-price') == 1;
  let isForceProductExterBox =
    productContainer.attr('data-force-extra-box') == 1 ? true : false;

  // Open price is a sales concept - wastage only records the quantity written off
  if (
    openPriceProduct &&
    !wastageMode &&
    !($(this).attr('data-has-product-extra') == 1 && isForceProductExterBox)
  ) {
    showOpenPriceProductModal($(this));
    return;
  }

  let productType = productContainer.attr('data-product-type');
  let isWeightProduct = productContainer.attr('data-is-weight-product') == 1;
  let productId = parseInt($(this).attr('data-product-id'));
  locationCart.order_storage_ids = [];
  orderStorageIds = null;

  if (isWeightProduct) {
    getWeigthProductModal(productId);
  } else if (
    $(this).attr('data-has-product-extra') == 1 &&
    $(this).attr('data-force-product-extra-popup') == 1 &&
    isForceProductExterBox
  ) {
    if (!$('#product-extra-modal').length) {
      getClassicProductExtraModal(productId);
    }
    if (productType === 'suggested') {
      setTimeout(() => {
        $('#add-to-cart-button').attr('data-product-type', productType);
      }, 300);
    }

    return false;
  } else {
    if (!$(this).siblings('span').hasClass('d-none')) {
      $(this).siblings('span').addClass('d-none');
    }
    if ($(this).siblings('.remove-product').hasClass('d-none')) {
      $(this).siblings('.remove-product').removeClass('d-none');
    }
    if ($(this).siblings('input.product-to-order').hasClass('d-none')) {
      $(this).siblings('input.product-to-order').removeClass('d-none');
    }

    let productIndex = locationCart.products.findIndex(
      (obj) =>
        obj.product_id == productId &&
        ((obj.is_takeaway == undefined && !locationCart.is_takeaway_checked) ||
          (obj.is_takeaway == 1 && locationCart.is_takeaway_checked)) &&
        !productContainer.attr('data-is-open-price')?.length &&
        parseFloat(obj.discount_percent) == 0 &&
        !obj.product_table_id &&
        !obj.product_table_split_id
    );

    if (!locationCart.number_of_products) {
      locationCart.order_discount_percent = 0;
    }

    let productAmount;
    let priceInclVat = parseFloat($(this).attr('data-price-incl-vat'));
    alterPriceInclVatForCheck = parseFloat(
      $(this).attr('data-alter-price-incl-vat')
    );
    let alterPriceInclVat =
      parseFloat($(this).attr('data-alter-price-incl-vat')) == 0
        ? priceInclVat
        : parseFloat($(this).attr('data-alter-price-incl-vat'));

    if (productIndex === -1) {
      productAmount = 1;
      let product = {
        product_id: productId,
        original_product_price: locationCart.is_takeaway_checked
          ? alterPriceInclVat
          : priceInclVat,
        amount: productAmount,
        discount_percent: locationCart.order_discount_percent || 0,
        discount_price: 0,
        is_open_price: productContainer.attr('data-is-open-price')?.length
          ? 1
          : 0,
      };

      if (locationCart.is_takeaway_checked) {
        product.is_takeaway = locationCart.is_takeaway_checked;
      }

      if (productContainer.attr('data-is-open-price')?.length) {
        productContainer.attr('data-is-open-price', 1);
      }
      locationCart.products.unshift(product);
      locationCart.amount =
        parseFloat(locationCart.amount) +
        priceInclVat * (1 - product.discount_percent / 100);
    } else {
      const priceInclDiscount =
        locationCart.products[productIndex].original_product_price;
      productAmount =
        parseFloat(locationCart.products[productIndex].amount) + 1;
      locationCart.products[productIndex].amount = productAmount;

      if (locationCart.products[productIndex].amount_added_by_cart) {
        locationCart.products[productIndex].amount_added_by_cart =
          parseFloat(locationCart.products[productIndex].amount_added_by_cart) +
          1;
      } else {
        locationCart.products[productIndex].amount_added_by_cart = 1;
      }

      locationCart.amount =
        parseFloat(locationCart.amount) +
        priceInclDiscount *
          (1 - locationCart.products[productIndex].discount_percent / 100);
    }

    locationCart.amount_without_discount = floor(
      locationCart.products.reduce(
        (total, product) =>
          total +
          parseFloat(
            (product.amount * product.original_product_price).toFixed(2)
          ),
        0
      )
    );

    locationCart.number_of_products =
      parseInt(locationCart.number_of_products) + 1;
    updateCartSummary();
    updateCartProducts();
    $('input#product-id-' + productId).val(productAmount);
    if (productType == 'suggested') {
      productContainer.remove();
      adjustClassicProductsHeight();
      if ($('#suggested-product div').length === 0) {
        $('.suggested-product-list-container').attr('hidden', true);
        $('#remove-suggested-product-container').attr('hidden', true);
      }
    }
  }
}

function getClassicProductExtraModal(
  productId,
  discountPrice = 0,
  discountPercent = 0,
  update = 0,
  productIndex = null,
  comment = '',
  productExtra = [''],
  productQuantity = 1,
  productInCart = null
) {
  if ($('#product-extra-modal').length) {
    return;
  }

  //Dimiss SubProductCategoryMdal
  if ($('#pos-sub-product-category-product-modal').length) {
    $('#pos-sub-product-category-product-modal').remove();
  }
  $('.modal-backdrop').remove();
  $('body').removeClass('modal-open');
  $('body').css('padding-right', '');
  //End of Dimiss SubProductCategoryMdal

  if ($('#product-extra-modal').length) {
    $('#product-extra-modal').remove();
  }

  let data = {
    location_id: locationId,
    product_id: productId,
    location_type: locationCart.location_type,
    product_extra: productExtra,
    update: update,
    comment: comment,
    discount_price: discountPrice,
    discount_percent: discountPercent,
    product_quantity: productQuantity,
    shop_type: p === 'events_self_service' ? 'self_service' : 'pos',
    product_in_cart: productInCart,
    is_takeaway_checked: locationCart.is_takeaway_checked ?? 0,
  };
  if (productIndex !== null) {
    data.cart_index = productIndex;
  }
  if (locationCart.promo_code != '') {
    data.promo_code = locationCart.promo_code;
  }

  if (!getExtraModalAjaxLock) {
    getExtraModalAjaxLock = true;
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/order/get-product-extra',
      data: data,
    })
      .done(function (data) {
        if (data.html !== undefined && data.html !== null) {
          $('body').after(data.html);
          $('#product-extra-modal').modal('show');
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON &&
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      })
      .always(function () {
        getExtraModalAjaxLock = false;
      });
  }
}

function resetInactivityTimer() {
  const rawTimeout = Number(
    $('#classic-location-products').data('inactivity-timeout')
  );
  const timeoutSeconds = rawTimeout === 120 ? 120 : 0;

  if (timeoutSeconds === 0) {
    clearTimeout(inactivityTimer);
    inactivityTimer = null;
    return;
  }

  clearTimeout(inactivityTimer);

  inactivityTimer = setTimeout(function () {
    if (locationCart.products.length === 0) {
      resetInactivityTimer();
      return;
    }

    hasBeenInactive = true;
  }, timeoutSeconds * 1000);
}

function showClearCartConfirmation() {
  $('#clearing-cart-modal').modal('show');

  clearTimeout(confirmTimer);
  confirmTimer = setTimeout(function () {
    clearCartAndCleanup();
  }, 7000);
}

function clearCartAndCleanup() {
  clearTimeout(confirmTimer);

  emptyAllCart();

  $('#clearing-cart-modal').modal('hide');
  $('#cart-modal').modal('hide');
  $('#empty-cart-modal').modal('hide');
  $('.modal-backdrop').remove();
  hasBeenInactive = false;
  resetInactivityTimer();
}

$('#clearing-cart-confirm').on('click', function () {
  clearTimeout(confirmTimer);
  hasBeenInactive = false;
  $('#clearing-cart-modal').modal('hide');
  resetInactivityTimer();
});

function setLastOrderDetails() {
  if (wastageMode) {
    $('.last-order-detail').addClass('d-none');
    return;
  }

  if (
    localStorage.getItem('lastOrderTotal') &&
    localStorage.getItem('lastOrderProducts')
  ) {
    const lastOrderTotal = localStorage.getItem('lastOrderTotal');
    const lastOrderProducts = JSON.parse(
      localStorage.getItem('lastOrderProducts')
    );
    let orderDetailString = `Siste handel:<strong>${lastOrderTotal} kr</strong>`;
    lastOrderProducts.forEach((product) => {
      orderDetailString += `, ${product}`;
    });
    $('.last-order-detail').html(orderDetailString);
    $('.last-order-detail').removeClass('d-none');
  } else {
    if (!$('.last-order-detail').hasClass('d-none')) {
      $('.last-order-detail').addClass('d-none');
    }
  }
}

$(document).on('click', '.process-expand-button', function () {
  if ($(this).hasClass('expanded')) {
    $('.expand-btn-icon').removeClass('d-none');
    $('.minimize-btn-icon').addClass('d-none');
  } else {
    $('.expand-btn-icon').addClass('d-none');
    $('.minimize-btn-icon').removeClass('d-none');
  }

  $(this).toggleClass('expanded');
});

//terminal cancel process
$(document).on('click', '.cancel-btn', function () {
  const message = $(this).attr('data-cancel-terminal-message');
  const terminalNumber = $(this).attr('data-terminal-number');
  const shouldProceed = confirm(message + terminalNumber + '?');

  if (shouldProceed) {
    const terminal_id = $(this).data('terminal-id');
    const orderCard = $(".order-card[id='" + terminal_id + "']");
    //set the terminal number
    orderCard.find('.terminal-number').text(terminalNumber);
    //change the loading status
    const statusBadge = orderCard.find('.status-badge');
    statusBadge.addClass('processing text-primary');
    statusBadge.html(
      `Avbryter <div class="spinner-border spinner-border-sm text-primary ml-2" role="status"><span class="sr-only">Loading...</span></div>`
    );
    // 1. Abort ongoing order creation if it exists (when we cancelling the trasaction/payment metod,need to abort the order creation)
    //currentOrderAjax.readyState !== 4 means "the AJAX request is not yet complete."
    if (currentOrderAjax && currentOrderAjax.readyState !== 4) {
      currentOrderAjax.abort();
      currentOrderAjax = null;
    }

    $('div.loader').remove();
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/order/cancel-terminal-payment',
      data: {
        terminal_id: terminal_id,
        location_id: $('#location-id').val() || null,
      },
    })
      .done(function (data) {
        if (data && data.success == true) {
          // Successfully cancelled
          updateOrderProcessStatus(terminal_id, 'failed');
        } else if (data && data.error) {
          alert(data.error);
        } else {
          alert('Unknown error occurred while cancelling terminal payment.');
        }
        return;
      })
      .fail(function (jqXHR) {
        if (
          jqXHR.responseJSON.redirect_url !== undefined &&
          jqXHR.responseJSON.redirect_url !== null
        ) {
          document.location.href = jqXHR.responseJSON.redirect_url;
        }

        let errorMsg =
          'Failed to cancel the terminal payment. Please try again later.';
        if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
          errorMsg = jqXHR.responseJSON.error;
        }
        alert(errorMsg);
      });
  }
});

$(document).on('click', '.show-order', function () {
  const terminal_id = $(this).data('terminal-id');
  $.ajax({
    type: 'POST',
    url: '/api/v1/private/order/get-terminal-product-list',
    data: {
      terminal_id,
    },
  })
    .done(function (data) {
      if (data.html !== undefined && data.html !== null) {
        $('#content').append(data.html);
        $('#terminalProductListModal').modal('show');
      } else {
        alert('No order details found for this terminal.');
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON &&
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
      alert('Failed to fetch order details. Please try again later.');
    });
});

$(document).on('click', '#retry-payment-button', function () {
  const failedTerminalId = $(this).data('terminal-id');
  const paymentSelectValue = $('#payment-method-select').val();
  const exchangeAmount =
    Number($(this).attr('data-exchange-amount').replace(',', '.')) || 0;

  //If user didn't select any payment method
  if (!paymentSelectValue) {
    alert('Velg en betalingsmetode for å fortsette!');
    return;
  }
  const splitPart = paymentSelectValue.split('payment_terminal-');
  let terminal_id = null;
  let payment_method = null;
  let terminal_number = null;

  if (splitPart.length > 1) {
    terminal_id = splitPart[1];
    if (terminal_id != failedTerminalId) {
      payment_method = 'payment_terminal';
      terminal_number = $('#payment-method-select option:selected').text();

      const wrapper = $('#process-orders-with-terminal-payments');
      if (wrapper.hasClass('d-none')) {
        wrapper.removeClass('d-none');
        wrapper.addClass('d-flex');
      }
      const clonedOrderCard = $('.order-card.clone').clone();
      clonedOrderCard.removeClass('clone d-none');
      clonedOrderCard.addClass('processing');
      clonedOrderCard.attr('id', terminal_id);
      clonedOrderCard
        .find('.terminal-number')
        .text($('#payment-method-select option:selected').text());
      const statusBadge = clonedOrderCard.find('.status-badge');
      statusBadge.addClass('processing text-primary');
      statusBadge.html(
        `Behandling <div class="spinner-border spinner-border-sm text-primary ml-2" role="status"><span class="sr-only">Loading...</span></div>`
      );
      clonedOrderCard
        .find('.order-items')
        .text($('#' + failedTerminalId + ' .order-items').text());

      const retryButton = clonedOrderCard.find('.retry-btn');
      retryButton.addClass('retry-btn-' + terminal_id);
      retryButton.attr('disabled', true);
      retryButton.attr('data-terminal-id', terminal_id);

      const showOrderButton = clonedOrderCard.find('.show-order');
      showOrderButton.addClass('show-order-' + terminal_id);
      showOrderButton.attr('data-terminal-id', terminal_id);

      const cancelProcessButton = clonedOrderCard.find(
        '.cancel-payment-process'
      );
      cancelProcessButton.attr(
        'data-terminal-number',
        $('#payment-method-select option:selected').text()
      );
      cancelProcessButton.attr('data-terminal-id', terminal_id);
      cancelProcessButton.addClass('disabled');
      cancelProcessButton.attr('disabled');

      if (!$('#' + terminal_id).length) {
        $('#processing-orders').append(clonedOrderCard.clone());

        if (
          typeof window.terminalTimeouts !== 'undefined' &&
          window.terminalTimeouts[terminal_id]
        ) {
          clearTimeout(window.terminalTimeouts[terminal_id].cancelTimeout);
          clearTimeout(window.terminalTimeouts[terminal_id].enableTimeout);
          delete window.terminalTimeouts[terminal_id];
        }
      }
      removeOrderProcessStatus(failedTerminalId);
    } else {
      payment_method = 'payment_terminal';
      terminal_number = $('#payment-method-select option:selected').text();
      updateOrderProcessStatus(failedTerminalId, 'processing');
    }
  } else {
    payment_method = paymentSelectValue;
  }

  $('#retry-payment-modal').modal('hide');
  setTimeout(() => {
    $('#retry-payment-modal').remove();
  }, 1000);

  if (payment_method === 'payment_terminal' && terminal_id) {
    if (
      typeof window.terminalTimeouts !== 'undefined' &&
      window.terminalTimeouts[terminal_id]
    ) {
      clearTimeout(window.terminalTimeouts[terminal_id].cancelTimeout);
      clearTimeout(window.terminalTimeouts[terminal_id].enableTimeout);
      delete window.terminalTimeouts[terminal_id];
    }
  }

  $.ajax({
    type: 'POST',
    url: '/api/v1/private/order/new',
    data: {
      terminal_id,
      payment_method,
      failed_terminal_id: failedTerminalId,
      terminal_number,
      location_id: locationId,
    },
    timeout: 240000,
  })
    .done(function (data) {
      fetchDataAndSend();
      if (
        data.payment_redirect_url !== undefined &&
        data.payment_redirect_url !== null
      ) {
        document.location.href = data.payment_redirect_url;
        return;
      }

      if (
        data.confirmation_code !== undefined &&
        data.confirmation_code !== null
      ) {
        const orderHtml =
          data.order_html !== undefined && data.order_html !== null
            ? data.order_html
            : '';
        $('.modal-backdrop').remove();

        removeOrderProcessStatus(terminal_id);
        removeOrderProcessStatus(failedTerminalId);

        if (exchangeAmount <= 0) {
          const $confirmationStyle = $('#classic-location-products').data(
            'order-confirmation-toast-style'
          );
          $('.confirmation-toast').remove();
          if (orderHtml) {
            $('.confirmation-toast').remove();
            $('#content').append(
              '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                (window.innerWidth >= 500 ? ' right: 0;' : '') +
                ' width: 480px; display: none;">' +
                '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                ($confirmationStyle == 'compact' ? 'false' : 'true') +
                '" data-delay="' +
                ($confirmationStyle === 'compact' ? 100000 : 3000) +
                '">' +
                '  <div class="toast-header">' +
                '    <strong class="mr-auto">Ordre registrert</strong>' +
                '    <small></small>' +
                '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                '      <span aria-hidden="true">&times;</span>' +
                '    </button>' +
                '  </div>' +
                '  <div class="toast-body">' +
                orderHtml +
                '  </div>' +
                '</div>' +
                '</div>'
            );
          }

          if (
            data.item_count &&
            data.total_amount &&
            $confirmationStyle === 'compact'
          ) {
            showPreviousSaleBar(data.item_count, data.total_amount);
          } else {
            $('.confirmation-toast').css({ padding: '1rem' }).show();
            $('.confirmation-toast-box')
              .toast('show')
              .on('hidden.bs.toast', function () {
                $('.confirmation-toast').attr('style', function (i, s) {
                  return (s || '') + 'padding: 0px !important;';
                });
              });
          }
        }

        if (locationCart.products.length <= 0) {
          showOrderSuccessCheckmark();
        }
      }

      if (
        data.table_session_id &&
        $('#table-session-details-modal.show').length > 0 &&
        $('#table-session-details-modal').attr('data-table-session-id') ==
          data.table_session_id &&
        $('#btnSyncState').hasClass('d-none')
      ) {
        $('#btnSyncState').removeClass('d-none').addClass('d-flex');
      }

      if (data.is_paid !== undefined && data.is_paid !== null) {
        removeOrderProcessStatus(failedTerminalId);

        if (
          data.table_id &&
          $('#split-payment-cart-modal.show').length > 0 &&
          $('#split-payment-cart-modal').attr('data-table-id') ==
            data.table_id &&
          $('#refresh-table-details').hasClass('d-none')
        ) {
          locationCart.table_number = data.table_id;
          $('#refresh-table-details').removeClass('d-none');
        }
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON &&
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }

      if (
        data.responseText !== undefined &&
        data.responseText.error_message !== undefined &&
        data.responseText.error_message !== null
      ) {
        errorPopupAlert(data.responseText.error_message);
      } else {
        errorPopupAlert(
          'Noe gikk galt under bestilling. Vennligst prøv igjen.'
        );
      }
      updateOrderProcessStatus(terminal_id, 'failed');
    });
});

$(document).on('click', '.retry-btn', function () {
  const terminal_id = $(this).data('terminal-id');
  const type = $(this).data('terminal-type') || '';
  const exchangeAmount = $(this).data('exchange-amount') || 0;

  if (type === 'verifone') {
    const payload = localStorage.getItem(`vt_${terminal_id}`);
    if (
      payload &&
      window.globalSocket &&
      window.globalSocket.readyState === WebSocket.OPEN &&
      payload !== '' &&
      payload !== 'null' &&
      payload !== 'undefined'
    ) {
      updateOrderProcessStatus(terminal_id);
      window.globalSocket.send(payload);
    }
  } else {
    getRetryPaymentModal({
      terminal_id,
      location_id: $('#location-id').val(),
      exchange_amount: exchangeAmount,
    });
  }
});

function getStoredPaymentData(terminalId) {
  const { locationCart: locationCartData, paymentData } = JSON.parse(
    localStorage.getItem(`vt_${terminalId}`) || '{}'
  );

  let tableGuestId = null;
  let tableSessionId = null;
  if (paymentData && paymentData.data && paymentData.data.data.orderParams) {
    tableGuestId = paymentData.data.data.orderParams.table_guest_id || null;
    tableSessionId = paymentData.data.data.orderParams.table_session_id || null;
  }

  localStorage.removeItem(`vt_${terminalId}`);

  return { locationCartData, tableGuestId, tableSessionId };
}

$(document).on('click', '#actionTryOtherMethod', function () {
  const terminalId = $('#payment-process-delete-modal').attr(
    'data-terminal-id'
  );
  const { locationCartData, tableGuestId, tableSessionId } =
    getStoredPaymentData(terminalId);

  cancelPaymentProcess(terminalId, tableSessionId, tableGuestId).always(
    function () {
      setClassicLocationCart(locationCartData).always(function () {
        $('#payment-process-delete-modal')
          .removeAttr('data-terminal-id')
          .modal('hide');
      });
    }
  );
});

$(document).on('click', '#actionDeleteProcess', function () {
  const terminalId = $('#payment-process-delete-modal').attr(
    'data-terminal-id'
  );
  const { tableGuestId, tableSessionId } = getStoredPaymentData(terminalId);

  $('#payment-process-delete-modal')
    .removeAttr('data-terminal-id')
    .modal('hide');

  cancelPaymentProcess(terminalId, tableSessionId, tableGuestId);
});

$(document).on(
  'click',
  '.cancel-payment-process',
  function (event, skipConfirm) {
    const messge = $(this).attr('data-cancel-process-message');
    const terminalNumber = $(this).attr('data-terminal-number');
    const type = $(this).attr('data-terminal-type') || '';
    const terminalId = $(this).attr('data-terminal-id');
    const shouldProceed =
      skipConfirm ||
      type === 'verifone' ||
      confirm(messge + terminalNumber + '?');
    let tableGuestId = null;
    let tableSessionId = null;

    if (type === 'verifone') {
      $('#payment-process-delete-modal')
        .attr('data-terminal-id', terminalId)
        .modal('show');
      return;
    }

    if (shouldProceed) {
      cancelPaymentProcess(terminalId, tableSessionId, tableGuestId);
    }
  }
);

function cancelPaymentProcess(
  terminalId,
  tableSessionId = null,
  tableGuestId = null
) {
  return $.ajax({
    type: 'POST',
    url: '/api/v1/private/order/cancel-payment-process',
    data: {
      terminal_id: terminalId,
      table_session_id: tableSessionId,
      table_guest_id: tableGuestId,
    },
    timeout: 240000,
  })
    .done(function (data) {
      removeOrderProcessStatus(terminalId);
      if (
        data.tableSessionId &&
        $('#table-session-details-modal.show').length > 0 &&
        $('#table-session-details-modal').attr('data-table-session-id') ==
          data.tableSessionId &&
        $('#btnSyncState').hasClass('d-none')
      ) {
        let isShareByAmount = $('mode-tab[data-mode="sum"]').hasClass('active')
          ? 1
          : 0;

        if (!isShareByAmount) {
          $('#btnSyncState').removeClass('d-none').addClass('d-flex');
        }
      }

      if (
        typeof window.terminalTimeouts !== 'undefined' &&
        window.terminalTimeouts[terminalId]
      ) {
        clearTimeout(window.terminalTimeouts[terminalId].cancelTimeout);
        clearTimeout(window.terminalTimeouts[terminalId].enableTimeout);
        delete window.terminalTimeouts[terminalId];
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON &&
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
      errorPopupAlert(data.responseJSON.errors, 3000);
    })
    .always(function () {
      if (
        $(
          '#payment-process-delete-modal[data-terminal-id="' + terminalId + '"]'
        ).length
      ) {
        $('#payment-process-delete-modal')
          .removeAttr('data-terminal-id')
          .modal('hide');
      }
    });
}

function removeOrderProcessStatus(terminalId) {
  // const orderCard = $("#" + terminalId); // this selector only work on speicific device
  const orderCard = $(".order-card[id='" + terminalId + "']");
  if (orderCard.length) {
    orderCard.remove();
    if ($('#processing-orders').children().not('.d-none').length === 0) {
      $('#process-orders-with-terminal-payments').removeClass('d-flex');
      $('#process-orders-with-terminal-payments').addClass('d-none');
    }
  }

  if (locationCart.number_of_products > 0 || locationCart.table_number) {
    $(".order-button[data-terminal-id='" + terminalId + "']").prop(
      'disabled',
      false
    );
    $(".quick-order-button[data-terminal-id='" + terminalId + "']").prop(
      'disabled',
      false
    );
    $(".quick-order-button[data-terminal-id='" + terminalId + "']").removeAttr(
      'title'
    );
  } else {
    $(".order-button[data-terminal-id='" + terminalId + "']").attr(
      'title',
      'Legg produkter i Checkout først'
    );
  }
}

function updateOrderProcessStatus(terminalId, status) {
  const orderCard = $(".order-card[id='" + terminalId + "']");
  if (orderCard.length) {
    const statusBadge = orderCard.find('.status-badge');
    if (status === 'failed') {
      if (
        typeof window.terminalTimeouts !== 'undefined' &&
        window.terminalTimeouts[terminalId]
      ) {
        clearTimeout(window.terminalTimeouts[terminalId].cancelTimeout);
        clearTimeout(window.terminalTimeouts[terminalId].enableTimeout);
        delete window.terminalTimeouts[terminalId];
      }

      statusBadge.removeClass('processing text-primary');
      statusBadge.addClass(status);
      statusBadge.text('Mislyktes');
      orderCard.removeClass('processing');
      orderCard.addClass('failed');

      const $retryButton = $(
        ".retry-btn[data-terminal-id='" + terminalId + "']"
      );
      if ($retryButton.length) {
        $retryButton.removeAttr('disabled');
      }

      const $cancelButton = $(
        ".cancel-btn[data-terminal-id='" + terminalId + "']"
      );

      if ($cancelButton.length) {
        $cancelButton
          .prop('disabled', true)
          .css({
            cursor: 'not-allowed',
            'pointer-events': 'none',
          })
          .find('svg')
          .attr('stroke', '#ccc'); // make icon look disabled
      }
      const $button = $(
        ".cancel-payment-process[data-terminal-id='" + terminalId + "']"
      );
      if ($button.length) {
        $button.removeClass('disabled');
        $button.removeAttr('disabled');
      }

      if (typeof window.terminalTimeouts === 'undefined') {
        window.terminalTimeouts = {};
      }

      // Set new timeouts for this terminal
      const cancelTimeout = setTimeout(() => {
        $(
          ".cancel-payment-process[data-terminal-id='" + terminalId + "']"
        ).trigger('click', [true]);

        if (
          typeof window.terminalTimeouts !== 'undefined' &&
          window.terminalTimeouts[terminalId]
        ) {
          delete window.terminalTimeouts[terminalId];
        }
      }, 60000);

      const enableTimeout = setTimeout(() => {
        if (locationCart.number_of_products > 0 || locationCart.table_number) {
          $(".quick-order-button[data-terminal-id='" + terminalId + "']").prop(
            'disabled',
            false
          );
          $(
            ".quick-order-button[data-terminal-id='" + terminalId + "']"
          ).removeAttr('title');
        }

        if (
          typeof window.terminalTimeouts !== 'undefined' &&
          window.terminalTimeouts[terminalId]
        ) {
          delete window.terminalTimeouts[terminalId];
        }
      }, 60000);

      // Store timeout references
      window.terminalTimeouts[terminalId] = {
        cancelTimeout: cancelTimeout,
        enableTimeout: enableTimeout,
      };
    } else {
      // Clear existing timeout for this terminal if it exists
      if (
        typeof window.terminalTimeouts !== 'undefined' &&
        window.terminalTimeouts[terminalId]
      ) {
        clearTimeout(window.terminalTimeouts[terminalId].cancelTimeout);
        clearTimeout(window.terminalTimeouts[terminalId].enableTimeout);
        delete window.terminalTimeouts[terminalId];
      }

      statusBadge.removeClass('failed');
      statusBadge.addClass('processing text-primary');
      statusBadge.html(
        `Behandling <div class="spinner-border spinner-border-sm text-primary ml-2" role="status"><span class="sr-only">Loading...</span></div>`
      );
      orderCard.removeClass('failed');
      orderCard.addClass('processing');

      if ($('.retry-btn-' + terminalId).length) {
        $('.retry-btn-' + terminalId).attr('disabled', true);
      }

      if ($('.cancel-btn-' + terminalId).length) {
        $('.cancel-btn-' + terminalId)
          .attr('disabled', false)
          .css({
            cursor: 'pointer',
            'pointer-events': 'auto',
          })
          .find('svg')
          .attr('stroke', 'black');
      }

      const $button = $(
        ".cancel-payment-process[data-terminal-id='" + terminalId + "']"
      );
      if ($button.length) {
        $button.addClass('disabled');
        $button.attr('disabled');
      }
    }
  }
}

$(document).on('input', '.payment-split-input', function () {
  const input = $(this);
  const value = parseFloat(input.val().replace(',', '.')) || 0;

  const maxAllowedValue = parseFloat(input.attr('data-max-allowed'));
  const remainingCreditLimit =
    input.data('remaining-credit-limit') !== undefined
      ? parseFloat(input.data('remaining-credit-limit'))
      : null;
  const feedback = input.closest('.split-method').find('.invalid-feedback');
  const button = input.closest('.split-method').find('.order-payment-split');

  feedback.find('#max-value').text(maxAllowedValue);

  const paymentSplitInputs = $('.payment-split-input').not(input);
  const totalPaid = paymentSplitInputs.toArray().reduce((acc, el) => {
    return acc + (parseFloat($(el).val()) || 0);
  }, 0);

  let remainingValue = (maxAllowedValue * 100 - value * 100) / 100;
  let isInvalid = false;
  let errorMessage = '';

  if (value > maxAllowedValue) {
    isInvalid = true;
    errorMessage =
      'Verdien kan ikke overstige den totale mengden av ' +
      formattedPriceToShow(maxAllowedValue) +
      ' kr';
  } else if (remainingCreditLimit !== null && value > remainingCreditLimit) {
    isInvalid = true;
    errorMessage =
      'Verdien har overskredet den totale nødvendige mengden på ' +
      remainingCreditLimit +
      ' kr';
  }

  if (remainingValue > 0 && remainingValue < 1) {
    isInvalid = true;
    errorMessage = 'Resterende beløp kan ikke være mindre enn 1 kr.';
  }

  if (isInvalid) {
    feedback.removeClass('d-none');
    input.addClass('is-invalid');
    input.focus();
    feedback.find('small').text(errorMessage);
    button.prop('disabled', true);
  } else {
    feedback.addClass('d-none');
    input.removeClass('is-invalid');
    button.prop('disabled', false);
  }
});

function getPaymentSplitModal(
  data,
  container = '#event-public-list-organizer'
) {
  if (!paymentSplitModalAjaxLock) {
    paymentSplitModalAjaxLock = true;

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/order/get-payment-split-modal',
      data: data,
    })
      .done(function (data) {
        if (data.html !== undefined && data.html !== null) {
          if ($('#product-extra-modal').length) {
            $('#product-extra-modal').remove();
          }
          if ($('#cart-modal').length) {
            $('#cart-modal').remove();
          }
          if ($('#payment-split-modal').length) {
            $('#payment-split-modal').remove();
          }

          $('body').after(data.html);

          if ($('#payment-split-modal').length) {
            const remainingAmount = parseFloat(
              $('#total-amount').attr('data-total-amount')
            );
            if (remainingAmount <= 0) {
              removeQueryParams('order');
              locationCart.order_id = null;
              localStorage.removeItem('location-cart');
              $('#payment-split-modal').remove();
              return;
            }

            if ($('body').attr('is-verifone-session-started') == '1') {
              $(
                ".payment-split-input[data-payment-method='payment_verifone_terminal']"
              ).prop('disabled', false);
              $(
                ".order-payment-split[data-payment-method='payment_verifone_terminal']"
              ).prop('disabled', false);
            }

            $('#split-methods-select').select2({
              theme: 'bootstrap4',
              dropdownParent: $('#payment-split-modal'),
              minimumResultsForSearch: Infinity,
            });

            const paymentMethod = $('#split-methods-select').val();
            if (paymentMethod == 'payment_giftcard') {
              $('#split-method-giftcard-validator-container').removeClass(
                'd-none'
              );
              $('#payment-split-button').attr('disabled', true);
              $('#payment-split-input').attr('disabled', true);
              $('#payment-split-input').val('');
            } else if (paymentMethod == 'payment_verifone_terminal') {
              $('#payment-split-button').prop(
                'disabled',
                $('body').attr('is-verifone-session-started') == '1'
                  ? false
                  : true
              );
            } else if (paymentMethod == 'payment_terminal') {
              $('#payment-split-button').attr(
                'data-terminal-id',
                $('#split-methods-select option:selected').attr(
                  'data-terminal-id'
                )
              );
            }

            $('#payment-split-input').attr(
              'data-payment-method',
              paymentMethod
            );
            $('#payment-split-button').attr(
              'data-payment-method',
              paymentMethod
            );

            $('#payment-split-modal').modal('show');
          }
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON &&
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      })
      .always(function () {
        paymentSplitModalAjaxLock = false;
      });
  }
}

function adjustClassicProductsHeight() {
  var viewportHeight = $(window).height();
  const headerHeight = $('header').outerHeight() || 0;

  var suggestedHeaderHeight =
    $('#classic-product-category-nav').outerHeight() || 0;
  var suggestedNavHeight = $('.product-category-nav').outerHeight() || 0;
  //To work scrollable properly in category-tabcontent container if small-cart-container has products
  let smallCartContainerHeight = 0;
  if ($('.small-cart-container').hasClass('has-products')) {
    smallCartContainerHeight = $('.small-cart-container').outerHeight() || 0;
  } else {
    smallCartContainerHeight = 0;
  }
  var availableHeight =
    viewportHeight -
    suggestedHeaderHeight -
    suggestedNavHeight -
    headerHeight -
    smallCartContainerHeight;

  $('.category-tabcontent').css({
    'max-height': availableHeight + 'px',
    'padding-bottom': '4rem',
    // "overflow-y": "auto", // Ensure scrollable
    // "overflow-x": "hidden"
  });

  applyFlexboxCartLayout();
}

function applyFlexboxCartLayout() {
  const $checkoutBody = $('.checkout-body');
  const $cartContainer = $('.cart-products-container');
  const $orderDetails = $('.order-details');
  const $checkoutHeader = $('.checkout-header');
  const $actionsContainer = $('.checkout-actions-container');

  if (
    !$checkoutBody.length ||
    !$cartContainer.length ||
    !$orderDetails.length
  ) {
    return;
  }

  // Setup main flexbox container
  $checkoutBody.css({
    display: 'flex',
    'flex-direction': 'column',
    height: '100%',
  });

  $checkoutHeader.css({
    'flex-shrink': '0',
  });

  $cartContainer.css({
    flex: '1 1 auto',
    'overflow-y': 'auto',
    'min-height': '0',
  });

  if ($actionsContainer.length) {
    const actionButtonCount = $actionsContainer.find('.checkout-action').length;
    const viewportHeight = $(window).height();
    const viewportWidth = $(window).width();
    const $checkoutSummary = $('.checkout-summary');

    const isTabletScreen =
      viewportWidth >= 768 && viewportWidth <= 1024 && viewportHeight >= 1000;
    const isDesktopScreen = viewportWidth > 1024;

    if (isTabletScreen) {
      $orderDetails.css({
        'margin-top': 'auto',
        'flex-shrink': '0',
      });
    } else if (isDesktopScreen) {
      $orderDetails.css({
        'margin-top': 'auto',
        'flex-shrink': '0',
      });
    } else {
      $orderDetails.css({
        'margin-top': 'auto',
        'flex-shrink': '0',
      });
    }

    $orderDetails.addClass('payment-buttons-bottom').css({
      display: 'flex',
      'flex-direction': 'column',
      'justify-content': 'flex-start',
    });

    if (actionButtonCount > 8 || viewportHeight < 700 || isTabletScreen) {
      $orderDetails.css({
        'overflow-y': 'auto',
        // Remove static min/max heights to prevent white space issues
        // "min-height": "200px", // REMOVED - causes static height issues
        // "max-height": "60vh", // REMOVED - causes static height issues
      });
    } else if (isDesktopScreen) {
      $orderDetails.css({
        'overflow-y': 'auto',
      });
    } else {
      $orderDetails.css({
        'overflow-y': 'auto',
        // Remove static min/max heights to prevent white space issues
        // "min-height": "150px", // REMOVED - causes static height issues
        // "max-height": "50vh", // REMOVED - causes static height issues
      });
    }

    if ($checkoutSummary.length) {
      $checkoutSummary.css({
        'margin-top': '0',
        'flex-shrink': '0',
      });
    }

    $actionsContainer.css({
      'flex-shrink': '0',
      'align-self': 'flex-end',
    });

    // The actions container sits inside the register form, so the form has to
    // hold its height too - otherwise it shrinks and the button grid clips.
    // Selected by name because the id exists in both the desktop and the
    // mobile copy of the checkout.
    $('form[name="order_register_form"]').css('flex-shrink', '0');
  } else {
    $orderDetails.addClass('no-payment-buttons').css({
      'flex-shrink': '0',
      display: 'flex',
      'flex-direction': 'column',
    });
  }
}

$(document).on('click', '.alt_price_button', function (e) {
  if (!$(this).hasClass('active')) {
    locationCart.is_takeaway_checked = 1;
    locationCart.products = locationCart.products.map((product) => ({
      ...product,
      is_takeaway: 1,
    }));
    $(this).addClass('active');
    $('.checkout-header .header-container .label').text('Checkout (takeaway)');
  } else {
    locationCart.is_takeaway_checked = 0;
    $(this).removeClass('active');
    locationCart.products = locationCart.products.map(
      ({ is_takeaway, ...product }) => product
    );
    $('.checkout-header .header-container .label').text('Checkout');
  }
  updateCartProducts();
});

$(document).on('click', '.split-payment-modal-close-btn', function (e) {
  e.preventDefault();

  const paymentSplitInputs = $('.payment-split-input').toArray();
  // const totalPaid = paymentSplitInputs.reduce((acc, el) => {
  //   return acc + (parseFloat($(el).val()) || 0);
  // }, 0);

  let totalAmount = parseFloat(
    $('.payment-split-input').first().attr('data-max-allowed')
  );

  const remainingAmout = parseFloat(
    $('#total-amount').attr('data-total-amount')
  );
  const totalPaid = totalAmount - remainingAmout;

  if (!totalPaid || totalAmount - totalPaid == 0) {
    $('#payment-split-modal').modal('hide');
  } else {
    return;
  }
});

function getRetryPaymentModal(data) {
  $.ajax({
    type: 'POST',
    url: '/api/v1/private/order/get-retry-payment-modal',
    data: data,
  })
    .done(function (data) {
      if (data.html !== undefined && data.html !== null) {
        if ($('#product-extra-modal').length) {
          $('#product-extra-modal').remove();
        }
        if ($('#cart-modal').length) {
          $('#cart-modal').remove();
        }
        if ($('#payment-split-modal').length) {
          $('#payment-split-modal').remove();
        }

        if ($('#retry-payment-modal').length) {
          $('#retry-payment-modal').remove();
        }

        $('#content-body').append(data.html);

        if ($('#retry-payment-modal').length) {
          $('#retry-payment-modal')
            .on('shown.bs.modal', function () {
              fixBackdrops();
            })
            .modal('show');
        }
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON &&
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
}

$('#tripletex-payment-amount-input').on('input', function () {
  let value = parseFloat($(this).val());
  let max = parseFloat($(this).attr('max'));

  if (value > max) {
    $(this).val(max);
  }
});

$(document).on('click', '.tripletex-invoice-payment-button', function () {
  let invoiceId = $(this).attr('data-invoice-id');
  let productName = $(this).attr('data-product-name');
  let productPrice = $(this).attr('data-product-price');
  $('#tripletex-payment-amount-input').val(productPrice);
  $('#tripletex-payment-amount-input').attr('max', productPrice);
  $('#tripletex-payment-submit').attr('data-invoice-id', invoiceId);
  $('#tripletex-payment-submit').attr('data-product-name', productName);
  $('#tripletex-payment-submit').attr('data-product-price', productPrice);
  $('#tripletex-payment-amount-modal').modal('show');
});

$(document).on('click', '#tripletex-payment-submit', function () {
  let invoiceId = $(this).attr('data-invoice-id');
  let productName = $(this).attr('data-product-name');
  let productPrice = $('#tripletex-payment-amount-input').val();

  $('#tripletex-payment-amount-modal').modal('hide');
  addTripletexInvoiceToCart(invoiceId, productName, productPrice);
});

function addTripletexInvoiceToCart(invoiceId, productName, productPrice) {
  const product = {
    product_id: 'tripletex_invoice_' + invoiceId,
    amount: 1,
    discount_percent: 0,
    original_product_price: productPrice,
    name: productName,
    is_open_price: 1,
  };
  locationCart.products = [product];
  locationCart.amount = (locationCart.amount || 0) + productPrice;
  locationCart.amount_without_discount =
    (locationCart.amount_without_discount || 0) + productPrice;
  locationCart.number_of_products = (locationCart.number_of_products || 0) + 1;
  getClassicCartModal()
    .done(function (data) {
      if (data.cart_products) {
        locationCart.products = data.cart_products;
      }

      $('#tripleTaxInvoicesModal').modal('hide');
    })
    .always(function () {
      $('#tripleTaxInvoicesModal').modal('hide');
    });
}

function isPreventToPayInvoice(button) {
  if (locationCart.number_of_products > 0) {
    const product = locationCart.products[0];
    const paymentMethod =
      $(button).attr('data-payment-method') ?? locationCart.payment_method;
    if (
      product.invoice_id > 0 &&
      String(product.name || '')
        .toLowerCase()
        .includes('invoice') &&
      (paymentMethod === 'payment_credit' ||
        paymentMethod === 'payment_split' ||
        $(button).is('#show-giftcard-section'))
    ) {
      return true;
    } else {
      return false;
    }
  }
}
